// Build 20260912-353: retain panel selection during legacy control actions.
// Build 348: shared toolbar clearance and available panel height.
// Build 20260911-342: rich text ranges.
// Build 338: shared panel navigation and subtle anchors.
// Build 20260911-337: reversible raster-logo crop.
// Build 20260910-335: unified font library and separate upload action.
// Build 20260910-334: direct custom-font upload entry for every text owner.
// Build 20260910-333: rotate text, pill and persisted output together.
// Build 20260910-327: grouped original-colour brand variants.
(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  const params = new URLSearchParams(location.search);
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle) || params.get('smoof_ui') === 'off') return;
  if (window.__smoofModernUiShellBuild353) return;
  window.__smoofModernUiShellBuild353 = true;
  window.__smoofModernUiShellBuild350 = true;
  window.__smoofModernUiShellBuild349 = true;
  window.__smoofModernUiShellBuild348 = true;
  window.__smoofModernUiShellBuild347 = true;
  window.__smoofModernUiShellBuild346 = true;
  window.__smoofModernUiShellV45Build342 = true;
  window.__smoofModernUiShellV45 = true;
  window.__smoofModernUiShellV44 = true;
  window.__smoofModernUiShellV41 = true;
  window.__smoofModernUiShellV40 = true;
  window.__smoofModernUiShellV39 = true;
  window.__smoofModernUiShellV38 = true;
  window.__smoofModernUiShellV37 = true;
  window.__smoofModernUiShellV36 = true;
  window.__smoofModernUiShellV35 = true;
  window.__smoofModernUiShellV34 = true;
  window.__smoofModernUiShellV33 = true;
  window.__smoofModernUiShellV32 = true;
  window.__smoofModernUiShellV31 = true;
  window.__smoofModernUiShellV30 = true;
  window.__smoofModernUiShellV29 = true;
  window.__smoofModernUiShellV28 = true;
  window.__smoofModernUiShellV27 = true;
  window.__smoofModernUiShellV26 = true;
  window.__smoofModernUiShellV25 = true;
  window.__smoofModernUiShellV24 = true;
  window.__smoofModernUiShellV23 = true;
  window.__smoofModernUiShellV22 = true;
  window.__smoofModernUiShellV21 = true;
  window.__smoofModernUiShellV20 = true;
  window.__smoofModernUiShellV19 = true;

  const root = document.documentElement;
  root.dataset.smoofThemeUiRuntime = 'v2-64-panel-action-20260912-353';
  const profile = window.SmoofProductProfiles?.current || null;
  const backgroundLocked = profile?.editorPolicy?.backgroundLocked === true;
  const laserMonochromeActive = () => {
    const policyState = window.SmoofDotMePolicy?.isMonochromeActive?.();
    if (typeof policyState === 'boolean') return policyState;
    return profile?.editorPolicy?.forceMonochromeLaser === true &&
      window.SmoofProductVariant?.get?.()?.printProcess === 'laser';
  };
  const laserVectorLogoRequired = laserMonochromeActive;
  const mobile = window.matchMedia('(max-width: 749px)');
  const SELECT_EVENT = 'smoof:editor-select';
  let panelActionDepth = 0;
  let selectedId = '';
  let keyboardMove = false;
  const heldArrows = new Set();
  const heldPointers = new Set();
  let source = null;
  let commandbar = null;
  let commandbarHost = null;
  let commandbarFlowParent = null;
  let helpWasOpenOnPointerDown = false;
  let resetWasOpenOnPointerDown = false;
  let context = null;
  let layers = null;
  let layersOpen = false;
  let layersPage = 'list';
  let layersTransitionTimer = 0;
  let suppressSelectionRenderId = '';
  let suppressSelectionRenderUntil = 0;
  let addShortcutPointerHandledUntil = 0;
  let mobileCanvasPointer = null;
  let historyCurrent = null;
  let historyCurrentKey = '';
  let historyPast = [];
  let historyFuture = [];
  let historyTimer = 0;
  let historyBaselineTimer = 0;
  let historyRestoring = false;
  let fontPickerTarget = '';
  let fontPickerInitialFamily = '';
  let templateCategory = '';
  let pictogramPickerOpenFor = '';
  const pictogramPickerCategory = { left: 'arrows', right: 'arrows' };
  const pictogramCategoryScroll = Object.create(null);
  let templateCoachmark = null;
  let templateCoachmarkTimer = 0;
  let templateCoachmarkAcknowledged = false;
  const panelScrollCleanups = new WeakMap();
  const TEMPLATE_COACHMARK_KEY = 'smoof-template-coachmark-v1';
  const DESIGN_OPTION_ID = '3474d16c-f4b6-4517-8f74-f88c27e5c914';
  const PERSONALIZED_VALUE_ID = '29cd05e6-2ef9-4956-89ef-35326fccfd1c';
  const FONT_OPTION_ID = '052c068b-772b-4d04-af0d-56214e55cce3';
  const HISTORY_LIMIT = 40;
  const HISTORY_OPTION_IDS = [
    '052c068b-772b-4d04-af0d-56214e55cce3',
    '2375ec9f-695e-489a-ae63-4dc66fbcbb3f',
    '8cbb313f-ef10-40a4-a711-b894c8c15c2f',
    '1b10591e-29cb-455c-a22f-5d534a275702',
    '5f47cc89-1d8f-4089-9919-514d4d1d3640',
    '999ff02f-9bc5-4ddf-996d-98459628780d',
    'f9b38c60-cd0d-4740-94a4-5b235d7ab60c',
    'aa1edcda-2cc3-4d6f-affd-d2db797ab684',
    'c3b03f1a-c9a4-495e-b138-51bde4cfcbe8',
    'dace7c47-c686-47bc-8580-4444848e6190',
    'dcde59d1-5fef-4e99-8d22-30e2ec19197e',
    '331a45ae-bd3d-4b85-8c7f-a8cbf014b032',
    '1f69ffa6-f179-46de-8ee6-5a90ac70558f',
    '3d6f15f5-b6a7-44d8-8e66-d80fe15b7603',
    '45b6444d-2b8c-431d-9594-91a6ab688d18',
    'f0b04c23-daf0-420c-9572-6d05e339241e',
    '5e5d6fe5-7f13-4891-9903-9ad8949dbb95',
    '3f615f11-8440-41a9-af77-fe79452d77f1'
  ];

  function richSelectionRow(id) {
    const selection=window.SmoofRichText?.selectedStyle?.(id);
    if(!selection)return `<div data-smoof-ui-text-scope data-active="false"><div data-smoof-ui-scope-copy><span data-smoof-ui-scope-label>${t('Gesamter Text','Whole text')}</span><span data-smoof-ui-scope-hint>${t('Für einzelne Zeichen direkt im Text markieren.','Select characters in the text to format them.')}</span></div></div>`;
    return `<div data-smoof-ui-text-scope data-smoof-ui-rich-selection data-active="true"><div data-smoof-ui-scope-copy><span data-smoof-ui-scope-label>${t('Textauswahl','Text selection')}${selection.mixed?` · ${t('Gemischt','Mixed')}`:''}</span><strong data-smoof-ui-rich-preview title="${escapeHtml(selection.text)}">${escapeHtml(selection.text)}</strong></div><button type="button" data-smoof-ui-action="rich-clear" data-smoof-ui-scope-clear aria-label="${t('Auswahl aufheben und gesamten Text formatieren','Clear selection and format whole text')}">${t('Gesamter Text','Whole text')}<span aria-hidden="true">↗</span></button></div>`;
  }
  function textRotationRow(value) {
    return row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="text-rotation-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-text-rotation>${Math.round(Number(value) || 0)}°</span><button type="button" data-smoof-ui-action="text-rotation-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`);
  }

  function optionRoot(id) {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${id}"]`));
    return roots.find(candidate => candidate.offsetParent !== null) || roots[0] || null;
  }

  function cleanFontFamily(value) {
    return String(value || '')
      .replace(/["']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  function selectedGoogleFont() {
    const option = optionRoot(FONT_OPTION_ID);
    return cleanFontFamily(
      option?.querySelector('select')?.value ||
      option?.querySelector('input[type="hidden"]')?.value ||
      option?.querySelector('button[aria-haspopup="listbox"]')?.innerText ||
      ''
    );
  }

  function rawFontForItem(itemId) {
    const selectedFont=window.SmoofRichText?.selectedStyle?.(itemId)?.fontFamily;
    if(selectedFont)return selectedFont;
    if (/^custom-text-[1-3]$/.test(itemId)) {
      return window.SmoofCustomTextTools?.getState?.(itemId)?.fontFamily || selectedGoogleFont() || 'Roboto';
    }
    if (/^text-[0-2]$/.test(itemId)) {
      return window.SmoofTextTools?.getFont?.(Number(itemId.split('-')[1])) || selectedGoogleFont() || 'Roboto';
    }
    if (itemId === 'table-number') {
      return window.SmoofNumberHistory?.getFont?.() || selectedGoogleFont() || 'Roboto';
    }
    return selectedGoogleFont() || 'Roboto';
  }

  function fontForItem(itemId) {
    if(window.SmoofRichText?.selectedStyle?.(itemId)?.mixedFont)return t('Gemischt','Mixed');
    const family = rawFontForItem(itemId);
    return window.SmoofCustomFontRegistry?.labelFor?.(family) || family;
  }

  function customFontSelected(itemId) {
    return Boolean(
      window.SmoofCustomFontRegistry?.isCustomFamily?.(
        rawFontForItem(itemId)
      )
    );
  }

  function setNativeValue(input, value, commit = false) {
    if (!input) return false;
    const prototype = input instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : input instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor && descriptor.set) descriptor.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    if (commit) input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function personalizedDesignSelected() {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${DESIGN_OPTION_ID}"]`));
    const checked = roots
      .flatMap(option => Array.from(option.querySelectorAll('input[type="checkbox"], input[type="radio"]')))
      .find(input => input.checked);
    if (!checked) return false;
    if (checked.value === PERSONALIZED_VALUE_ID) return true;
    const label = checked.closest('label')?.textContent || checked.parentElement?.textContent || '';
    return /Personalisiertes Design|Personalized Design/i.test(label);
  }

  function captureOptionState(id) {
    const rootNode = optionRoot(id);
    if (!rootNode) return null;

    const choices = Array.from(rootNode.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
    if (choices.length) {
      return {
        kind: 'choice',
        values: choices.filter(input => input.checked).map(input => input.value)
      };
    }

    const control = rootNode.querySelector([
      'select',
      'textarea',
      'input[type="color"]',
      'input[type="text"]',
      'input[type="search"]'
    ].join(',')) || rootNode.querySelector('input[type="hidden"]');

    return control
      ? { kind: control.tagName.toLowerCase(), type: control.type || '', value: control.value }
      : null;
  }

  function captureHistorySnapshot() {
    const options = {};
    HISTORY_OPTION_IDS.forEach(id => {
      const value = captureOptionState(id);
      if (value) options[id] = value;
    });

    return {
      options,
      textLayout: window.SmoofTextTools?.getHistoryState?.() || null,
      textVisibility: window.SmoofTextVisibility
        ? [0, 1, 2].map(index => window.SmoofTextVisibility.isVisible(index) !== false)
        : null,
      logo: window.SmoofLogoHistory?.getState?.() || null,
      logoCopy: window.SmoofLogoCopyTools?.getHistoryState?.() || null,
      logoDuplicate: window.SmoofLogoDuplicateTools?.getHistoryState?.() || null,
      logoInversion: window.SmoofLogoInvertTools?.getHistoryState?.() || null,
      logoColours: window.SmoofLogoColourTools?.getHistoryState?.() || null,
      logoBackgrounds: window.SmoofLogoBackgroundTools?.getHistoryState?.() || null,
      number: window.SmoofNumberHistory?.getState?.() || null,
      arrows: window.SmoofArrowTools?.getHistoryState?.() || null,
      payments: window.SmoofPaymentTools?.getHistoryState?.() || null,
      socialPlatforms: window.SmoofSocialPlatformTools?.getHistoryState?.() || null,
      customTexts: window.SmoofCustomTextTools?.getHistoryState?.() || null,
      customPictograms: window.SmoofCustomPictogramTools?.getHistoryState?.() || null,
      qrGeometry: window.SmoofQrGeometryTools?.getHistoryState?.() || null,
      nfc: window.SmoofNfcTools?.getHistoryState?.() || null,
      backgroundImage: window.SmoofBackgroundImageBridge?.getHistoryState?.() ||
        window.SmoofBackgroundImageBridge?.getState?.() || null,
      layerOpacity: window.SmoofLayerOpacityTools?.getHistoryState?.() || null,
      backgroundGradient: window.SmoofBackgroundGradientTools?.getHistoryState?.() || null
    };
  }

  function historySignature(snapshot) {
    if (!snapshot) return '';
    const logo = snapshot.logo || {};
    const dataUrl = String(logo.dataUrl || '');
    return JSON.stringify({
      ...snapshot,
      logo: {
        ...logo,
        dataUrl: dataUrl
          ? `${dataUrl.length}:${dataUrl.slice(0, 36)}:${dataUrl.slice(-36)}`
          : ''
      }
    });
  }

  function syncHistoryButtons() {
    if (!commandbar) return;
    const undo = commandbar.querySelector('[data-smoof-ui-command-action="undo"]');
    const redo = commandbar.querySelector('[data-smoof-ui-command-action="redo"]');
    if (undo) undo.disabled = historyPast.length === 0 || historyRestoring;
    if (redo) redo.disabled = historyFuture.length === 0 || historyRestoring;
  }

  function clearHistory() {
    clearTimeout(historyTimer);
    clearTimeout(historyBaselineTimer);
    historyBaselineTimer = 0;
    historyCurrent = null;
    historyCurrentKey = '';
    historyPast = [];
    historyFuture = [];
    syncHistoryButtons();
  }

  function commitHistorySnapshot() {
    if (keyboardMove || historyRestoring || !personalizedDesignSelected()) return;
    const next = captureHistorySnapshot();
    if (!next) return;
    const nextKey = historySignature(next);

    if (!historyCurrent) {
      historyCurrent = next;
      historyCurrentKey = nextKey;
      syncHistoryButtons();
      return;
    }

    if (nextKey === historyCurrentKey) return;
    historyPast.push(historyCurrent);
    if (historyPast.length > HISTORY_LIMIT) historyPast.shift();
    historyCurrent = next;
    historyCurrentKey = nextKey;
    historyFuture = [];
    syncHistoryButtons();
  }

  function scheduleHistoryCapture(delay = 320) {
    if (keyboardMove || historyRestoring) return;
    clearTimeout(historyTimer);
    historyTimer = setTimeout(commitHistorySnapshot, delay);
  }

  function setNativeChecked(input, checked) {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
    if (descriptor?.set) descriptor.set.call(input, checked);
    else input.checked = checked;
  }

  function applyOptionState(id, saved) {
    const rootNode = optionRoot(id);
    if (!rootNode || !saved) return;

    if (saved.kind === 'choice') {
      const wanted = new Set(saved.values || []);
      rootNode.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
        const checked = wanted.has(input.value);
        if (input.checked === checked) return;
        setNativeChecked(input, checked);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return;
    }

    const control = rootNode.querySelector([
      'select',
      'textarea',
      'input[type="color"]',
      'input[type="text"]',
      'input[type="search"]'
    ].join(',')) || rootNode.querySelector('input[type="hidden"]');
    if (control && control.value !== saved.value) setNativeValue(control, saved.value, true);
  }

  function applyHistorySnapshot(snapshot) {
    if (!snapshot) return;
    window.SmoofRichText?.clear?.();
    historyRestoring = true;
    clearTimeout(historyTimer);
    syncHistoryButtons();

    Object.entries(snapshot.options || {}).forEach(([id, value]) => applyOptionState(id, value));

    const applyLayouts = () => {
      if (snapshot.textLayout) window.SmoofTextTools?.applyHistoryState?.(snapshot.textLayout);
      if (snapshot.logo) window.SmoofLogoHistory?.applyState?.(snapshot.logo);
      if (snapshot.logoCopy) window.SmoofLogoCopyTools?.applyHistoryState?.(snapshot.logoCopy);
      if (snapshot.logoDuplicate) window.SmoofLogoDuplicateTools?.applyHistoryState?.(snapshot.logoDuplicate);
      if (snapshot.logoInversion) window.SmoofLogoInvertTools?.applyHistoryState?.(snapshot.logoInversion);
      window.SmoofLogoColourTools?.applyHistoryState?.(snapshot.logoColours || {});
      if (snapshot.logoBackgrounds) window.SmoofLogoBackgroundTools?.applyHistoryState?.(snapshot.logoBackgrounds);
      if (snapshot.number) window.SmoofNumberHistory?.applyState?.(snapshot.number);
      if (snapshot.arrows) window.SmoofArrowTools?.applyHistoryState?.(snapshot.arrows);
      if (snapshot.payments) window.SmoofPaymentTools?.applyHistoryState?.(snapshot.payments);
      if (snapshot.socialPlatforms) window.SmoofSocialPlatformTools?.applyHistoryState?.(snapshot.socialPlatforms);
      if (snapshot.customTexts) window.SmoofCustomTextTools?.applyHistoryState?.(snapshot.customTexts);
      if (snapshot.customPictograms) window.SmoofCustomPictogramTools?.applyHistoryState?.(snapshot.customPictograms);
      if (snapshot.qrGeometry) window.SmoofQrGeometryTools?.applyHistoryState?.(snapshot.qrGeometry);
      if (snapshot.nfc) window.SmoofNfcTools?.applyHistoryState?.(snapshot.nfc);
      if (snapshot.backgroundImage) window.SmoofBackgroundImageBridge?.applyHistoryState?.(snapshot.backgroundImage);
      if (snapshot.layerOpacity) window.SmoofLayerOpacityTools?.applyHistoryState?.(snapshot.layerOpacity);
      if (snapshot.backgroundGradient) window.SmoofBackgroundGradientTools?.applyHistoryState?.(snapshot.backgroundGradient);
      (Array.isArray(snapshot.textVisibility) ? snapshot.textVisibility : []).forEach((visible, index) => {
        if (!window.SmoofTextVisibility) return;
        if (window.SmoofTextVisibility.isVisible(index) !== visible) {
          window.SmoofTextVisibility.toggle(index);
        }
      });
    };

    applyLayouts();
    requestAnimationFrame(() => requestAnimationFrame(applyLayouts));
    setTimeout(() => {
      applyLayouts();
      historyRestoring = false;
      syncHistoryButtons();
      if (layersOpen && layersPage === 'detail') renderLayers();
      else if (selectedId) renderContext();
    }, 220);
  }

  function undoHistory() {
    if (historyRestoring) return;
    clearTimeout(historyTimer);
    commitHistorySnapshot();
    if (!historyPast.length || !historyCurrent) return;
    historyFuture.push(historyCurrent);
    const target = historyPast.pop();
    historyCurrent = target;
    historyCurrentKey = historySignature(target);
    applyHistorySnapshot(target);
  }

  function redoHistory() {
    if (historyRestoring || !historyFuture.length || !historyCurrent) return;
    historyPast.push(historyCurrent);
    const target = historyFuture.pop();
    historyCurrent = target;
    historyCurrentKey = historySignature(target);
    applyHistorySnapshot(target);
  }

  function syncPersonalizationGate() {
    const enabled = personalizedDesignSelected();
    root.dataset.smoofUiEnabled = String(enabled);
    if (!enabled) {
      keyboardMove = false; heldArrows.clear();
      dismissTemplateCoachmark(false);
      if (historyCurrent) clearHistory();
      layersOpen = false;
      layersPage = 'list';
      selectedId = '';
      if (context) context.dataset.open = 'false';
      if (layers) layers.dataset.open = 'false';
    } else if (!historyCurrent && !historyBaselineTimer) {
      historyBaselineTimer = setTimeout(() => {
        historyBaselineTimer = 0;
        commitHistorySnapshot();
      }, 420);
    }
    return enabled;
  }

  const t = (de, en) => root.lang.toLowerCase().startsWith('en') ? en : de;
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
  const icon = name => {
    const common = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    const paths = {
      editor: '<path d="m4 16-1 5 5-1L19 9l-4-4L4 16Z"></path><path d="m13.5 6.5 4 4"></path>',
      templates: '<rect x="4" y="3.5" width="16" height="17" rx="3"></rect><path d="M4 9.5h16M10.5 9.5v11"></path>',
      layers: '<path d="m12 3 9 5-9 5-9-5 9-5Z"></path><path d="m3 12 9 5 9-5"></path><path d="m3 16 9 5 9-5"></path>',
      ruler: '<path d="M3 7h18v10H3z"></path><path d="M7 7v4M11 7v2M15 7v4M19 7v2"></path>',
      reset: '<path d="M4 4v6h6"></path><path d="M5.5 16a8 8 0 1 0 .5-9l-2 3"></path>',
      undo: '<path d="M9 7 4 12l5 5"></path><path d="M5 12h8a6 6 0 0 1 6 6"></path>',
      redo: '<path d="m15 7 5 5-5 5"></path><path d="M19 12h-8a6 6 0 0 0-6 6"></path>',
      save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"></path><path d="M17 21v-8H7v8M7 3v5h8"></path>',
      open: '<path d="M3 6h6l2 3h7a2 2 0 0 1 2 2v1"></path><path d="M3 6v13h16l2-7H6l-3 7Z"></path>',
      help: '<circle cx="12" cy="12" r="9"></circle><path d="M9.7 9a2.5 2.5 0 1 1 4 2c-1 .7-1.7 1.2-1.7 2.5"></path><path d="M12 17h.01"></path>',
      close: '<path d="m6 6 12 12M18 6 6 18"></path>',
      back: '<path d="m15 18-6-6 6-6"></path>',
      eye: '<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle>',
      eyeOff: '<path d="M3 3l18 18"></path><path d="M10.6 6.1A9 9 0 0 1 12 6c6 0 9.5 6 9.5 6a15 15 0 0 1-2.1 2.8M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6a9 9 0 0 0 3.2-.6"></path>',
      lock: '<rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path>',
      text: '<path d="M5 5h14M12 5v14M8 19h8"></path>',
      arrows: '<path d="m3 8 4 4-4 4M9 8l4 4-4 4M15 8l4 4-4 4"></path>',
      nfc: '<path d="M5.2 8.1a9.7 9.7 0 0 1 13.6 0"></path><path d="M7.9 10.9a5.8 5.8 0 0 1 8.2 0"></path><path d="M10.6 13.6a2 2 0 0 1 2.8 0"></path><circle cx="12" cy="17" r=".8" fill="currentColor" stroke="none"></circle>',
      image: '<rect x="3" y="4" width="18" height="16" rx="2"></rect><circle cx="9" cy="10" r="2"></circle><path d="m21 16-5-5L5 20"></path>',
      number: '<path d="M9 3 7 21M17 3l-2 18M4 9h16M3 15h16"></path>',
      dot: '<circle cx="12" cy="12" r="7"></circle>',
      background: '<path d="M12 3a9 9 0 1 0 0 18c1.3 0 2-1.4 1.2-2.4-.7-.9-.1-2.2 1.1-2.2H17a4 4 0 0 0 4-4C21 7.2 17 3 12 3Z"></path><circle cx="7.5" cy="10" r=".8" fill="currentColor"></circle><circle cx="11" cy="7" r=".8" fill="currentColor"></circle><circle cx="15" cy="8" r=".8" fill="currentColor"></circle>',
      qr: '<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v6h-4v-2M14 20v-2"></path>',
      payment: '<rect x="3" y="6" width="18" height="13" rx="2"></rect><path d="M3 10h18M7 15h3"></path>',
      social: '<circle cx="7" cy="7" r="3"></circle><circle cx="17" cy="7" r="3"></circle><circle cx="12" cy="17" r="3"></circle><path d="m9.5 8.5 2 5M14.5 8.5l-2 5M10 7h4"></path>',
      add: '<path d="M12 5v14M5 12h14"></path>',
      trash: '<path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"></path>'
    };
    return `<svg ${common}>${paths[name] || paths.text}</svg>`;
  };

  const descriptors = () => {
    const map = {
    'text-0': { symbol: 'text', title: t('Textzeile 1', 'Text line 1'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'text-1': { symbol: 'text', title: t('Textzeile 2', 'Text line 2'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'text-2': { symbol: 'text', title: t('Textzeile 3', 'Text line 3'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'arrow-left': { symbol: 'arrows', title: t('Piktogramm links', 'Left pictogram'), copy: t('Motiv, Drehung, Farben und Text', 'Symbol, rotation, colours and label'), kind: 'arrow', hideable: true },
    'arrow-right': { symbol: 'arrows', title: t('Piktogramm rechts', 'Right pictogram'), copy: t('Motiv, Drehung, Farben und Text', 'Symbol, rotation, colours and label'), kind: 'arrow', hideable: true },
    logo: { symbol: 'image', title: 'Logo', copy: t('Position, Größe, Datei und Sichtbarkeit', 'Position, size, file and visibility'), kind: 'logo', hideable: true },
    'logo-copy': { symbol: 'image', title: t('Logo-1-Duplikat', 'Logo 1 duplicate'), copy: t('Verknüpftes Duplikat von Logo 1', 'Linked duplicate of logo 1'), kind: 'logo-copy', hideable: true },
    'logo-2': { symbol: 'image', title: t('Logo 2', 'Logo 2'), copy: t('Eigenständige Logodatei, Position und Größe', 'Independent logo file, position and size'), kind: 'logo-duplicate', hideable: true },
    'table-number': { symbol: 'number', title: t('Tisch-/Zimmernummer', 'Table/room number'), copy: t('Optionales Textelement', 'Optional text element'), kind: 'number', hideable: true },
    'branding-dot': { symbol: 'dot', title: t('Branding-Kreis', 'Branding circle'), copy: t('Farbe und Sichtbarkeit', 'Colour and visibility'), kind: 'brand', hideable: true },
    nfc: { symbol: 'nfc', title: 'NFC', copy: t('Symbol, Kreisfarbe und Position', 'Icon, circle colour and position'), kind: 'nfc', hideable: true },
    payments: { symbol: 'payment', title: t('Zahlungsanbieter', 'Payment providers'), copy: t('Mehrfachauswahl, Farbe und Größe', 'Multiple selection, colour and size'), kind: 'payments', hideable: true },
    'social-library': { symbol: 'social', title: t('Social Media & Plattformen', 'Social media & platforms'), copy: t('Bewertungen, Social Media und Plattformen', 'Reviews, social media and platforms'), kind: 'social-library' },
    add: { symbol: 'add', title: t('Hinzufügen', 'Add'), copy: t('Weitere Elemente ergänzen', 'Add more elements'), kind: 'add' },
    guides: { symbol: 'ruler', title: t('Bemaßung & Ausrichtung', 'Measurements & alignment'), copy: t('Maße anzeigen und Fanglinien einstellen', 'Show measurements and set snapping guides'), kind: 'guides' },
    downloads: { symbol: 'save', title: t('Uploads & Downloads', 'Uploads & Downloads'), copy: t('Design- und Druckdateien', 'Design and print files'), kind: 'downloads' },
    templates: { symbol: 'templates', title: t('Vorlagen', 'Templates'), copy: window.SmoofTemplateLibrary?.languageSelectionEnabled ? t('Sprache wählen, dann Vorlage entdecken', 'Choose a language, then explore templates') : t('Nach Anwendungsfall auswählen', 'Choose by use case'), kind: 'templates' },
    qr: { symbol: 'qr', title: 'QR-Code', copy: t('Sichtbarkeit, Position, Größe und Hintergrundfläche', 'Visibility, position, size and backing panel'), kind: 'qr', locked: false, hideable: true },
      background: {
        symbol: 'background',
        title: t('Hintergrund', 'Background'),
        copy: backgroundLocked
          ? t('Edelstahloberfläche ist fest vorgegeben', 'Stainless-steel surface is fixed')
          : t('Farbe, Verlauf und optionales Bild', 'Colour, gradient and optional image'),
        kind: 'background',
        locked: true
      }
    };
    (window.SmoofCustomTextTools?.getStates?.() || []).filter(state => state.enabled).forEach(state => {
      const number = Number(String(state.id || '').split('-').pop()) || 1;
      map[state.id] = {
        symbol: 'text',
        title: t(`Zusatztext ${number}`, `Additional text ${number}`),
        copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'),
        kind: 'custom-text',
        hideable: true
      };
    });
    (window.SmoofCustomPictogramTools?.getStates?.() || []).filter(state => state.enabled).forEach(state => {
      const number = Number(String(state.id || '').split('-').pop()) || 1;
      map[state.id] = {
        symbol: 'arrows',
        title: t(`Zusatzpiktogramm ${number}`, `Additional pictogram ${number}`),
        copy: t('Motiv, Drehung, Farbe und Größe', 'Symbol, rotation, colour and size'),
        kind: 'custom-pictogram',
        hideable: true
      };
    });
    Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}).forEach(id => {
      const definition = window.SmoofSocialPlatformLibrary?.get?.(id);
      if (!definition) return;
      map[`social-platform-${id}`] = {
        symbol: 'social', title: definition.label,
        copy: t('Position, Farbe und Größe', 'Position, colour and size'),
        kind: 'social-platform', hideable: true
      };
    });
    return map;
  };

  function sourceFor(id) {
    if (id === 'downloads' || id === 'templates' || id === 'add') return commandbar;
    if (id === 'social-library') return commandbar;
    if (/^social-platform-/.test(id)) {
      return document.querySelector(`[data-smoof-social-platform-frame="${id.replace(/^social-platform-/, '')}"]`);
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      return document.querySelector(`[data-smoof-editor-item="${id}"]`);
    }
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      return document.querySelector(`[data-smoof-custom-pictogram-frame="${id}"]`);
    }
    if (/^text-[0-2]$/.test(id)) {
      const frames = Array.from(document.querySelectorAll(`[data-smoof-text-frame="${id.split('-')[1]}"]`));
      const frame = frames.find(candidate => candidate.dataset.active === 'true') || frames.find(candidate => {
        const rect = candidate.getBoundingClientRect();
        const style = getComputedStyle(candidate);
        return style.display !== 'none' && rect.width > 2 && rect.height > 2;
      }) || frames[0];
      return frame ? frame.querySelector('[data-smoof-text-controls]') : null;
    }
    const selectors = {
      logo: '[data-smoof-logo-editor-frame]:not([data-smoof-logo-instance]) [data-smoof-logo-controls]',
      'logo-copy': '[data-smoof-logo-copy-controls]',
      'logo-2': '[data-smoof-logo-duplicate-controls]',
      'arrow-left': '[data-smoof-arrow-controls]',
      'arrow-right': '[data-smoof-arrow-controls]',
      'table-number': '[data-smoof-number-controls]',
      'branding-dot': '[data-smoof-brand-controls]',
      nfc: '[data-smoof-nfc-frame]',
      payments: '[data-smoof-payment-frame]',
      background: '[data-smoof-background-controls]',
      qr: '[data-smoof-qr-frame]'
    };
    return selectors[id] ? document.querySelector(selectors[id]) : null;
  }

  function visibleItemFor(id) {
    return Array.from(document.querySelectorAll(`[data-smoof-editor-item="${id}"]`)).find(el => {
      if (el.closest('[data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-commandbar]')) return false;
      if (el.matches('[data-smoof-text-controls], [data-smoof-logo-controls], [data-smoof-arrow-controls], [data-smoof-number-controls], [data-smoof-brand-controls]')) return false;
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      return !el.hidden && style.display !== 'none' && rect.width > 2 && rect.height > 2;
    }) || null;
  }

  function visibilitySource(id) {
    const controls = sourceFor(id);
    if (!controls) return null;
    if (/^text-/.test(id)) return controls.querySelector('[data-smoof-text-control-button="visibility"]');
    if (id === 'table-number') return controls.querySelector('[data-smoof-number-control-button="visibility"]');
    return null;
  }

  function isVisible(id) {
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      return window.SmoofCustomPictogramTools?.isVisible?.(id) !== false;
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      return window.SmoofCustomTextTools?.isVisible?.(id) !== false;
    }
    if (id === 'logo' && window.SmoofLogoTools?.isVisible) {
      return window.SmoofLogoTools.isVisible();
    }
    if (id === 'logo-2' && window.SmoofLogoDuplicateTools?.isVisible) {
      return window.SmoofLogoDuplicateTools.isVisible();
    }
    if (id === 'logo-copy' && window.SmoofLogoCopyTools?.isVisible) {
      return window.SmoofLogoCopyTools.isVisible();
    }
    if (id === 'nfc' && window.SmoofNfcTools?.isVisible) {
      return window.SmoofNfcTools.isVisible();
    }
    if (id === 'payments' && window.SmoofPaymentTools?.isVisible) {
      return window.SmoofPaymentTools.isVisible();
    }
    if (/^social-platform-/.test(id) && window.SmoofSocialPlatformTools?.isVisible) {
      return window.SmoofSocialPlatformTools.isVisible(id);
    }
    if (/^arrow-(left|right)$/.test(id) && window.SmoofArrowTools?.isVisible) {
      return window.SmoofArrowTools.isVisible(id.split('-')[1]);
    }
    if (id === 'branding-dot') {
      if (window.SmoofBrandTools?.isVisible) {
        return window.SmoofBrandTools.isVisible();
      }
      const dot = document.querySelector('[data-smoof-brand-dot]');
      const stored = dot?.dataset.smoofBrandVisible;
      if (stored === 'true' || stored === 'false') return stored === 'true';
      return dot ? !dot.hidden : true;
    }
    if (/^text-[0-2]$/.test(id) && window.SmoofTextVisibility) {
      return window.SmoofTextVisibility.isVisible(Number(id.split('-')[1]));
    }
    if (id === 'table-number' && window.SmoofNumberVisibilityTools?.isVisible) {
      return window.SmoofNumberVisibilityTools.isVisible();
    }
    if (id === 'qr' && window.SmoofQrGeometryTools?.isVisible) {
      return window.SmoofQrGeometryTools.isVisible();
    }
    const control = visibilitySource(id);
    if (control) {
      if (control.dataset.visible) return control.dataset.visible !== 'false';
      const pressed = control.getAttribute('aria-pressed');
      if (pressed !== null) return pressed !== 'true';
    }
    if (/^text-/.test(id)) {
      const index = id.split('-')[1];
      const frame = document.querySelector(`[data-smoof-text-frame="${index}"]`);
      return !frame || frame.dataset.visible !== 'false';
    }
    if (id === 'table-number') return Boolean(visibleItemFor(id));
    return true;
  }

  function toggleVisibility(id) {
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      window.SmoofCustomPictogramTools?.toggleVisibility?.(id);
      return;
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      window.SmoofCustomTextTools?.toggleVisibility?.(id);
      return;
    }
    if (id === 'logo' && window.SmoofLogoTools?.toggleVisibility) {
      window.SmoofLogoTools.toggleVisibility();
      return;
    }
    if (id === 'logo-2' && window.SmoofLogoDuplicateTools?.toggleVisibility) {
      window.SmoofLogoDuplicateTools.toggleVisibility();
      return;
    }
    if (id === 'logo-copy' && window.SmoofLogoCopyTools?.toggleVisibility) {
      window.SmoofLogoCopyTools.toggleVisibility();
      return;
    }
    if (id === 'nfc' && window.SmoofNfcTools?.toggleVisibility) {
      window.SmoofNfcTools.toggleVisibility();
      return;
    }
    if (id === 'payments' && window.SmoofPaymentTools?.toggleVisibility) {
      window.SmoofPaymentTools.toggleVisibility();
      return;
    }
    if (/^social-platform-/.test(id) && window.SmoofSocialPlatformTools?.toggleVisibility) {
      window.SmoofSocialPlatformTools.toggleVisibility(id);
      return;
    }
    if (/^arrow-(left|right)$/.test(id) && window.SmoofArrowTools?.toggleVisibility) {
      window.SmoofArrowTools.toggleVisibility(id.split('-')[1]);
      return;
    }
    if (id === 'branding-dot') {
      if (window.SmoofBrandTools?.toggleVisibility) {
        window.SmoofBrandTools.toggleVisibility();
        return;
      }

      /*
       * Sicherheitsnetz fuer Themes, in denen noch der alte Branding-Block
       * aktiv ist. Der eigentliche Fix wird mit v2.18.4 ebenfalls geliefert,
       * aber das Auge darf bei einem Versions-Mix nicht erneut wirkungslos
       * bleiben.
       */
      const visible = !isVisible(id);
      document.querySelectorAll('[data-smoof-brand-dot]').forEach(dot => {
        dot.hidden = !visible;
        dot.dataset.smoofBrandVisible = String(visible);
        dot.setAttribute('aria-hidden', String(!visible));
      });
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        let input = form.querySelector('input[name="properties[_SMOOF Branding sichtbar]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_SMOOF Branding sichtbar]';
          form.appendChild(input);
        }
        input.value = visible ? 'Ja' : 'Nein';
      });
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:branding-visibility-changed', {
        detail: { visible }
      }));
      return;
    }
    if (/^text-[0-2]$/.test(id) && window.SmoofTextVisibility) {
      window.SmoofTextVisibility.toggle(Number(id.split('-')[1]));
      return;
    }
    if (id === 'table-number' && window.SmoofNumberVisibilityTools?.toggleVisibility) {
      window.SmoofNumberVisibilityTools.toggleVisibility();
      return;
    }
    if (id === 'qr' && window.SmoofQrGeometryTools?.toggleVisibility) {
      window.SmoofQrGeometryTools.toggleVisibility();
      return;
    }
    const control = visibilitySource(id);
    if (control && !control.disabled) control.click();
  }

  function dispatchSelection(id, options = {}) {
    window.dispatchEvent(new CustomEvent(SELECT_EVENT, {
      detail: {
        id: String(id || ''),
        openContext: options.openContext === true
      }
    }));
  }

  function row(label, body) {
    return `<div data-smoof-ui-row><span data-smoof-ui-row-label>${label}</span><div>${body}</div></div>`;
  }

  function fontButton(family) {
    const safeFamily = escapeHtml(family);
    const actionLabel = t('Schrift auswählen', 'Choose font');
    return `<button type="button" data-smoof-ui-wide-button data-smoof-ui-font-button data-smoof-ui-action="text-font" aria-label="${actionLabel}: ${safeFamily}" title="${safeFamily}"><span>${safeFamily}</span><small aria-hidden="true">→</small></button>`;
  }

  function colorRow(label, proxy, selector) {
    const input = source ? source.querySelector(selector) : null;
    const locked = laserMonochromeActive();
    const value = locked ? '#000000' : (input?.value || '#000000');
    const disabled = locked ? ' disabled aria-disabled="true"' : '';
    return row(label, `<label data-smoof-ui-color-wrap${locked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}><span data-smoof-ui-color-swatch style="background-color:${value}"></span><span data-smoof-ui-color-value>${value.toUpperCase()}</span><input data-smoof-ui-color="${proxy}" type="color" value="${value}" aria-label="${label}"${disabled}></label>`);
  }

  function colorRowValue(label, proxy, value) {
    const locked = laserMonochromeActive();
    const safe = locked
      ? '#000000'
      : (/^#[0-9a-f]{6}$/i.test(String(value)) ? value : '#000000');
    const disabled = locked ? ' disabled aria-disabled="true"' : '';
    return row(label, `<label data-smoof-ui-color-wrap${locked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}><span data-smoof-ui-color-swatch style="background-color:${safe}"></span><span data-smoof-ui-color-value>${safe.toUpperCase()}</span><input data-smoof-ui-color="${proxy}" type="color" value="${safe}" aria-label="${label}"${disabled}></label>`);
  }

  function normalizeHexColor(value, allowShort = true) {
    const compact = String(value || '').trim().replace(/^#/, '');
    if (allowShort && /^[0-9a-f]{3}$/i.test(compact)) {
      return `#${compact.split('').map(character => character + character).join('')}`.toUpperCase();
    }
    return /^[0-9a-f]{6}$/i.test(compact)
      ? `#${compact}`.toUpperCase()
      : '';
  }

  function hexColorRow(label, proxy, rawValue, locked = false) {
    const effectiveLocked = locked || laserMonochromeActive();
    const value = effectiveLocked ? '#000000' : (normalizeHexColor(rawValue) || '#000000');
    const disabled = effectiveLocked ? ' disabled aria-disabled="true"' : '';
    return row(
      label,
      `<div data-smoof-ui-hex-color-editor${effectiveLocked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}>` +
        `<label data-smoof-ui-color-wrap data-smoof-ui-hex-color-swatch title="${t('Farbe auswählen', 'Choose colour')}">` +
          `<span data-smoof-ui-color-swatch style="background-color:${value}"></span>` +
          `<span data-smoof-ui-color-value>${value}</span>` +
          `<input data-smoof-ui-color="${proxy}" type="color" value="${value}" aria-label="${label}"${disabled}>` +
        `</label>` +
        `<input data-smoof-ui-hex-color="${proxy}" type="text" value="${value}" maxlength="7" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="${label} ${t('als Hexcode', 'as hex code')}" aria-invalid="false"${disabled}>` +
      `</div>`
    );
  }

  function sourceHexColorRow(label, proxy, selector) {
    const input = source ? source.querySelector(selector) : null;
    return hexColorRow(label, proxy, input?.value || '#000000');
  }

  function letterSpacingRow(value) {
    const spacing = Number.isFinite(Number(value)) ? Number(value) : 0;
    return row(
      t('Laufweite', 'Letter spacing'),
      `<div data-smoof-ui-stepper>` +
        `<button type="button" data-smoof-ui-action="letter-spacing-minus" aria-label="${t('Laufweite verringern', 'Decrease letter spacing')}">−</button>` +
        `<span data-smoof-ui-letter-spacing>${Math.round(spacing * 100)}%</span>` +
        `<button type="button" data-smoof-ui-action="letter-spacing-plus" aria-label="${t('Laufweite erhöhen', 'Increase letter spacing')}">+</button>` +
      `</div>`
    );
  }

  function backgroundColorRow(label) {
    const input = source ? source.querySelector('input[type="color"]') : null;
    return hexColorRow(label, 'background-color', input?.value);
  }

  function styleRow(proxy, selector, locked = false) {
    const select = source ? source.querySelector(selector) : null;
    const options = locked
      ? '<option value="Normal" selected>Normal</option>'
      : select ? Array.from(select.options).map(option => `<option value="${option.value}"${option.selected ? ' selected' : ''}${option.disabled ? ' disabled' : ''}>${escapeHtml(option.textContent)}</option>`).join('') : '';
    return row(t('Schnitt', 'Style'), `<select data-smoof-ui-select="${proxy}" aria-label="${t('Schriftschnitt', 'Font style')}"${locked ? ' disabled title="' + t('Dieser Upload enthält nur den Schnitt Normal.', 'This upload contains only the Normal style.') + '"' : ''}>${options}</select>`);
  }

  function sharedFontStyleOptions(selectedValue = 'Normal', locked = false, family = 'Roboto') {
    if (locked) return '<option value="Normal" selected>Normal</option>';
    const values = Array.from(window.SmoofTextTools?.styleOptions || ['Extra light', 'Extra light & Kursiv', 'Light', 'Light & Kursiv', 'Normal', 'Kursiv', 'Fett', 'Fett & Kursiv', 'Extra fett', 'Extra fett & Kursiv']);
    const selected = window.SmoofTextTools?.normalizeStyle?.(selectedValue) || selectedValue || 'Normal';
    const mixed=window.SmoofRichText?.selectedStyle?.(selectedId)?.mixedStyle;
    return (mixed?`<option value="" disabled selected>${t('Gemischt','Mixed')}</option>`:'') + values.map(value => {
      const spec = window.SmoofTextTools?.styleOption?.(family, value) || { label: value, disabled: value.startsWith('Extra') };
      if(window.SmoofRichText?.styleAvailable?.(selectedId,value)===false){spec.disabled=true;spec.label+=t(' (nicht für gesamte Auswahl verfügbar)',' (not available for entire selection)');}
      return `<option value="${escapeHtml(value)}"${!mixed && selected === value ? ' selected' : ''}${spec.disabled ? ' disabled' : ''}>${escapeHtml(spec.label)}</option>`;
    }).join('');
  }

  function pictogramPreview(iconRecord, side, selected = false) {
    const library = window.SmoofPictogramLibrary;
    const previewUrl = library?.dataUrl?.(iconRecord?.id, side) || '';
    const style = previewUrl
      ? ` style="--smoof-pictogram-image:url(&quot;${escapeHtml(previewUrl)}&quot;)"`
      : '';
    return `<span data-smoof-ui-pictogram-preview data-selected="${String(selected)}" data-raster="${String(iconRecord?.raster === true)}"${style}></span>`;
  }

  function alignActivePictogramCategory(container) {
    requestAnimationFrame(() => {
      const active = container?.querySelector?.('[data-smoof-ui-pictogram-category][data-active="true"]');
      active?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }

  function rememberPictogramCategoryScroll(container, key) {
    const tabs = container?.querySelector?.('[data-smoof-ui-pictogram-tabs]');
    if (!tabs) return;
    pictogramCategoryScroll[key] = Math.max(0, Number(tabs.scrollLeft) || 0);
  }

  function restorePictogramCategoryScroll(container, key) {
    const saved = Number(pictogramCategoryScroll[key]);
    requestAnimationFrame(() => {
      const tabs = container?.querySelector?.('[data-smoof-ui-pictogram-tabs]');
      if (!tabs || !Number.isFinite(saved)) return;
      tabs.scrollLeft = Math.max(0, saved);
    });
  }

  function availablePictogramCategories(side) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return [];
    const state = window.SmoofArrowTools?.getState?.(side);
    const current = library.get?.(state?.symbol);
    return Object.keys(library.categories).filter(id => {
      if (id === 'custom') return Boolean(current?.custom);
      return library.icons.some(iconRecord => iconRecord.category === id);
    });
  }

  function pictogramRow(state, side) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return '';
    const language = root.lang.toLowerCase().startsWith('en') ? 'en' : 'de';
    const current = library.get?.(state.symbol) || library.get?.('dots') || library.icons[0];
    const currentName = current?.[language] || current?.de || t('Motiv', 'Symbol');
    const isOpen = pictogramPickerOpenFor === side;
    const category = pictogramPickerCategory[side] || current?.category || 'arrows';
    const categoryButtons = availablePictogramCategories(side).map(id => {
      const label = library.categories[id]?.[language] || id;
      return `<button type="button" data-smoof-ui-pictogram-category="${escapeHtml(id)}" data-smoof-ui-action="pictogram-category:${escapeHtml(id)}" data-active="${String(category === id)}">${escapeHtml(label)}</button>`;
    }).join('');
    const candidates = [
      ...library.icons.filter(iconRecord => iconRecord.category === category),
      ...(category === 'custom' && current?.custom ? [current] : [])
    ].filter((iconRecord, index, list) => list.findIndex(candidate => candidate.id === iconRecord.id) === index);
    const cards = candidates.map(iconRecord => {
      const title = iconRecord[language] || iconRecord.de || iconRecord.id;
      const active = iconRecord.id === state.symbol;
      return `<button type="button" data-smoof-ui-pictogram-card data-active="${String(active)}" data-smoof-ui-action="pictogram-select:${escapeHtml(iconRecord.id)}" aria-pressed="${String(active)}">${pictogramPreview(iconRecord, side, active)}<span>${escapeHtml(title)}</span></button>`;
    }).join('');
    const picker = isOpen
      ? `<div data-smoof-ui-pictogram-library><div data-smoof-ui-pictogram-tabs>${categoryButtons}</div><div data-smoof-ui-pictogram-grid>${cards}<button type="button" data-smoof-ui-pictogram-card data-smoof-ui-pictogram-upload-card data-smoof-ui-action="pictogram-upload"><span data-smoof-ui-pictogram-upload-icon>＋</span><span>${t('Eigenes SVG oder PNG', 'Custom SVG or PNG')}</span></button></div><input type="file" accept=".svg,.png,image/svg+xml,image/png" data-smoof-ui-pictogram-upload="${side}" hidden><p data-smoof-ui-pictogram-status aria-live="polite">${t('SVG bis 600 KB oder transparentes PNG bis 500 KB und 1.000 × 1.000 px.', 'SVG up to 600 KB or transparent PNG up to 500 KB and 1,000 × 1,000 px.')}</p></div>`
      : '';
    return row(t('Motiv', 'Symbol'), `<button type="button" data-smoof-ui-pictogram-current data-smoof-ui-action="pictogram-picker-toggle" aria-expanded="${String(isOpen)}">${pictogramPreview(current, side, true)}<span><strong>${escapeHtml(currentName)}</strong><small>${t('Motiv auswählen', 'Choose symbol')}</small></span><b>${isOpen ? '↑' : '→'}</b></button>${picker}`);
  }

  function customPictogramRow(state, itemId) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return '';
    const language = root.lang.toLowerCase().startsWith('en') ? 'en' : 'de';
    const side = state.mirrored ? 'right' : 'left';
    const current = library.get?.(state.symbol) || library.get?.('dots') || library.icons[0];
    const currentName = current?.[language] || current?.de || t('Motiv', 'Symbol');
    const isOpen = pictogramPickerOpenFor === itemId;
    const category = pictogramPickerCategory[itemId] || current?.category || 'arrows';
    const categories = Object.keys(library.categories).filter(id => {
      if (id === 'custom') return Boolean(current?.custom);
      return library.icons.some(iconRecord => iconRecord.category === id);
    });
    const categoryButtons = categories.map(id => {
      const label = library.categories[id]?.[language] || id;
      return `<button type="button" data-smoof-ui-pictogram-category="${escapeHtml(id)}" data-smoof-ui-action="custom-pictogram-category:${escapeHtml(id)}" data-active="${String(category === id)}">${escapeHtml(label)}</button>`;
    }).join('');
    const candidates = [
      ...library.icons.filter(iconRecord => iconRecord.category === category),
      ...(category === 'custom' && current?.custom ? [current] : [])
    ].filter((iconRecord, index, list) => list.findIndex(candidate => candidate.id === iconRecord.id) === index);
    const cards = candidates.map(iconRecord => {
      const title = iconRecord[language] || iconRecord.de || iconRecord.id;
      const active = iconRecord.id === state.symbol;
      return `<button type="button" data-smoof-ui-pictogram-card data-active="${String(active)}" data-smoof-ui-action="custom-pictogram-select:${escapeHtml(iconRecord.id)}" aria-pressed="${String(active)}">${pictogramPreview(iconRecord, side, active)}<span>${escapeHtml(title)}</span></button>`;
    }).join('');
    const picker = isOpen
      ? `<div data-smoof-ui-pictogram-library><div data-smoof-ui-pictogram-tabs>${categoryButtons}</div><div data-smoof-ui-pictogram-grid>${cards}<button type="button" data-smoof-ui-pictogram-card data-smoof-ui-pictogram-upload-card data-smoof-ui-action="custom-pictogram-upload"><span data-smoof-ui-pictogram-upload-icon>＋</span><span>${t('Eigenes SVG oder PNG', 'Custom SVG or PNG')}</span></button></div><input type="file" accept=".svg,.png,image/svg+xml,image/png" data-smoof-ui-custom-pictogram-upload="${itemId}" hidden><p data-smoof-ui-pictogram-status aria-live="polite">${t('SVG bis 600 KB oder transparentes PNG bis 500 KB und 1.000 × 1.000 px.', 'SVG up to 600 KB or transparent PNG up to 500 KB and 1,000 × 1,000 px.')}</p></div>`
      : '';
    return row(t('Motiv', 'Symbol'), `<button type="button" data-smoof-ui-pictogram-current data-smoof-ui-action="custom-pictogram-picker-toggle" aria-expanded="${String(isOpen)}">${pictogramPreview(current, side, true)}<span><strong>${escapeHtml(currentName)}</strong><small>${t('Motiv auswählen', 'Choose symbol')}</small></span><b>${isOpen ? '↑' : '→'}</b></button>${picker}`);
  }

  function scalePropertyName(itemId) {
    if (/^text-[0-2]$/.test(itemId)) {
      return `properties[_SMOOF Text ${Number(itemId.split('-')[1]) + 1} Skalierung]`;
    }
    if (itemId === 'logo') return 'properties[_SMOOF Logo Skalierung]';
    if (itemId === 'logo-copy') return 'properties[_SMOOF Logo 1 Duplikat Skalierung]';
    if (itemId === 'logo-2') return 'properties[_SMOOF Logo 2 Skalierung]';
    if (itemId === 'arrow-left') return 'properties[_SMOOF Piktogramm links Skalierung]';
    if (itemId === 'arrow-right') return 'properties[_SMOOF Piktogramm rechts Skalierung]';
    if (itemId === 'table-number') return 'properties[_SMOOF Nummer Skalierung]';
    if (itemId === 'qr') return 'properties[_SMOOF QR Skalierung]';
    return '';
  }

  function currentScalePercent(itemId = selectedId) {
    if (/^custom-pictogram-[1-3]$/.test(itemId)) {
      const scale = Number(window.SmoofCustomPictogramTools?.getState?.(itemId)?.scale);
      return Math.round((Number.isFinite(scale) ? scale : 1) * 100);
    }
    if (/^custom-text-[1-3]$/.test(itemId)) {
      const scale = Number(window.SmoofCustomTextTools?.getState?.(itemId)?.scale);
      return Math.round((Number.isFinite(scale) ? scale : 1) * 100);
    }
    const propertyName = scalePropertyName(itemId);
    const productForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]'));
    const values = propertyName
      ? Array.from((productForm || document).querySelectorAll('input')).filter(input => input.name === propertyName)
      : [];
    const value = values.map(input => Number.parseFloat(input.value)).find(Number.isFinite);
    return Math.round((Number.isFinite(value) ? value : 1) * 100);
  }

  function syncScaleReadout(panel, itemId) {
    const output = panel?.querySelector('[data-smoof-ui-scale-value]');
    if (output) output.textContent = `${currentScalePercent(itemId)}%`;
  }

  function sizeRow(kind) {
    return row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="${kind}-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-scale-value>${currentScalePercent()}%</span><button type="button" data-smoof-ui-action="${kind}-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`);
  }

  function opacityRow(itemId = selectedId) {
    if (/^custom-pictogram-[1-3]$/.test(itemId)) {
      const opacity = Number(window.SmoofCustomPictogramTools?.getState?.(itemId)?.opacity);
      return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round((Number.isFinite(opacity) ? opacity : 1) * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
    }
    if (/^custom-text-[1-3]$/.test(itemId)) {
      const opacity = Number(window.SmoofCustomTextTools?.getState?.(itemId)?.opacity);
      return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round((Number.isFinite(opacity) ? opacity : 1) * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
    }
    if (!window.SmoofLayerOpacityTools?.supports?.(itemId)) return '';
    const opacity = window.SmoofLayerOpacityTools.get(itemId);
    return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round(opacity * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
  }

  function logoColourRows(id) {
    const value = window.SmoofLogoColourTools?.get?.(id);
    if (!value?.isSvg) return '';
    return row(t('SVG-Farbe', 'SVG colour'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-colour-toggle"><span>${value.enabled ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${value.enabled ? t('Original verwenden', 'Use original') : t('Einfärben', 'Recolour')} →</small></button>`) + hexColorRow(t('Farbe', 'Colour'), 'logo-colour', value.color);
  }

  function logoBackgroundRows(itemId = selectedId) {
    const background = window.SmoofLogoBackgroundTools?.get?.(itemId);
    if (!background) return '';
    const shapeOptions = [
      ['rectangle', t('Rechteckig', 'Rectangular')],
      ['rounded', t('Abgerundete Ecken', 'Rounded corners')],
      ['circle', t('Rund', 'Round')]
    ].map(([value, label]) => `<option value="${value}"${background.shape === value ? ' selected' : ''}>${label}</option>`).join('');
    return row(t('Fläche', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-background-toggle"><span>${background.enabled ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${background.enabled ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
      (background.enabled
        ? row(t('Form', 'Shape'), `<select data-smoof-ui-select="logo-background-shape" aria-label="${t('Hintergrundform', 'Background shape')}">${shapeOptions}</select>`) +
          colorRowValue(t('Flächenfarbe', 'Background colour'), 'logo-background-color', background.color) +
          row(t('Innenabstand', 'Padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="logo-background-padding-minus">−</button><span data-smoof-ui-logo-padding-value>${Math.round(background.padding * 100)}%</span><button type="button" data-smoof-ui-action="logo-background-padding-plus">+</button></div>`)
        : '');
  }

  function originalColourRow(state, action) {
    const laser = window.SmoofBrandArtwork?.isLaser();
    return row(t('Markenfarben', 'Brand colours'), laser
      ? `<span data-smoof-ui-locked-note>${t('Laser · Schwarz', 'Laser · Black')}</span>`
      : state.originalColours === false
        ? `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="${action}">${t('Originalfarben verwenden', 'Use original colours')}</button>`
        : `<span data-smoof-ui-locked-note>${t('Originalfarben', 'Original colours')}</span>`);
  }

  function catalogueGroups(items) {
    const variants = {
      'google-wordmark': ['Google', 'text'], google: ['Google', 'symbol'],
      'paypal-wordmark': ['PayPal', 'text'], paypal: ['PayPal', 'symbol'],
      'mastercard-wordmark': ['Mastercard', 'logo'], mastercard: ['Mastercard', 'symbol'],
      'apple-pay-wordmark': ['Apple Pay', 'logo'], 'apple-pay': ['Apple Pay', 'card'],
      'twint-symbol': ['TWINT', 'symbol'], 'twint-logo': ['TWINT', 'logo'], twint: ['TWINT', 'text']
    };
    const groups = new Map();
    items.forEach(item => {
      const [brand, variant] = item.brand ? [item.brand, item.variant || ''] : variants[item.id] || [item.label, items.find(entry => entry.monochrome?.id === item.id)?.variant || ''];
      if (!groups.has(brand)) groups.set(brand, []);
      groups.get(brand).push({ item, variant });
    });
    const order = ['symbol', 'text', 'logo', 'card', ''];
    return [...groups].sort(([a], [b]) => a.localeCompare(b, 'de', { sensitivity: 'base' }))
      .map(([brand, choices]) => ({ brand, choices: choices.sort((a,b) => order.indexOf(a.variant) - order.indexOf(b.variant) || Number(Boolean(a.item.original)) - Number(Boolean(b.item.original))) }));
  }

  function cataloguePicker(items, selected, kind) {
    return `<div data-smoof-ui-catalogue>${catalogueGroups(items).map(({ brand, choices }) =>
      `<section data-smoof-ui-catalogue-brand="${escapeHtml(brand)}"><strong>${escapeHtml(brand)}</strong><div data-smoof-ui-catalogue-choices>${choices.map(({ item, variant }) => {
        const names = { symbol: t('Symbol', 'Symbol'), text: t('Text', 'Text'), logo: t('Logo', 'Logo'), card: t('Rahmen', 'Framed') };
        const full = { symbol: t('Symbol', 'Symbol'), text: t('Schriftzug', 'Wordmark'), logo: t('Symbol mit Schriftzug', 'Symbol and wordmark'), card: t('Logo mit Rahmen', 'Framed logo') };
        const title = brand + (variant ? ' – ' + full[variant] : '') + (item.original ? ' · ' + t('Originalfarben','Original colours') : '');
        const originalPreview = item.original ? window.SmoofBrandArtwork?.create(item, {}) : null;
        const previewItem = window.SmoofBrandArtwork?.resolve(item, {}) || item;
        const preview = originalPreview ? originalPreview.outerHTML : previewItem.path
          ? `<svg viewBox="${escapeHtml(previewItem.viewBox || '0 0 24 24')}" aria-hidden="true"><path d="${escapeHtml(previewItem.path)}" fill-rule="${previewItem.fillRule === 'evenodd' ? 'evenodd' : 'nonzero'}"/></svg>`
          : `<span data-smoof-ui-catalogue-word aria-hidden="true">${escapeHtml(item.label)}</span>`;
        return `<label data-smoof-ui-${kind}-option title="${escapeHtml(title)}"><input type="checkbox" data-smoof-ui-${kind === 'payment' ? 'payment-provider' : 'social-platform'}="${item.id}" aria-label="${escapeHtml(title)}"${selected.has(item.id) ? ' checked' : ''}><span data-smoof-ui-catalogue-preview${item.original ? ' data-smoof-original-preview' : ''}>${preview}</span>${choices.length > 1 ? `<small>${names[variant] || ''}${item.original ? `<span data-smoof-original-label>${t('Original','Original')}</span>` : ''}</small>` : ''}</label>`;
      }).join('')}</div></section>`
    ).join('')}</div>`;
  }

  function paymentProviderGrid(state) {
    return cataloguePicker(window.SmoofPaymentProviderLibrary?.providers || [], new Set(state.selected || []), 'payment');
  }

  function socialPlatformGrid() {
    const items = window.SmoofSocialPlatformLibrary?.items || [];
    const selected = new Set(Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}));
    return [['reviews', t('Bewertungen', 'Reviews')], ['social', t('Social Media', 'Social media')], ['platforms', t('Plattformen', 'Platforms')]]
      .map(([category, label]) => `<section data-smoof-ui-social-category><strong>${label}</strong>${cataloguePicker(items.filter(item => item.category === category), selected, 'social')}</section>`).join('');
  }

  function resetButton(kind) {
    return `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="${kind}-reset">${icon('reset')} ${t('Position und Größe zurücksetzen', 'Reset position and size')}</button></div>`;
  }

  function detailBody(descriptor) {
    if (!descriptor) return '';
    if (descriptor.kind === 'guides') {
      const native = document.querySelector('[data-smoof-guide-visibility-button]');
      const guides = window.SmoofAlignmentGuides;
      const options = [
        ['measurements', t('Bemaßung und Sicherheitszonen', 'Measurements and safety zones'), native?.dataset.active === 'true' || native?.getAttribute('aria-pressed') === 'true', Boolean(native)],
        ['y', t('Horizontale Fanglinien', 'Horizontal snapping guides'), guides?.isAxisEnabled?.('y') !== false, Boolean(guides?.setAxisEnabled)],
        ['x', t('Vertikale Fanglinien', 'Vertical snapping guides'), guides?.isAxisEnabled?.('x') !== false, Boolean(guides?.setAxisEnabled)]
      ];
      return `<div data-smoof-ruler-options>${options.map(([key, label, checked, ready]) =>
        `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="guide-toggle:${key}" role="switch" aria-label="${label}" aria-checked="${checked}"${ready ? '' : ' disabled'}><span>${label}</span><span data-smoof-ruler-switch aria-hidden="true"></span></button>`
      ).join('')}</div><p data-smoof-ruler-hint>${t('Fanglinien rasten Elemente beim Ziehen ein. Wählen Sie ein Element und verschieben Sie es mit den Pfeiltasten fein; mit Umschalt in größeren Schritten.', 'Snapping guides align elements while dragging. Select an element and use the arrow keys for fine movement; hold Shift for larger steps.')}</p>`;
    }
    if (descriptor.kind === 'add') {
      const secondLogo = window.SmoofLogoDuplicateTools?.getState?.() || { hasLogo: false };
      const payments = window.SmoofPaymentTools?.getState?.() || { selected: [] };
      const customTextCount = Number(window.SmoofCustomTextTools?.count?.()) || 0;
      const customPictogramCount = Number(window.SmoofCustomPictogramTools?.count?.()) || 0;
      const items = [
        {
          id: 'logo-2',
          symbol: 'image',
          title: t('Zweites Logo', 'Second logo'),
          copy: t('Eine eigenständige Logodatei hinzufügen', 'Add an independent logo file'),
          available: Boolean(window.SmoofLogoDuplicateTools && !secondLogo.hasLogo)
        },
        {
          id: 'payments',
          symbol: 'payment',
          title: t('Zahlungsanbieter', 'Payment providers'),
          copy: payments.visible === false && payments.selected?.length
            ? t('Gespeicherte Logos wieder einblenden und bearbeiten', 'Show and edit saved provider logos')
            : t('Logos auswählen und gestalten', 'Choose and style provider logos'),
          available: Boolean(window.SmoofPaymentTools && (payments.visible === false || !payments.selected?.length))
        },
        {
          id: 'social-platforms',
          symbol: 'social',
          title: t('Social Media & Plattformen', 'Social media & platforms'),
          copy: t('Bewertungen, Netzwerke und Kontaktwege', 'Reviews, networks and contact channels'),
          available: Boolean(window.SmoofSocialPlatformTools)
        },
        {
          id: 'custom-text',
          symbol: 'text',
          title: t('Text hinzufügen', 'Add text'),
          copy: t('Bis zu drei zusätzliche Textbereiche', 'Up to three additional text areas'),
          available: Boolean(window.SmoofCustomTextTools && customTextCount < 3)
        },
        {
          id: 'custom-pictogram',
          symbol: 'arrows',
          title: t('Piktogramm hinzufügen', 'Add pictogram'),
          copy: t('Bis zu drei frei platzierbare Piktogramme', 'Up to three freely placeable pictograms'),
          available: Boolean(window.SmoofCustomPictogramTools && customPictogramCount < 3)
        }
      ].filter(item => item.available);
      if (!items.length) {
        return `<div data-smoof-ui-locked-note>${t('Zurzeit sind keine zusätzlichen Elemente verfügbar.', 'No additional elements are currently available.')}</div>`;
      }
      return `<div data-smoof-ui-add-list>${items.map(item => `<button type="button" data-smoof-ui-add-item data-smoof-ui-action="add-open:${item.id}"${item.disabled ? ' disabled aria-disabled="true"' : ''}><span data-smoof-ui-add-symbol>${icon(item.symbol)}</span><span data-smoof-ui-add-copy><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.copy)}</small></span><span data-smoof-ui-add-arrow>→</span></button>`).join('')}</div>`;
    }
    if (descriptor.kind === 'templates') {
      const library = window.SmoofTemplateLibrary;
      const language = root.lang.toLowerCase().startsWith('en') ? 'en' : 'de';
      const languageGate = library?.languageSelectionEnabled === true;
      const languages = library?.listLanguages?.() || [];
      const selectedLanguage = languages.find(item => item.id === library?.selectedLanguage);
      if (languageGate && !selectedLanguage) {
        const options = languages.map(item => {
          const countLabel = item.count === 1 ? t('Vorlage', 'template') : t('Vorlagen', 'templates');
          return '<button type="button" data-smoof-ui-language-option data-smoof-ui-action="template-language:' + escapeHtml(item.id) + '"><span><strong>' +
            escapeHtml(item[language] || item.de) + '</strong><small>' + item.count + ' ' + countLabel +
            '</small></span><span aria-hidden="true">→</span></button>';
        }).join('');
        return '<div data-smoof-ui-language-step><strong>' + t('Sprache der Vorlage wählen', 'Choose the template language') +
          '</strong><p>' + t('In welcher Sprache soll Ihr Design sein?', 'Which language should your design use?') +
          '</p><div data-smoof-ui-language-options>' + options + '</div>' +
          (!options ? '<p role="status">' + t('Zurzeit sind keine Vorlagensprachen verfügbar.', 'No template languages are currently available.') + '</p>' : '') + '</div>';
      }
      const languageHeading = languageGate
        ? '<div data-smoof-ui-selected-language><span><small>' + t('Vorlagensprache', 'Template language') + '</small><strong>' +
          escapeHtml(selectedLanguage[language] || selectedLanguage.de) + '</strong></span><button type="button" data-smoof-ui-action="template-language-change">' +
          t('Sprache ändern', 'Change language') + '</button></div>' : '';
      const categories = library?.listCategories?.() || library?.categories || [];
      if (templateCategory && !categories.some(category => category.id === templateCategory)) templateCategory = '';
      const available = library?.list?.(templateCategory) || [];
      const categoryButtons = [
        { id: '', de: 'Alle', en: 'All' },
        ...categories
      ].map(category => `<button type="button" data-smoof-ui-template-category="${escapeHtml(category.id)}" data-smoof-ui-action="template-category:${escapeHtml(category.id)}" data-active="${String(templateCategory === category.id)}">${escapeHtml(category[language] || category.de || category.id)}</button>`).join('');
      const cards = available.map(template => {
        const title = typeof template.title === 'object' ? template.title[language] || template.title.de : template.title;
        const description = typeof template.description === 'object' ? template.description[language] || template.description.de : template.description;
        const preview = template.preview
          ? `<img src="${escapeHtml(template.preview)}" alt="" loading="lazy">`
          : `<span data-smoof-ui-template-placeholder>${icon('templates')}</span>`;
        return `<article data-smoof-ui-template-card>${preview}<div><strong>${escapeHtml(title)}</strong>${description ? `<small>${escapeHtml(description)}</small>` : ''}<button type="button" data-smoof-ui-action="template-apply:${escapeHtml(template.id)}">${t('Vorlage verwenden', 'Use template')}</button></div></article>`;
      }).join('');
      const customersEmpty = templateCategory === 'customers';
      const emptyTitle = languageGate ? t('Noch keine Vorlagen', 'No templates yet') : customersEmpty ? t('Kundenvorlagen folgen', 'Customer templates coming soon') : t('Vorlagen werden vorbereitet', 'Templates are being prepared');
      const emptyCopy = languageGate
        ? t('Für diese Sprache und Auswahl sind derzeit keine passenden Vorlagen verfügbar.', 'No matching templates are currently available for this language and selection.')
        : customersEmpty
        ? t('Hier finden Sie künftig die kundenspezifischen Vorlagen Ihres Partners.', 'Your partner’s customer-specific templates will appear here.')
        : t('Die ersten SMOOF-Designs erscheinen hier, sobald sie hinterlegt sind.', 'The first SMOOF designs will appear here as soon as they are added.');
      return `${languageHeading}<div data-smoof-ui-template-categories>${categoryButtons}</div>${cards ? `<div data-smoof-ui-template-grid>${cards}</div>` : `<div data-smoof-ui-template-empty>${icon('templates')}<strong>${emptyTitle}</strong><span>${emptyCopy}</span></div>`}`;
    }
    if (descriptor.kind === 'social-library') {
      return socialPlatformGrid() +
        `<div data-smoof-ui-locked-note>${t('Jedes Logo wird unabhängig positioniert. Originalvarianten behalten ihre Markenfarben.', 'Each logo is positioned independently. Original variants retain their brand colours.')}</div>`;
    }
    if (descriptor.kind === 'social-platform') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(selectedId);
      if (!object) return '';
      return (window.SmoofSocialPlatformLibrary?.get(selectedId)?.original ? originalColourRow(object, 'social-original-colours') : hexColorRow(t('Farbe', 'Colour'), 'social-platform-color', object.color)) +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="social-platform-size-minus">−</button><span data-smoof-ui-social-scale>${Math.round(object.scale * 100)}%</span><button type="button" data-smoof-ui-action="social-platform-size-plus">+</button></div>`) +
        row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="social-platform-opacity-minus">−</button><span data-smoof-ui-social-opacity>${Math.round(object.opacity * 100)}%</span><button type="button" data-smoof-ui-action="social-platform-opacity-plus">+</button></div>`) +
        resetButton('social-platform') +
        `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="social-platform-delete">${icon('trash')} ${t('Logo entfernen', 'Remove logo')}</button></div>`;
    }
    if (descriptor.kind === 'downloads') {
      return row(t('Öffnen', 'Open'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="open-design"><span>${t('Design-Datei öffnen', 'Open design file')}</span><small>.smoofdesign →</small></button>`) +
        row(t('Design', 'Design'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-design"><span>${t('Design-Datei herunterladen', 'Download design file')}</span><small>.smoofdesign ↓</small></button>`) +
        row(t('Mockup', 'Mockup'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-mockup"><span>${t('Mockup herunterladen', 'Download mockup')}</span><small>PNG ↓</small></button>`) +
        row(t('Freigabe', 'Approval'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-proof"><span>${t('Proof-PDF herunterladen', 'Download proof PDF')}</span><small>PDF ↓</small></button>`) +
        row(t('Produktion', 'Production'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-production"><span>${t('Produktions-PDF herunterladen', 'Download production PDF')}</span><small>PDF ↓</small></button>`);
    }
    if (descriptor.kind === 'qr') {
      const qr = window.SmoofQrGeometryTools?.getState?.() || { scale: 1 };
      const diameter = Number(window.SmoofProductVariant?.get?.()?.diameterMm) || 80;
      const sizeMm = Number(window.SmoofQrGeometryTools?.sizeMm?.(diameter)) || (29 * Number(qr.scale || 1));
      const unsafe = sizeMm < 18;
      const backingLocked = window.SmoofQrGeometryTools?.isBackingLocked?.() === true;
      const codeColorLocked = window.SmoofQrGeometryTools?.isCodeColorLocked?.() === true;
      const qrVisible = qr.visible !== false;
      const backingConfigured = !backingLocked && qr.backingVisible !== false;
      const backingVisible = qrVisible && backingConfigured;
      const backingDisabled = backingLocked || !qrVisible;
      return row('QR-Code', `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="qr-visibility-toggle"><span>${qrVisible ? t('Sichtbar', 'Visible') : t('Ausgeblendet', 'Hidden')}</span><small>${qrVisible ? t('Ausblenden', 'Hide') : t('Einblenden', 'Show')} →</small></button>`) +
        hexColorRow(t('QR-Code-Farbe', 'QR code colour'), 'qr-code-color', codeColorLocked ? '#000000' : (qr.codeColor || '#000000'), codeColorLocked) +
        row(t('Hintergrundfläche', 'Backing panel'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="qr-backing-toggle"${backingDisabled ? ' disabled' : ''}><span>${backingVisible ? t('Sichtbar', 'Visible') : t('Ausgeblendet', 'Hidden')}</span><small>${backingLocked ? t('Bei DOT ME fest transparent', 'Locked transparent for DOT ME') : !qrVisible ? t('Mit QR-Code ausgeblendet', 'Hidden with QR code') : backingConfigured ? t('Ausblenden', 'Hide') : t('Einblenden', 'Show')} →</small></button>`) +
        (backingVisible ? hexColorRow(t('Flächenfarbe', 'Panel colour'), 'qr-backing-color', qr.backingColor || '#FFFFFF') : '') +
        `<div data-smoof-ui-locked-note data-smoof-ui-qr-contrast-note><strong>${t('Hinweis zur Scanbarkeit', 'Scanning guidance')}</strong><br>${t('Ein zu geringer Kontrast zwischen QR-Code und Hintergrund kann die Scanbarkeit auf einigen Geräten beeinträchtigen. Für die bestmögliche Scanbarkeit wird ein hoher Kontrast empfohlen, z. B. ein schwarzer QR-Code auf weißem Hintergrund.', 'Low contrast between the QR code and its background may affect scanning on some devices. For the best scan reliability, use high contrast, such as a black QR code on a white background.')}</div>` +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="qr-scale-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-qr-scale>${Math.round(Number(qr.scale || 1) * 100)}%</span><button type="button" data-smoof-ui-action="qr-scale-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`) +
        `<div data-smoof-ui-locked-note${unsafe ? ' data-smoof-ui-warning="true"' : ''}><strong>${sizeMm.toFixed(1).replace('.', ',')} mm</strong>${unsafe
          ? t(' Sehr kleine QR-Codes können je nach Druck und Endgerät schlechter scanbar sein.', ' Very small QR codes may be harder to scan depending on print quality and device.')
          : t(' Wird der QR-Code ausgeblendet, verschwindet auch seine Fläche. Die Fläche kann separat ausgeblendet werden, ohne den QR-Code zu verbergen.', ' Hiding the QR code also hides its panel. The panel can be hidden separately without hiding the QR code.')}${codeColorLocked
            ? t(' Lasergravur gibt den QR-Code technisch bedingt immer schwarz aus.', ' Laser engraving always outputs the QR code in black.')
            : ''}</div>` +
        resetButton('qr');
    }
    if (!source) return `<div data-smoof-ui-locked-note>${t('Die Einstellungen dieses Elements sind momentan nicht verfügbar.', 'This element’s settings are currently unavailable.')}</div>`;
    if (descriptor.kind === 'custom-text') {
      const state = window.SmoofCustomTextTools?.getState?.(selectedId);
      if (!state) return '';
      const customFont = customFontSelected(selectedId);
      const rangeStyle=window.SmoofRichText?.selectedStyle?.(selectedId);
      const styles = sharedFontStyleOptions(rangeStyle?.fontStyle||state.fontStyle, customFont, rawFontForItem(selectedId));
      return richSelectionRow(selectedId) + row(t('Schrift', 'Font'), fontButton(fontForItem(selectedId))) +
        row(t('Schnitt', 'Style'), `<select data-smoof-ui-select="custom-text-style" aria-label="${t('Schriftschnitt', 'Font style')}"${customFont ? ' disabled' : ''}>${styles}</select>`) +
        hexColorRow(t('Farbe', 'Colour'), 'custom-text-color', rangeStyle?.color||state.color) +
        textRotationRow(state.rotation) +
        sizeRow('custom-text') +
        letterSpacingRow(state.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-toggle"><span>${state.pillVisible ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${state.pillVisible ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (state.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', state.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', state.pillFillColor) +
          row(t('Füllung', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-fill-toggle"><span>${state.pillFillVisible ? t('Farbig', 'Coloured') : t('Transparent', 'Transparent')}</span><small>${state.pillFillVisible ? t('Transparent schalten', 'Make transparent') : t('Farbe verwenden', 'Use colour')} →</small></button>`) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(state.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(state.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(state.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="custom-text-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="custom-text-delete">${icon('trash')} ${t('Text entfernen', 'Remove text')}</button></div>`;
    }
    if (descriptor.kind === 'custom-pictogram') {
      const state = window.SmoofCustomPictogramTools?.getState?.(selectedId);
      if (!state) return '';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
      const isRaster = iconRecord?.raster === true;
      return customPictogramRow(state, selectedId) +
        (isRaster ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="custom-pictogram-color-mode"><span>${state.colorize ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${state.colorize ? t('Original verwenden', 'Use original') : t('Einfarbig färben', 'Use single colour')} →</small></button>`) : '') +
        (!isRaster || state.colorize ? hexColorRow(t('Farbe', 'Colour'), 'custom-pictogram-color', state.color) : '') +
        row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="custom-pictogram-rotation-minus">−</button><span data-smoof-ui-custom-pictogram-rotation>${Math.round(state.rotation)}°</span><button type="button" data-smoof-ui-action="custom-pictogram-rotation-plus">+</button></div>`) +
        sizeRow('custom-pictogram') +
        row(t('Spiegelung', 'Mirroring'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="custom-pictogram-mirror"><span>${state.mirrored ? t('Gespiegelt', 'Mirrored') : t('Original', 'Original')}</span><small>${t('Horizontal spiegeln', 'Mirror horizontally')} →</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="custom-pictogram-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="custom-pictogram-delete">${icon('trash')} ${t('Piktogramm entfernen', 'Remove pictogram')}</button></div>`;
    }
    if (descriptor.kind === 'text') {
      const index = selectedId.split('-')[1];
      const currentFont = fontForItem(selectedId);
      const rangeStyle=window.SmoofRichText?.selectedStyle?.(selectedId);
      const customFont = customFontSelected(selectedId);
      const pill = window.SmoofTextTools?.getPillState?.(Number(index)) || { pillVisible: false, pillFillVisible: false, pillStrokeColor: '#000000', pillFillColor: '#ffffff', pillStrokeWidth: 0.05, pillPaddingX: 0.45, pillPaddingY: 0.22 };
      return richSelectionRow(selectedId) + row(t('Schrift', 'Font'), fontButton(currentFont)) +
        (rangeStyle ? row(t('Schnitt','Style'), `<select data-smoof-ui-select="text-style" aria-label="${t('Schriftschnitt','Font style')}"${customFont?' disabled':''}>${sharedFontStyleOptions(rangeStyle.fontStyle,customFont,rawFontForItem(selectedId))}</select>`) : styleRow('text-style', `[data-smoof-text-style-select="${index}"]`, customFont)) +
        (rangeStyle ? hexColorRow(t('Farbe','Colour'),'text-color',rangeStyle.color) : sourceHexColorRow(t('Farbe', 'Colour'), 'text-color', `[data-smoof-text-color-input="${index}"]`)) +
        textRotationRow(pill.rotation) +
        sizeRow('text') +
        letterSpacingRow(pill.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-toggle"><span>${pill.pillVisible ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${pill.pillVisible ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (pill.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', pill.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', pill.pillFillColor) +
          row(t('Füllung', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-fill-toggle"><span>${pill.pillFillVisible ? t('Farbig', 'Coloured') : t('Transparent', 'Transparent')}</span><small>${pill.pillFillVisible ? t('Transparent schalten', 'Make transparent') : t('Farbe verwenden', 'Use colour')} →</small></button>`) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(pill.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(pill.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(pill.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        resetButton('text');
    }
    if (descriptor.kind === 'logo') {
      const logo = window.SmoofLogoTools?.getState?.() || { hasLogo: false, fileName: '' };
      const logoCopy = window.SmoofLogoCopyTools?.getState?.() || { enabled: false };
      const logoCopyReady = Boolean(window.SmoofLogoCopyTools);
      const inverted = window.SmoofLogoInvertTools?.get?.('logo') === true;
      return (laserVectorLogoRequired()
          ? `<div data-smoof-ui-locked-note><strong>${t('SVG erforderlich', 'SVG required')}</strong><br>${t('Für die Lasergravur können ausschließlich Vektorlogos im SVG-Format hochgeladen werden.', 'Laser engraving only accepts vector logos in SVG format.')}</div>`
          : '') + sizeRow('logo') +
        (logo.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')} →</small></button>`) : '') +
        (logo.hasLogo && window.SmoofLogoCropTools?.canCrop?.() ? row(t('Ausschnitt', 'Crop'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-crop"><span>${t('Logo zuschneiden', 'Crop logo')}</span><small>${t('Bearbeiten', 'Edit')} →</small></button>`) : '') +
        logoColourRows('logo') +
        (logo.hasLogo ? logoBackgroundRows('logo') : '') +
        row(t('Duplikat', 'Duplicate'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="add-open:logo-copy"${logo.hasLogo && logoCopyReady ? '' : ' disabled aria-disabled="true"'}><span>${logoCopy.enabled ? t('Duplikat bearbeiten', 'Edit duplicate') : t('Duplizieren', 'Duplicate')}</span><small>${logoCopy.enabled ? t('Öffnen', 'Open') : !logoCopyReady ? t('Lädt …', 'Loading …') : logo.hasLogo ? '' : t('Logo hochladen', 'Upload logo')} →</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button${logo.hasLogo ? ' data-smoof-ui-danger' : ''} data-smoof-ui-action="logo-file">${icon(logo.hasLogo ? 'trash' : 'image')} ${logo.hasLogo ? t('Entfernen', 'Remove') : t('Upload', 'Upload')}</button></div>`;
    }
    if (descriptor.kind === 'logo-copy') {
      const logoCopy = window.SmoofLogoCopyTools?.getState?.() || { enabled: false, hasLogo: false };
      const inverted = window.SmoofLogoInvertTools?.get?.('logo-copy') === true;
      return sizeRow('logo-copy') +
        (logoCopy.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-copy-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')} →</small></button>`) : '') +
        logoColourRows('logo-copy') +
        logoBackgroundRows('logo-copy') +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-copy-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="logo-copy-toggle">${icon('trash')} ${t('Duplikat entfernen', 'Remove duplicate')}</button></div>`;
    }
    if (descriptor.kind === 'logo-duplicate') {
      const secondLogo = window.SmoofLogoDuplicateTools?.getState?.() || { hasLogo: false, fileName: '' };
      const inverted = window.SmoofLogoInvertTools?.get?.('logo-2') === true;
      return (laserVectorLogoRequired()
          ? `<div data-smoof-ui-locked-note><strong>${t('SVG erforderlich', 'SVG required')}</strong><br>${t('Für die Lasergravur können ausschließlich Vektorlogos im SVG-Format hochgeladen werden.', 'Laser engraving only accepts vector logos in SVG format.')}</div>`
          : '') + sizeRow('logo-2') +
        (secondLogo.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-2-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')} →</small></button>`) : '') +
        logoColourRows('logo-2') +
        (secondLogo.hasLogo ? logoBackgroundRows('logo-2') : '') +
        opacityRow() + `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-2-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button${secondLogo.hasLogo ? ' data-smoof-ui-danger' : ''} data-smoof-ui-action="logo-2-file">${icon(secondLogo.hasLogo ? 'trash' : 'image')} ${secondLogo.hasLogo ? t('Entfernen', 'Remove') : t('Upload', 'Upload')}</button></div>`;
    }
    if (descriptor.kind === 'arrow') {
      const side = selectedId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side) || { rotation: 0, count: 4, symbol: 'dots', labelVisible: true, arrowColor: '#000000', labelColor: '#000000' };
      const isOriginalArrow = state.symbol === 'dots';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
      const isRasterPictogram = iconRecord?.raster === true;
      return pictogramRow(state, side) +
        (isRasterPictogram ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pictogram-color-mode"><span>${state.colorize ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${state.colorize ? t('Original verwenden', 'Use original') : t('Einfarbig färben', 'Use single colour')} →</small></button>`) : '') +
        (!isRasterPictogram || state.colorize ? hexColorRow(t('Piktogramm', 'Pictogram'), 'arrow-color', state.arrowColor) : '') +
        (isOriginalArrow ? hexColorRow(t('TAP/SCAN', 'TAP/SCAN'), 'arrow-label-color', state.labelColor) : '') +
        row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-rotation-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-arrow-rotation>${Math.round(state.rotation)}°</span><button type="button" data-smoof-ui-action="arrow-rotation-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`) +
        sizeRow('arrow-scale') +
        (isOriginalArrow ? row(t('Pfeilanzahl', 'Arrow count'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-count-minus" aria-label="${t('Weniger Pfeile', 'Fewer arrows')}">−</button><span data-smoof-ui-arrow-count>${state.count}</span><button type="button" data-smoof-ui-action="arrow-count-plus" aria-label="${t('Mehr Pfeile', 'More arrows')}">+</button></div>`) : '') +
        (isOriginalArrow ? row(t('TAP/SCAN', 'TAP/SCAN'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="arrow-label"><span>${state.labelVisible ? t('Text sichtbar', 'Label visible') : t('Text ausgeblendet', 'Label hidden')}</span><small>${state.labelVisible ? t('Ausblenden', 'Hide') : t('Einblenden', 'Show')} →</small></button>`) : '') +
        opacityRow() +
        resetButton('arrows');
    }
    if (descriptor.kind === 'number') {
      const currentFont = fontForItem('table-number');
      const numberState = window.SmoofNumberHistory?.getState?.() || { letterSpacing: 0 };
      return row(t('Schrift', 'Font'), fontButton(currentFont)) +
        styleRow('number-style', '[data-smoof-number-style-select]', customFontSelected('table-number')) +
        sourceHexColorRow(t('Farbe', 'Colour'), 'number-color', '[data-smoof-number-color-input]') +
        textRotationRow(numberState.rotation) +
        sizeRow('number') +
        letterSpacingRow(numberState.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-toggle"><span>${numberState.pillVisible ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${numberState.pillVisible ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (numberState.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', numberState.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', numberState.pillFillColor) +
          row(t('Füllung', 'Fill'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pill-fill-toggle"><span>${numberState.pillFillVisible ? t('Farbig', 'Coloured') : t('Transparent', 'Transparent')}</span><small>${numberState.pillFillVisible ? t('Transparent schalten', 'Make transparent') : t('Farbe verwenden', 'Use colour')} →</small></button>`) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(numberState.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(numberState.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(numberState.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        resetButton('number');
    }
    if (descriptor.kind === 'brand') return colorRow(t('Farbe', 'Colour'), 'brand-color', '[data-smoof-brand-color-input]') + opacityRow();
    if (descriptor.kind === 'nfc') {
      const nfc = window.SmoofNfcTools?.getState?.() || {
        iconColor: '#0d0d0d',
        circleColor: '#ffffff',
        circleTransparent: false
      };
      const nfcColor = (label, name, value) => colorRowValue(label, name, value);
      return nfcColor(t('Symbol', 'Icon'), 'nfc-icon-color', nfc.iconColor) +
        nfcColor(t('Kreisfläche', 'Circle fill'), 'nfc-circle-color', nfc.circleColor) +
        row(t('Hintergrund', 'Background'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="nfc-transparency"><span>${nfc.circleTransparent ? t('Transparent', 'Transparent') : t('Farbig', 'Coloured')}</span><small>${nfc.circleTransparent ? t('Farbig schalten', 'Use colour') : t('Transparent schalten', 'Make transparent')} →</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-locked-note>${t('Im QR-Code rastet das NFC-Symbol ausschließlich exakt in der Mitte ein. Außerhalb der QR-Schutzzone ist es frei platzierbar.', 'Inside the QR code the NFC icon snaps exactly to the centre. Outside the QR protection zone it can be positioned freely.')}</div>` +
        resetButton('nfc');
    }
    if (descriptor.kind === 'payments') {
      const payments = window.SmoofPaymentTools?.getState?.() || {
        selected: [], color: '#000000', scale: 1
      };
      return row(t('Anbieter', 'Providers'), paymentProviderGrid(payments)) +
        (payments.selected?.some(id => window.SmoofPaymentProviderLibrary?.get(id)?.original) ? originalColourRow(payments, 'payment-original-colours') : '') +
        hexColorRow(t('Einfarbige Logos', 'Single-colour logos'), 'payment-color', payments.color) +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="payment-size-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-payment-scale>${Math.round(payments.scale * 100)}%</span><button type="button" data-smoof-ui-action="payment-size-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`) +
        opacityRow() +
        resetButton('payment');
    }
    if (descriptor.kind === 'background') {
      if (backgroundLocked) {
        return `<div data-smoof-ui-locked-note><strong>${t('Für DOT ME gesperrt', 'Locked for DOT ME')}</strong><br>${t('Die Edelstahloberfläche gehört zum Produkt und kann nicht verändert, eingefärbt oder durch ein Bild ersetzt werden.', 'The stainless-steel surface belongs to the product and cannot be recoloured or replaced by an image.')}</div>`;
      }
      const bridgedImage = window.SmoofBackgroundImageBridge?.getState?.();
      const image = (bridgedImage?.hasImage ? bridgedImage : window.SmoofBackgroundImageTools?.getState?.()) || {
        hasImage: false,
        fileName: ''
      };
      const gradient = window.SmoofBackgroundGradientTools?.getState?.() || {
        enabled: false,
        color1: '#000000',
        color2: '#ffffff',
        angle: 0,
        overlayEnabled: false,
        overlayColor: '#000000',
        overlayOpacity: 0.3
      };
      const fileName = image.fileName || t('Kein Bild ausgewählt', 'No image selected');
      const imagePositionX = Math.max(0, Math.min(1, Number.isFinite(Number(image.positionX)) ? Number(image.positionX) : 0.5));
      const imagePositionY = Math.max(0, Math.min(1, Number.isFinite(Number(image.positionY)) ? Number(image.positionY) : 0.5));
      const imageScale = Math.max(0.05, Math.min(3, Number(image.scale) || 1));
      const safeFileName = escapeHtml(fileName);
      return backgroundColorRow(t('Grundfarbe', 'Base colour')) +
        opacityRow() +
        row(t('Verlauf', 'Gradient'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-gradient-toggle"><span>${gradient.enabled ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${gradient.enabled ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (gradient.enabled
          ? hexColorRow(t('Startfarbe', 'Start colour'), 'background-gradient-color-1', gradient.color1) +
            hexColorRow(t('Endfarbe', 'End colour'), 'background-gradient-color-2', gradient.color2) +
            row(t('Richtung', 'Direction'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-gradient-angle-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-gradient-angle>${Math.round(gradient.angle)}°</span><button type="button" data-smoof-ui-action="background-gradient-angle-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`)
          : '') +
        row(t('Bild', 'Image'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-upload"><span>${image.hasImage ? t('Bild ersetzen', 'Replace image') : t('Bild hochladen', 'Upload image')}</span><small>PNG, JPG, WebP →</small></button>`) +
        `<div data-smoof-ui-locked-note><strong data-smoof-ui-file-name title="${safeFileName}">${safeFileName}</strong>${t('Das Bild füllt die Druckfläche. Größe und Ausschnitt können angepasst werden.', 'The image fills the print area. Size and crop can be adjusted.')}</div>` +
        (image.hasImage
          ? row(t('Bildgröße', 'Image size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-scale-minus">−</button><span>${Math.round(imageScale * 100)}%</span><button type="button" data-smoof-ui-action="background-image-scale-plus">+</button></div>`) +
            row(t('Horizontal', 'Horizontal'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-x-minus">−</button><span>${Math.round((imagePositionX - 0.5) * 200)}%</span><button type="button" data-smoof-ui-action="background-image-x-plus">+</button></div>`) +
            row(t('Vertikal', 'Vertical'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-y-minus">−</button><span>${Math.round((imagePositionY - 0.5) * 200)}%</span><button type="button" data-smoof-ui-action="background-image-y-plus">+</button></div>`) +
            `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="background-image-position-reset">${icon('reset')} ${t('Bildausschnitt zurücksetzen', 'Reset image crop')}</button></div>`
          : '') +
        row(t('Overlay', 'Overlay'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-overlay-toggle"><span>${gradient.overlayEnabled ? t('Aktiv', 'Active') : t('Aus', 'Off')}</span><small>${gradient.overlayEnabled ? t('Deaktivieren', 'Disable') : t('Aktivieren', 'Enable')} →</small></button>`) +
        (gradient.overlayEnabled
          ? hexColorRow(t('Overlayfarbe', 'Overlay colour'), 'background-overlay-color', gradient.overlayColor) +
            row(t('Overlaystärke', 'Overlay strength'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-overlay-opacity-minus" aria-label="${t('Overlay reduzieren', 'Reduce overlay')}">−</button><span data-smoof-ui-overlay-opacity>${Math.round(gradient.overlayOpacity * 100)}%</span><button type="button" data-smoof-ui-action="background-overlay-opacity-plus" aria-label="${t('Overlay verstärken', 'Increase overlay')}">+</button></div>`)
          : '') +
        (image.hasImage
          ? `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="background-remove">${icon('trash')} ${t('Hintergrundbild entfernen', 'Remove background image')}</button></div>`
          : '');
    }
    return '';
  }

  function panelHead(descriptor, mode) {
    const hideable = Boolean(descriptor && descriptor.hideable);
    const start = panelRouteStack.at(-1)?.to === selectedId
      ? `<button type="button" data-smoof-ui-route-back aria-label="${t('Zurück', 'Back')}">${icon('back')}</button>`
      : mode === 'layers-detail'
      ? `<button type="button" data-smoof-ui-panel-back aria-label="${t('Zurück', 'Back')}">${icon('back')}</button>`
      : `<span data-smoof-ui-panel-symbol>${icon(descriptor.symbol)}</span>`;
    const visibility = hideable
      ? `<button type="button" data-smoof-ui-panel-visibility data-smoof-ui-action="item-visibility" aria-label="${isVisible(selectedId) ? t('Element ausblenden', 'Hide element') : t('Element einblenden', 'Show element')}">${icon(isVisible(selectedId) ? 'eye' : 'eyeOff')}</button>`
      : '';
    return `<header data-smoof-ui-panel-head data-has-visibility="${hideable}">${start}<span><strong data-smoof-ui-panel-title>${descriptor.title}</strong><small data-smoof-ui-panel-copy>${descriptor.copy}</small></span>${visibility}<button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button></header>`;
  }

  function installPanelScrollAffordance(panel) {
    panelScrollCleanups.get(panel)?.();
    panelScrollCleanups.delete(panel);

    const scroller = panel.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    if (!scroller) return;

    const footer = document.createElement('div');
    footer.dataset.smoofUiScrollAffordance = 'true';
    footer.innerHTML = `<button type="button" data-smoof-ui-scroll-more aria-label="${t('Weitere Einstellungen anzeigen', 'Show more settings')}"><span>${t('Mehr', 'More')}</span><span aria-hidden="true">↓</span></button>`;
    panel.appendChild(footer);

    const button = footer.querySelector('[data-smoof-ui-scroll-more]');
    const update = () => {
      const maximum = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      const scrollable = maximum > 2;
      const hasMore = scrollable && scroller.scrollTop < maximum - 2;
      panel.dataset.smoofUiScrollable = String(scrollable);
      panel.dataset.smoofUiHasMore = String(hasMore);
      button.tabIndex = hasMore ? 0 : -1;
      button.setAttribute('aria-hidden', String(!hasMore));
    };

    const scrollMore = () => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollBy({
        top: Math.max(80, Math.round(scroller.clientHeight * 0.72)),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    };

    scroller.addEventListener('scroll', update, { passive: true });
    button.addEventListener('click', scrollMore);

    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(update)
      : null;
    resizeObserver?.observe(scroller);
    if (scroller.firstElementChild) resizeObserver?.observe(scroller.firstElementChild);

    panelScrollCleanups.set(panel, () => {
      scroller.removeEventListener('scroll', update);
      button.removeEventListener('click', scrollMore);
      resizeObserver?.disconnect();
    });

    requestAnimationFrame(() => requestAnimationFrame(update));
  }

  function capturePanelScroll(panel, key) {
    const scroller = panel?.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    const sameView = panel?.dataset.smoofUiScrollKey === key;
    return {
      key,
      top: sameView && scroller ? Math.max(0, scroller.scrollTop) : 0
    };
  }

  function restorePanelScroll(panel, snapshot) {
    if (!panel || !snapshot) return;
    panel.dataset.smoofUiScrollKey = snapshot.key;
    const scroller = panel.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    if (!scroller) return;

    const restore = () => {
      if (!scroller.isConnected || panel.dataset.smoofUiScrollKey !== snapshot.key) return;
      const maximum = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      scroller.scrollTop = Math.min(snapshot.top, maximum);
    };

    restore();
    requestAnimationFrame(restore);
  }

  function activePercentageInputIn(panel) {
    const active = document.activeElement;
    return Boolean(
      panel &&
      active instanceof HTMLInputElement &&
      active.matches('[data-smoof-percent-input]') &&
      panel.contains(active)
    );
  }

  // One mounted subview: preserve the parent's DOM, scroll and selected owner.
  let panelSubview = null;
  function leavePanelSubview(cancel = false) {
    const view = panelSubview;
    if (!view) return;
    if (cancel) {
      if (view.onBack?.() === false) return;
      if (panelSubview !== view) return;
    }
    panelSubview = null;
    view.element.removeAttribute('data-smoof-panel-embedded');
    if (view.next?.parentNode === view.parent) view.parent.insertBefore(view.element, view.next);
    else view.parent?.append(view.element);
    view.panel.replaceChildren(...view.nodes);
    delete view.panel.dataset.smoofUiSubview;
    delete root.dataset.smoofPanelSubview;
    view.panel.style.height = view.height;
    view.panel.dataset.open = 'true';
    view.scroll.forEach(([node, top]) => { node.scrollTop = top; });
    view.element.querySelector('[aria-modal]')?.setAttribute('aria-modal', 'true');
    animatePanel(view.panel, 'back');
    requestAnimationFrame(() => {
      view.focus?.focus?.({preventScroll:true});
      positionContext(); positionLayers();
    });
  }
  const panelTransitionTimers = new WeakMap();
  const panelRenderLocks = new WeakMap();
  function deferPanelRender(panel) {
    const lock = panelRenderLocks.get(panel);
    if (!lock) return false;
    if (lock.item === selectedId && (panel !== layers || lock.page === layersPage) && panel.dataset.open === 'true' && personalizedDesignSelected()) {
      lock.pending = true;
      return true;
    }
    // A different selection or closed editor must take effect immediately.
    clearTimeout(panelTransitionTimers.get(panel));
    panelRenderLocks.delete(panel);
    delete panel.dataset.smoofUiTransition;
    return false;
  }
  function animatePanel(panel, direction = 'forward') {
    if (panel === layers) clearTimeout(layersTransitionTimer);
    clearTimeout(panelTransitionTimers.get(panel));
    delete panel.dataset.smoofUiTransition;
    panelRenderLocks.delete(panel);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Use exactly the same direction, distance and timing as the layer drill-in.
    void panel.offsetWidth;
    panel.dataset.smoofUiTransition = direction;
    const lock = {item:selectedId, page:layersPage, pending:false};
    panelRenderLocks.set(panel, lock);
    panelTransitionTimers.set(panel, setTimeout(() => {
      delete panel.dataset.smoofUiTransition;
      if (panelRenderLocks.get(panel) !== lock) return;
      panelRenderLocks.delete(panel);
      if (lock.pending && !panelSubview && lock.item === selectedId && panel.dataset.open === 'true') {
        // Refresh once after the slide, without restarting animation on new nodes.
        if (panel === layers) renderLayers(); else renderContext();
      }
    }, mobile.matches ? 570 : 480));
  }
  function mountPanelSubview({element, title, kind, onBack}) {
    const panel = layersOpen ? layers : context;
    if (!panel || !element || !selectedId) return null;
    if (panelSubview) leavePanelSubview(true);
    if (panelSubview) return null;
    const view = {panel,element,kind,onBack,item:selectedId,parent:element.parentNode,next:element.nextSibling,nodes:[...panel.childNodes],height:panel.style.height,focus:document.activeElement,scroll:[...panel.querySelectorAll('*')].filter(n=>n.scrollTop).map(n=>[n,n.scrollTop])};
    panelSubview=view;
    const currentHeight=panel.getBoundingClientRect().height;
    panel.dataset.open='true';
    panel.dataset.smoofUiSubview=kind;
    root.dataset.smoofPanelSubview=kind;
    // Keep the same footprint where possible; the subview's own content scrolls.
    panel.style.height=`${Math.min(Math.max(currentHeight, mobile.matches ? 440 : 510), innerHeight * (mobile.matches ? .78 : .72),560)}px`;
    const head=document.createElement('header');head.dataset.smoofUiPanelHead='';
    head.innerHTML=`<button type="button" data-smoof-subview-back aria-label="${t('Zurück','Back')}">${icon('back')}</button><span><strong data-smoof-ui-panel-title>${escapeHtml(title)}</strong><small data-smoof-ui-panel-copy>${escapeHtml(descriptors()[selectedId]?.title || '')}</small></span><button type="button" data-smoof-subview-close aria-label="${t('Zurück zur Ebene','Back to layer')}">${icon('close')}</button>`;
    head.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>leavePanelSubview(true)));
    const body=document.createElement('div');body.dataset.smoofSubviewBody='';
    element.dataset.smoofPanelEmbedded=kind;
    element.querySelector('[aria-modal]')?.setAttribute('aria-modal','false');
    body.append(element);panel.replaceChildren(head,body);
    animatePanel(panel);positionContext();positionLayers();
    return () => {if(panelSubview===view)leavePanelSubview(false);};
  }
  window.SmoofPanelNavigation=Object.freeze({mount:mountPanelSubview,back:()=>leavePanelSubview(true),isOpen:()=>Boolean(panelSubview)});
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&panelSubview){event.preventDefault();event.stopImmediatePropagation();leavePanelSubview(true);}
  },true);
  document.addEventListener('pointerdown',event=>{
    if(panelSubview&&!panelSubview.panel.contains(event.target)&&!event.target.closest('.smoof-font-backdrop'))leavePanelSubview(true);
  },true);
  window.addEventListener('smoof:surface-change',()=>leavePanelSubview(true));
  window.addEventListener('smoof:editor-reset-content',()=>leavePanelSubview(true));
  function embedFontPicker() {
    const element=document.querySelector('.smoof-font-backdrop[data-open="true"]');
    if(!element||panelSubview?.kind==='font')return;
    delete root.dataset.smoofFontPickerOpen;
    mountPanelSubview({element,title:t('Schrift auswählen','Choose font'),kind:'font',onBack:()=>{
      element.dataset.open='false';element.setAttribute('aria-hidden','true');
      resetFontPickerState();
    }});
  }
  const panelAnchors = new Map();
  function updatePanelAnchor(panel, anchor) {
    let skin = panelAnchors.get(panel);
    if (!skin) {
      skin = document.createElement('div');
      skin.dataset.smoofPanelAnchor = '';
      skin.setAttribute('aria-hidden', 'true');
      const shadowId = `smoof-panel-shadow-${panelAnchors.size}`;
      skin.innerHTML = `<svg data-smoof-panel-shadow aria-hidden="true"><defs><filter id="${shadowId}" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur in="SourceAlpha" stdDeviation="14"/><feOffset dy="10"/><feComponentTransfer><feFuncA type="linear" slope=".18"/></feComponentTransfer><feComposite in2="SourceAlpha" operator="out"/></filter></defs><path fill="#000" filter="url(#${shadowId})"/></svg><div data-smoof-panel-glass></div><svg aria-hidden="true"><path fill="none" stroke-width="1"/></svg>`;
      document.body.append(skin);
      panelAnchors.set(panel, skin);
    }
    const hide = () => { skin.hidden = true; delete panel.dataset.smoofUnifiedSkin; };
    const legacy = panel.dataset.smoofUiLegacyShell === 'true';
    const visible = legacy ? !panel.hidden && getComputedStyle(panel).display !== 'none' && getComputedStyle(panel).visibility !== 'hidden' : panel.dataset.open === 'true';
    skin.dataset.legacy = String(legacy);
    if (!visible || !anchor?.isConnected || !panel.getBoundingClientRect().width) return hide();
    const a = anchor.getBoundingClientRect(), b = panel.getBoundingClientRect();
    const x = a.left + a.width / 2, y = a.top + a.height / 2;
    if (x < 0 || x > innerWidth || y < 0 || y > innerHeight) return hide();
    let edge;
    if (a.right <= b.left - 5) edge = 'left';
    else if (a.left >= b.right + 5) edge = 'right';
    else if (a.bottom <= b.top - 5) edge = 'top';
    else if (a.top >= b.bottom + 5) edge = 'bottom';
    else return hide();
    // One silhouette and one backdrop sample for the body AND its pointer.
    // The outline goes around the pointer; there is no panel border across its base.
    const pad = 10, l = pad, t0 = pad, r = pad + b.width, bot = pad + b.height;
    const style = getComputedStyle(panel);
    const radius = Math.min(parseFloat(style.borderTopLeftRadius) || 22, b.width / 2, b.height / 2);
    const cx = pad + Math.max(radius + 12, Math.min(x - b.left, b.width - radius - 12));
    const cy = pad + Math.max(radius + 12, Math.min(y - b.top, b.height - radius - 12));
    let d = `M ${l + radius} ${t0}`;
    if (edge === 'top') d += ` L ${cx - 8} ${t0} L ${cx} ${t0 - 8} L ${cx + 8} ${t0}`;
    d += ` L ${r - radius} ${t0} Q ${r} ${t0} ${r} ${t0 + radius}`;
    if (edge === 'right') d += ` L ${r} ${cy - 8} L ${r + 8} ${cy} L ${r} ${cy + 8}`;
    d += ` L ${r} ${bot - radius} Q ${r} ${bot} ${r - radius} ${bot}`;
    if (edge === 'bottom') d += ` L ${cx + 8} ${bot} L ${cx} ${bot + 8} L ${cx - 8} ${bot}`;
    d += ` L ${l + radius} ${bot} Q ${l} ${bot} ${l} ${bot - radius}`;
    if (edge === 'left') d += ` L ${l} ${cy + 8} L ${l - 8} ${cy} L ${l} ${cy - 8}`;
    d += ` L ${l} ${t0 + radius} Q ${l} ${t0} ${l + radius} ${t0} Z`;
    Object.assign(skin.style, {left:`${b.left-pad}px`,top:`${b.top-pad}px`,width:`${b.width+pad*2}px`,height:`${b.height+pad*2}px`});
    const glass = skin.querySelector('[data-smoof-panel-glass]');
    const shadow = skin.firstElementChild;
    shadow.setAttribute('viewBox', `0 0 ${b.width+pad*2} ${b.height+pad*2}`);
    shadow.lastElementChild.setAttribute('d', d);
    glass.style.clipPath = `path("${d}")`;
    glass.style.background = style.getPropertyValue('--smoof-ui-panel-bg');
    const svg = skin.lastElementChild;
    svg.setAttribute('viewBox', `0 0 ${b.width+pad*2} ${b.height+pad*2}`);
    svg.firstElementChild.setAttribute('d', d);
    svg.firstElementChild.setAttribute('stroke', style.getPropertyValue('--smoof-ui-stroke').trim() || '#ddd');
    skin.dataset.edge = edge;
    skin.hidden = false;
    panel.dataset.smoofUnifiedSkin = 'true';
  }

  function renderContext() {
    if (deferPanelRender(context)) return;
    if (panelSubview) { if(panelSubview.item===selectedId)return; leavePanelSubview(true); }
    if (activePercentageInputIn(context)) return;
    if (!personalizedDesignSelected()) {
      context.dataset.open = 'false';
      return;
    }
    if (selectedId === 'guides' && context?.dataset.open === 'true' && context.dataset.smoofUiItemId === 'guides') { syncGuideSwitches(); return; }
    const descriptor = descriptors()[selectedId];
    source = descriptor ? sourceFor(selectedId) : null;
    if (!descriptor || layersOpen) {
      context.dataset.open = 'false';
      return;
    }
    if (selectedId === 'templates' && (context.dataset.open !== 'true' || context.dataset.smoofUiItemId !== 'templates')) {
      templateCategory = '';
      window.SmoofTemplateLibrary?.selectLanguage?.('', { silent: true });
    }
    const templateStep = selectedId === 'templates' ? ':' + (window.SmoofTemplateLibrary?.selectedLanguage || 'choose') : '';
    const scrollSnapshot = capturePanelScroll(context, `context:${selectedId}${templateStep}`);
    context.innerHTML = panelHead(descriptor, 'context') + `<div data-smoof-ui-panel-body>${detailBody(descriptor)}</div>`;
    context.dataset.smoofUiItemId = selectedId;
    context.dataset.open = 'true';
    installPanelScrollAffordance(context);
    restorePanelScroll(context, scrollSnapshot);
    requestAnimationFrame(() => {
      positionContext();
    });
  }

  function layerRows() {
    const customTextIds = (window.SmoofCustomTextTools?.getStates?.() || []).filter(state => state.enabled).map(state => state.id);
    const customPictogramIds = (window.SmoofCustomPictogramTools?.getStates?.() || []).filter(state => state.enabled).map(state => state.id);
    const socialPlatformIds = Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}).map(id => `social-platform-${id}`);
    const order = ['text-0', 'text-1', 'text-2', ...customTextIds, 'arrow-left', 'arrow-right', ...customPictogramIds, 'logo', 'logo-copy', 'logo-2', 'payments', ...socialPlatformIds, 'table-number', 'branding-dot', 'nfc', 'qr', 'background'];
    const map = descriptors();
    return order.filter(id => {
      if (id === 'nfc') return window.SmoofNfcTools?.isActive?.();
      if (id === 'logo-copy') return window.SmoofLogoCopyTools?.getState?.()?.enabled;
      if (id === 'logo-2') return window.SmoofLogoDuplicateTools?.getState?.()?.hasLogo;
      if (id === 'payments') {
        const selected = window.SmoofPaymentTools?.getState?.()?.selected;
        return Array.isArray(selected) && selected.length > 0;
      }
      return true;
    }).map(id => {
      const item = map[id];
      const visibility = Boolean(item.hideable);
      const locked = item.locked;
      const action = visibility
        ? `<button type="button" data-smoof-ui-layer-action="${id}" aria-label="${t('Sichtbarkeit ändern', 'Change visibility')}">${icon(isVisible(id) ? 'eye' : 'eyeOff')}</button>`
        : `<span data-smoof-ui-layer-action>${icon(locked ? 'lock' : 'editor')}</span>`;
      return `<div data-smoof-ui-layer="${id}" data-editable="${String(!item.locked)}"><span data-smoof-ui-layer-symbol>${icon(item.symbol)}</span><span><strong data-smoof-ui-layer-name>${item.title}</strong><small data-smoof-ui-layer-copy>${item.copy}</small></span>${action}</div>`;
    }).join('');
  }

  function renderLayers() {
    if (deferPanelRender(layers)) return;
    if (panelSubview) { if(panelSubview.item===selectedId)return; leavePanelSubview(true); }
    if (activePercentageInputIn(layers)) return;
    if (!layersOpen) return;
    const scrollKey = layersPage === 'detail'
      ? `layers:detail:${selectedId}`
      : 'layers:list';
    const scrollSnapshot = capturePanelScroll(layers, scrollKey);
    if (layersPage === 'detail') {
      const descriptor = descriptors()[selectedId];
      source = descriptor ? sourceFor(selectedId) : null;
      if (!descriptor) { layersPage = 'list'; renderLayers(); return; }
      layers.innerHTML = panelHead(descriptor, 'layers-detail') + `<div data-smoof-ui-panel-body>${detailBody(descriptor)}</div>`;
      layers.dataset.smoofUiItemId = selectedId;
    } else {
      delete layers.dataset.smoofUiItemId;
      layers.innerHTML = `<header data-smoof-ui-panel-head><span data-smoof-ui-panel-symbol>${icon('layers')}</span><span><strong data-smoof-ui-panel-title>${t('Ebenen', 'Layers')}</strong><small data-smoof-ui-panel-copy>${t('Element auswählen und bearbeiten', 'Choose and edit an element')}</small></span><button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button></header><div data-smoof-ui-layer-list>${layerRows()}</div>`;
    }
    installPanelScrollAffordance(layers);
    restorePanelScroll(layers, scrollSnapshot);
    requestAnimationFrame(() => {
      positionLayers();
    });
  }

  // The toolbar silhouette owns vertical clearance; buttons still own pointer alignment.
  const toolbarPanelGap = 10;
  const panelViewportInset = 12;
  function toolbarPanelPlacement(panel) {
    const bar = commandbar.getBoundingClientRect();
    const belowTop = Math.max(panelViewportInset, bar.bottom + toolbarPanelGap);
    const aboveBottom = Math.min(innerHeight - panelViewportInset, bar.top - toolbarPanelGap);
    const below = Math.max(0, innerHeight - panelViewportInset - belowTop);
    const above = Math.max(0, aboveBottom - panelViewportInset);
    const placeAbove = below < 180 && above > below;
    const available = placeAbove ? above : below;
    panel.style.setProperty('--smoof-ui-available-height', `${available}px`);
    panel.style.maxHeight = `${available}px`;
    const height = panel.getBoundingClientRect().height;
    return placeAbove ? aboveBottom - height : belowTop;
  }

  function positionContext() {
    if (!context) return;
    if (mobile.matches) { context.style.removeProperty('max-height'); context.style.removeProperty('--smoof-ui-available-height'); }
    if (context.dataset.open !== 'true' || mobile.matches) {updatePanelAnchor(context,visibleItemFor(selectedId));return;}
    const item = visibleItemFor(selectedId);
    const toolbarAction = selectedId === 'payments' || selectedId === 'add' || selectedId === 'social-library'
      ? 'add'
      : selectedId === 'templates'
        ? 'templates'
      : selectedId === 'guides'
        ? 'guides'
      : selectedId === 'downloads'
        ? 'save-design'
        : 'layers';
    const toolbarAnchor = commandbar?.querySelector(
      `[data-smoof-ui-command-action="${toolbarAction}"]`
    ) || commandbar;
    const anchor = item || toolbarAnchor;
    if (!anchor) return;
    const a = anchor.getBoundingClientRect();
    const anchoredToToolbar = !item;
    context.style.removeProperty('--smoof-ui-available-height');
    context.style.maxHeight = `${Math.max(180, innerHeight - 24)}px`;
    const toolbarTop = anchoredToToolbar ? toolbarPanelPlacement(context) : null;
    const b = context.getBoundingClientRect();
    let left = anchoredToToolbar ? a.left + (a.width - b.width) / 2 : a.right + 14;
    if (!anchoredToToolbar && left + b.width > innerWidth - 12) left = a.left - b.width - 14;
    left = Math.max(12, Math.min(left, innerWidth - b.width - 12));
    let top = anchoredToToolbar ? toolbarTop : a.top + (a.height - b.height) / 2;
    if (!anchoredToToolbar) top = Math.max(12, Math.min(top, innerHeight - b.height - 12));
    context.style.left = `${Math.round(left)}px`;
    context.style.top = `${Math.round(top)}px`;
    updatePanelAnchor(context,anchor);
  }

  function positionLayers() {
    if (!layers || !commandbar) return;
    if (mobile.matches) {layers.style.removeProperty('max-height');layers.style.removeProperty('--smoof-ui-available-height');updatePanelAnchor(layers,layersPage==='detail'?visibleItemFor(selectedId):commandbar.querySelector('[data-smoof-ui-command-action=layers]'));return;}
    const a = commandbar.getBoundingClientRect();
    const top = toolbarPanelPlacement(layers);
    const b = layers.getBoundingClientRect();
    let left = a.left + (a.width - b.width) / 2;
    left = Math.max(12, Math.min(left, innerWidth - b.width - 12));
    layers.style.left = `${Math.round(left)}px`;
    layers.style.top = `${Math.round(top)}px`;
    updatePanelAnchor(layers,layersPage==='detail'?visibleItemFor(selectedId):commandbar.querySelector('[data-smoof-ui-command-action=layers]'));
  }

  function commandbarAnchor() {
    const candidates = Array.from(document.querySelectorAll(
      '.po-livePreview-root, media-gallery.product__gallery, .product__gallery'
    ));

    return candidates.find(candidate => {
      const rect = candidate.getBoundingClientRect();
      const style = getComputedStyle(candidate);
      return style.display !== 'none' && rect.width > 240 && rect.height > 240;
    }) || visibleItemFor('background');
  }

  function ensureCommandbarHost(anchor) {
    if (!anchor || !anchor.parentNode || !commandbar) return;

    const flowAnchor = anchor.matches('.po-livePreview-root')
      ? (anchor.closest('media-gallery.product__gallery, .product__gallery') || anchor)
      : anchor;

    if (!flowAnchor.parentNode) return;

    if (commandbarFlowParent && commandbarFlowParent !== flowAnchor.parentNode) {
      delete commandbarFlowParent.dataset.smoofUiGalleryFlow;
    }
    commandbarFlowParent = flowAnchor.parentNode;
    commandbarFlowParent.dataset.smoofUiGalleryFlow = 'true';

    if (!commandbarHost || !commandbarHost.isConnected) {
      commandbarHost = document.createElement('div');
      commandbarHost.dataset.smoofUiCommandbarHost = 'true';
      commandbarHost.dataset.smoofEditorItem = 'modern-ui-control';
    }

    if (
      commandbarHost.parentNode !== flowAnchor.parentNode ||
      commandbarHost.nextSibling !== flowAnchor
    ) {
      flowAnchor.parentNode.insertBefore(commandbarHost, flowAnchor);
    }

    if (commandbar.parentNode !== commandbarHost) {
      commandbarHost.append(commandbar);
    }
  }

  function positionCommandbar() {
    if (!commandbar) return;
    const anchor = commandbarAnchor();
    if (!anchor) return;
    ensureCommandbarHost(anchor);
    commandbar.style.removeProperty('left');
    commandbar.style.removeProperty('top');
  }

  function legacyPanel(action) {
    const selector = action === 'help' ? '[data-smoof-guide-legend]' : '[data-smoof-reset-menu]';
    return document.querySelector(selector);
  }

  function ensureLegacyPanelShell(action, panel) {
    if (!panel || panel.dataset.smoofUiLegacyShell === 'true') return;

    const isHelp = action === 'help';
    const header = document.createElement('header');
    header.dataset.smoofUiPanelHead = 'true';
    header.dataset.smoofUiLegacyHeader = action;
    header.innerHTML = [
      `<span data-smoof-ui-panel-symbol>${icon(isHelp ? 'help' : 'reset')}</span>`,
      '<span>',
      `<strong data-smoof-ui-panel-title>${isHelp ? t('Hilfe zum Editor', 'Editor help') : t('Zurücksetzen', 'Reset')}</strong>`,
      `<small data-smoof-ui-panel-copy>${isHelp ? t('Funktionen und Druckfläche', 'Features and print area') : t('Layout oder gesamtes Design wählen', 'Choose layout or entire design')}</small>`,
      '</span>',
      `<button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button>`
    ].join('');

    const body = document.createElement('div');
    body.dataset.smoofUiLegacyBody = action;
    while (panel.firstChild) body.append(panel.firstChild);

    if (isHelp) {
      const printHeading = document.createElement('strong');
      printHeading.textContent = t('Hinweise zur Druckfläche', 'Print area guidance');
      body.prepend(printHeading);
      const onboarding = document.createElement('section');
      onboarding.dataset.smoofUiHelpOnboarding = 'true';
      onboarding.innerHTML = `<strong>${t('Einführung in den SMOOF DOTS Editor', 'Introduction to the SMOOF DOTS Editor')}</strong><p>${t('Lernen Sie die wichtigsten Bereiche kennen, ohne Ihr Design zu verändern.', 'Explore the most important areas without changing your design.')}</p><button type="button" data-smoof-editor-tour-restart>${t('Einführung erneut starten', 'Restart introduction')}</button>`;
      const reference = document.createElement('section');
      reference.dataset.smoofUiHelpReference = 'true';
      reference.innerHTML = `<details><summary>${t("Ihre Arbeitsfläche", "Your workspace")}</summary><p>${t("Wählen Sie ein Element auf der Druckfläche aus, um es zu verschieben oder seine Einstellungen zu öffnen. Auf Mobilgeräten genügt ein Antippen. Schriftwahl und Logo-Zuschnitt öffnen sich im selben Panel; der Zurück-Pfeil führt zu den Einstellungen.", "Select an element on the print area to move it or open its settings. On mobile, tap it. Font selection and logo cropping open within the same panel; use the back arrow to return to its settings.")}</p></details><details><summary>${t("Mit Vorlagen starten", "Start with templates")}</summary><p>${t("Wählen Sie zuerst eine verfügbare Sprache, dann eine Kategorie und ein Design. Das Angebot richtet sich nach Ihrem Produkt und dem jeweiligen Shopbereich. Vor dem Ersetzen Ihres Designs erscheint eine Bestätigung.", "Choose an available language, then a category and a design. Available templates depend on your product and shop area. You will be asked to confirm before your design is replaced.")}</p></details><details><summary>${t("Texte und Schriften", "Text and fonts")}</summary><p>${t("Markieren Sie in einem Textfeld einzelne Zeichen oder Wörter, um Schrift, verfügbaren Schriftschnitt und Farbe nur dort zu ändern. „Gesamter Text“ beendet die Auswahl. Größe, Laufweite und Drehung gelten weiterhin für das ganze Feld.", "Select characters or words within a text field to change their font, available font style and colour. “Whole text” clears the selection. Size, letter spacing and rotation still apply to the whole field.")}</p></details><details><summary>${t("Ihre Schriftbibliothek", "Your font library")}</summary><p>${t("Über die Schriftwahl finden Sie Standardschriften und bereits hochgeladene eigene Schriften. Über „Eigene Schrift hochladen“ können Sie mehrere WOFF-, WOFF2-, TTF- oder OTF-Dateien gemeinsam hinzufügen. Bestätigen Sie dafür Ihre Nutzungs- und Produktionsrechte.", "The font picker includes standard fonts and your previously uploaded fonts. Use “Upload custom font” to add several WOFF, WOFF2, TTF or OTF files together and confirm that you hold the required usage and production rights.")}</p></details><details><summary>${t("Logos und Ausschnitt", "Logos and cropping")}</summary><p>${t("Wählen Sie Ihr hochgeladenes Hauptlogo und öffnen Sie „Logo zuschneiden“. Bei PNG, JPG und WEBP im Farbdruck können Sie den Ausschnitt anpassen oder transparente Außenränder entfernen. „Ganzes Original“ stellt das vollständige Bild wieder her. SVG und Laser bleiben ausgenommen.", "Select your uploaded main logo and open the crop tool. For PNG, JPG and WEBP in colour printing, adjust the crop or remove transparent outer margins. Restore the full original at any time. Cropping is unavailable for SVG and laser engraving.")}</p></details><details><summary>${t("Alle Elemente im Blick", "Keep every element in view")}</summary><p>${t("Unter Ebenen können Sie Elemente auswählen, bearbeiten, ausblenden und wieder einblenden. Prozentwerte lassen sich auch direkt eingeben; Plus und Minus ermöglichen kleine Anpassungen.", "Use Layers to select, edit, hide and restore elements. You can enter percentage values directly or make small adjustments with the plus and minus controls.")}</p></details><details><summary>${t("Elemente hinzufügen", "Add elements")}</summary><p>${t("Über Plus ergänzen Sie verfügbare Texte, Logos, Piktogramme, Zahlungsanbieter und Social-Media-Elemente. Dazu gehören Bewertungssterne und Markenvarianten mit Originalfarben. Bei DOT ME im Lasermodus bleiben Motive schwarz; weitere Optionen richten sich nach Produkt und Design.", "Use Add for available text, logos, pictograms, payment providers and social elements, including rating stars and brand variants in original colours. DOT ME laser artwork stays black; other options depend on your product and design.")}</p></details><details><summary>${t("Präzise ausrichten", "Align precisely")}</summary><p>${t("Im Lineal-Menü steuern Sie Bemaßung sowie horizontales und vertikales Einrasten getrennt. Ausgewählte Elemente verschieben Sie mit den Pfeiltasten, mit Umschalt in größeren Schritten. Während der Texteingabe bleiben die Tasten für den Text verfügbar.", "The ruler menu controls measurements and horizontal and vertical snapping separately. Move selected elements with the arrow keys; hold Shift for larger steps. While typing, the keys continue to control the text.")}</p></details><details><summary>${t("Designs und Dateien", "Designs and files")}</summary><p>${t("Speichern Sie Ihr Design als .smoofdesign-Datei und öffnen Sie es später erneut. Bei beidseitigen Produkten enthält die Datei beide Seiten. Hier finden Sie auch die Produktvorschau sowie Proof- und Produktionsdownloads. Beim Laden auf ein anderes Produkt gelten dessen technische Möglichkeiten.", "Save your design as a .smoofdesign file and reopen it later. For double-sided products, the file includes both sides. This panel also offers a product preview and proof and production downloads. When loading on another product, that product’s technical capabilities apply.")}</p></details><details><summary>${t("Sicher bearbeiten", "Edit with confidence")}</summary><p>${t("Rückgängig und Wiederholen helfen bei Änderungen. Zurücksetzen öffnet immer zuerst eine Auswahl. Bei eigenen QR-Farben achten Sie auf starken Kontrast; Hinweise dazu finden Sie im QR-Panel.", "Use Undo and Redo to manage changes. Reset always opens a choice first. Choose strong contrast for custom QR colours; see the QR panel for scanning guidance.")}</p></details>`;
      body.prepend(reference);
      body.prepend(onboarding);
    }

    panel.append(header, body);
    panel.dataset.smoofUiLegacyShell = 'true';
    new ResizeObserver(() => positionLegacyPopover(action)).observe(panel);
    new MutationObserver(() => {
      if (panel.hidden || getComputedStyle(panel).display === 'none' || getComputedStyle(panel).visibility === 'hidden') updatePanelAnchor(panel, null);
    }).observe(panel, {attributes:true, attributeFilter:['hidden', 'style']});

    header.querySelector('[data-smoof-ui-panel-close]')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (isHelp) closeLegacyHelp();
      else closeLegacyReset();
    });
  }

  function legacyPanelOpen(action) {
    const panel = legacyPanel(action);
    if (!panel || panel.hidden) return false;
    const style = getComputedStyle(panel);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function closeLegacyHelp() {
    const panel = legacyPanel('help');
    if (panel) {
      panel.style.removeProperty('display');
      panel.hidden = true;
      updatePanelAnchor(panel, null);
    }
    const native = document.querySelector('[data-smoof-guide-button]');
    if (native) native.setAttribute('aria-expanded', 'false');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="help"]');
    if (modern) modern.setAttribute('aria-expanded', 'false');
    const previewRoot = document.querySelector('.po-livePreview-root[data-smoof-legend-open="true"]');
    if (previewRoot) previewRoot.removeAttribute('data-smoof-legend-open');
  }

  function openLegacyHelp() {
    const panel = legacyPanel('help');
    if (!panel) return;

    ensureLegacyPanelShell('help', panel);

    closeLegacyReset();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';

    panel.hidden = false;
    panel.dataset.smoofModernHelp = 'true';
    panel.style.setProperty('display', 'grid', 'important');

    const native = document.querySelector('[data-smoof-guide-button]');
    if (native) native.setAttribute('aria-expanded', 'true');

    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="help"]');
    if (modern) modern.setAttribute('aria-expanded', 'true');

    const previewRoot = document.querySelector('.po-livePreview-root');
    if (previewRoot) previewRoot.dataset.smoofLegendOpen = 'true';

    window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: '' } }));
    positionLegacyPopover('help');
    requestAnimationFrame(() => positionLegacyPopover('help'));
  }

  function closeLegacyReset() {
    const panel = legacyPanel('reset');
    if (panel) {
      panel.style.removeProperty('display');
      panel.style.removeProperty('visibility');
      panel.hidden = true;
      updatePanelAnchor(panel, null);
    }
    const native = document.querySelector('[data-smoof-reset-button]');
    if (native) native.setAttribute('aria-expanded', 'false');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="reset"]');
    if (modern) modern.setAttribute('aria-expanded', 'false');
  }

  function openLegacyReset() {
    let panel = legacyPanel('reset');
    const native = document.querySelector('[data-smoof-reset-button]');

    /* Das stabile Reset-Liquid erzeugt sein Menü erst beim ersten Öffnen. */
    if (!panel && native) {
      native.click();
      panel = legacyPanel('reset');
    }
    if (!panel) return;

    ensureLegacyPanelShell('reset', panel);

    closeLegacyHelp();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';

    panel.dataset.smoofModernReset = 'true';
    panel.style.setProperty('visibility', 'hidden', 'important');
    panel.hidden = false;
    panel.style.setProperty('display', 'grid', 'important');

    if (native) native.setAttribute('aria-expanded', 'true');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="reset"]');
    if (modern) modern.setAttribute('aria-expanded', 'true');

    positionLegacyPopover('reset');
    requestAnimationFrame(() => {
      if (!panel.hidden) {
        positionLegacyPopover('reset');
        panel.style.removeProperty('visibility');
        updatePanelAnchor(panel, commandbar?.querySelector('[data-smoof-ui-command-action=reset]'));
      }
    });
  }

  function positionLegacyPopover(action) {
    if (!commandbar) return;
    const panel = legacyPanel(action);
    if (!panel) return;
    const style = getComputedStyle(panel);
    const measuringReset = action === 'reset' && panel.dataset.smoofModernReset === 'true';
    if (panel.hidden || style.display === 'none' || (style.visibility === 'hidden' && !measuringReset)) { updatePanelAnchor(panel, null); return; }
    const anchor = commandbar.getBoundingClientRect();
    const box = panel.getBoundingClientRect();
    const button = commandbar.querySelector(`[data-smoof-ui-command-action="${action}"]`);
    const buttonBox = button?.getBoundingClientRect();
    const pointerInset = (parseFloat(style.borderTopLeftRadius) || 22) + 12;
    let left = Math.max(anchor.right - box.width, buttonBox ? buttonBox.left + buttonBox.width / 2 - box.width + pointerInset : 0);
    left = Math.max(12, Math.min(left, innerWidth - box.width - 12));
    const top = Math.max(12, anchor.bottom + 10);
    const availableHeight = Math.max(180, innerHeight - top - 12);
    if (action === 'help') {
      panel.dataset.smoofModernHelp = 'true';
      panel.style.setProperty('--smoof-modern-help-left', `${Math.round(left)}px`);
      panel.style.setProperty('--smoof-modern-help-top', `${Math.round(top)}px`);
      panel.style.setProperty('--smoof-modern-help-height', `${Math.round(availableHeight)}px`);
    } else {
      panel.dataset.smoofModernReset = 'true';
      panel.style.setProperty('--smoof-modern-reset-left', `${Math.round(left)}px`);
      panel.style.setProperty('--smoof-modern-reset-top', `${Math.round(top)}px`);
      panel.style.setProperty('--smoof-modern-reset-height', `${Math.round(availableHeight)}px`);
    }
    updatePanelAnchor(panel, button);
  }

  function syncSelectionAppearance() {
    const item = personalizedDesignSelected() ? visibleItemFor(selectedId) : null;
    document.querySelectorAll('[data-smoof-ui-selected-object]').forEach(node => {
      if (node !== item) node.removeAttribute('data-smoof-ui-selected-object');
    });
    if (item && !item.hasAttribute('data-smoof-ui-selected-object')) item.setAttribute('data-smoof-ui-selected-object', 'true');
  }

  function syncCommandbar() {
    syncSelectionAppearance();
    if (!commandbar) return;
    if (!syncPersonalizationGate()) return;
    const layersButton = commandbar.querySelector('[data-smoof-ui-command-action="layers"]');
    if (layersButton) layersButton.setAttribute('aria-expanded', String(layersOpen));
    const addButton = commandbar.querySelector('[data-smoof-ui-command-action="add"]');
    if (addButton) {
      const addOpen = (selectedId === 'add' || selectedId === 'payments') && context?.dataset.open === 'true';
      addButton.setAttribute('aria-expanded', String(addOpen));
    }
    const downloadsButton = commandbar.querySelector('[data-smoof-ui-command-action="save-design"]');
    if (downloadsButton) {
      const downloadsOpen = selectedId === 'downloads' && context?.dataset.open === 'true';
      downloadsButton.setAttribute('aria-expanded', String(downloadsOpen));
    }
    const templatesButton = commandbar.querySelector('[data-smoof-ui-command-action="templates"]');
    if (templatesButton) {
      const templatesOpen = selectedId === 'templates' && context?.dataset.open === 'true';
      templatesButton.setAttribute('aria-expanded', String(templatesOpen));
    }
    const guideButton = commandbar.querySelector('[data-smoof-ui-command-action="guides"]');
    if (guideButton) {
      guideButton.removeAttribute('data-active');
      guideButton.removeAttribute('aria-pressed');
      guideButton.setAttribute('aria-expanded', String(selectedId === 'guides' && context?.dataset.open === 'true'));
      syncGuideSwitches();
    }
    const helpButton = commandbar.querySelector('[data-smoof-ui-command-action="help"]');
    if (helpButton) helpButton.setAttribute('aria-expanded', String(legacyPanelOpen('help')));
    const resetButton = commandbar.querySelector('[data-smoof-ui-command-action="reset"]');
    if (resetButton) resetButton.setAttribute('aria-expanded', String(legacyPanelOpen('reset')));
    syncHistoryButtons();
    positionCommandbar();
  }

  function proxy(selector) { return source ? source.querySelector(selector) : null; }
  function clickNative(selector) { const el = proxy(selector); if (el && !el.disabled) el.click(); }

  function finishFontSelection(family) {
    const clean = cleanFontFamily(family);
    const itemId = fontPickerTarget;
    if (!itemId || !clean || !/^[a-z0-9 ._-]+$/i.test(clean)) return false;
    const customFont = window.SmoofCustomFontRegistry?.isCustomFamily?.(clean);
    let applied = false;
    if (/^text-[0-2]$/.test(itemId)) {
      if (customFont) window.SmoofTextTools?.setStyle?.(Number(itemId.split('-')[1]), 'Normal');
      applied = Boolean(window.SmoofTextTools?.setFont?.(Number(itemId.split('-')[1]), clean));
    } else if (/^custom-text-[1-3]$/.test(itemId)) {
      if (customFont) window.SmoofCustomTextTools?.setStyle?.(itemId, 'Normal');
      applied = Boolean(window.SmoofCustomTextTools?.setFont?.(itemId, clean));
    } else if (itemId === 'table-number') {
      if (customFont) {
        const styleSelect = document.querySelector('[data-smoof-number-style-select]');
        if (styleSelect) setNativeValue(styleSelect, 'Normal', true);
      }
      applied = Boolean(window.SmoofNumberHistory?.setFont?.(clean));
    }
    if (!applied) return false;
    window.SmoofRichText?.release?.();
    if(panelSubview?.kind==='font')leavePanelSubview(false);
    selectedId = itemId;
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    scheduleHistoryCapture(80);
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
      syncCommandbar();
    }, 40);
    return true;
  }

  function resetFontPickerState() {
    window.SmoofRichText?.release?.();
    if(panelSubview?.kind==='font')leavePanelSubview(false);
    const hadPendingState = Boolean(
      fontPickerTarget ||
      root.hasAttribute('data-smoof-font-picker-active')
    );
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    if (!hadPendingState) return;
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
      syncCommandbar();
    }, 0);
  }

  function currentFontPickerTrigger() {
    const hook = document.querySelector('[data-smoof-font-tool]');
    const option = optionRoot(FONT_OPTION_ID);
    return (hook?.matches?.('button, [role="button"], [role="combobox"]') ? hook : null) ||
      hook?.querySelector?.('button, [role="button"], [role="combobox"]') ||
      option?.querySelector('button[aria-haspopup="listbox"], [role="combobox"], button') ||
      null;
  }

  function openFontPicker(itemId = selectedId) {
    if (!/^text-[0-2]$/.test(itemId) && !/^custom-text-[1-3]$/.test(itemId) && itemId !== 'table-number') return false;
    window.SmoofRichText?.hold?.(itemId);
    window.SmoofTextTools?.freezeFonts?.();
    window.SmoofNumberHistory?.freezeFont?.();
    fontPickerTarget = itemId;
    fontPickerInitialFamily = selectedGoogleFont();
    root.dataset.smoofFontPickerActive = 'true';
    const openExistingPicker = () => {
      if (fontPickerTarget !== itemId) return;
      window.SmoofCustomFontRegistry?.showPickerForFamily?.(rawFontForItem(itemId));
      const publicPicker = window.SmoofFontPicker || window.SmoofGoogleFontPicker;
      if (typeof publicPicker?.open === 'function') {
        publicPicker.open();
      } else {
        const trigger = currentFontPickerTrigger();
        if (!trigger || trigger.disabled) {
          resetFontPickerState();
          return;
        }
        trigger.click();
      }
      window.SmoofCustomFontRegistry?.showPickerForFamily?.(rawFontForItem(itemId));
      embedFontPicker();
      setTimeout(() => {
        if (fontPickerTarget !== itemId) return;
        const pickerOpen = Boolean(document.querySelector('.smoof-font-backdrop[data-open="true"]'));
        if (pickerOpen) return;
        resetFontPickerState();
      }, 160);
    };
    if (itemId === 'table-number') setTimeout(openExistingPicker, 80);
    else openExistingPicker();
    return true;
  }

  function panelItemId(panel) {
    return panel?.dataset.smoofUiItemId || selectedId;
  }

  function applySelect(name, value, panel) {
    const itemId = panelItemId(panel);
    const index = itemId.split('-')[1];
    suppressSelectionRenderId = itemId;
    suppressSelectionRenderUntil = Date.now() + 800;
    if (name === 'pictogram' && window.SmoofArrowTools?.setSymbol) {
      window.SmoofArrowTools.setSymbol(itemId.split('-')[1], value);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (name === 'logo-background-shape' && window.SmoofLogoBackgroundTools?.setShape) {
      window.SmoofLogoBackgroundTools.setShape(itemId, value);
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (name === 'custom-text-style' && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setStyle(itemId, value);
      const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
      if (select) select.value = value;
      return;
    }
    if (name === 'text-style' && window.SmoofTextTools) {
      window.SmoofTextTools.setStyle(Number(index), value);
      const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
      if (select) select.value = value;
      return;
    }
    const targetSource = sourceFor(itemId);
    const selector = name === 'text-style'
      ? `[data-smoof-text-style-select="${index}"]`
      : '[data-smoof-number-style-select]';
    const native = targetSource?.querySelector(selector);
    if (!native) return;
    setNativeValue(native, value, true);
    const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
    if (select) select.value = value;
  }

  function applyColor(name, value, commit, container) {
    if (backgroundLocked && String(name || '').startsWith('background-')) return;
    if (laserMonochromeActive()) {
      const colorInput = container?.querySelector?.(`[data-smoof-ui-color="${name}"]`);
      const colorWrap = colorInput?.closest('[data-smoof-ui-color-wrap]');
      const label = colorWrap?.querySelector('[data-smoof-ui-color-value]');
      const swatch = colorWrap?.querySelector('[data-smoof-ui-color-swatch]');
      const hexInput = container?.querySelector?.(`[data-smoof-ui-hex-color="${name}"]`);
      if (colorInput) colorInput.value = '#000000';
      if (label) label.textContent = '#000000';
      if (swatch) swatch.style.backgroundColor = '#000000';
      if (hexInput) {
        hexInput.value = '#000000';
        hexInput.setAttribute('aria-invalid', 'false');
      }
      window.SmoofDotMePolicy?.enforceNow?.('theme-ui-colour-attempt');
      return false;
    }
    const itemId = panelItemId(container);
    const index = itemId.split('-')[1];
    suppressSelectionRenderId = itemId;
    suppressSelectionRenderUntil = Date.now() + 1200;
    if (name === 'logo-colour' && window.SmoofLogoColourTools) {
      window.SmoofLogoColourTools.set(itemId, { color: value, enabled: true }, commit);
      const toggle = container.querySelector('[data-smoof-ui-action="logo-colour-toggle"]');
      if (toggle) {
        toggle.querySelector('span').textContent = t('Einfarbig', 'Single colour');
        toggle.querySelector('small').textContent = t('Original verwenden', 'Use original') + ' →';
      }
    } else if (name === 'custom-text-color' && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setColor(itemId, value, commit);
    } else if (name === 'custom-pictogram-color' && window.SmoofCustomPictogramTools) {
      window.SmoofCustomPictogramTools.setColor(itemId, value, commit);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && /^custom-text-[1-3]$/.test(itemId) && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setPillColor(itemId, name === 'pill-fill-color' ? 'fill' : 'stroke', value);
    } else if (name === 'text-color' && window.SmoofTextTools) {
      window.SmoofTextTools.setColor(Number(index), value, commit);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && itemId === 'table-number' && window.SmoofNumberHistory) {
      window.SmoofNumberHistory.setPillColor(name === 'pill-fill-color' ? 'fill' : 'stroke', value);
      if (commit) scheduleHistoryCapture(80);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && window.SmoofTextTools) {
      window.SmoofTextTools.setPillColor(Number(index), name === 'pill-fill-color' ? 'fill' : 'stroke', value);
    } else if (
      (name === 'arrow-color' || name === 'arrow-label-color') &&
      window.SmoofArrowTools
    ) {
      window.SmoofArrowTools.setColor(
        itemId.split('-')[1],
        name === 'arrow-label-color' ? 'label' : 'arrow',
        value,
        commit
      );
    } else if (
      (name === 'nfc-icon-color' || name === 'nfc-circle-color') &&
      window.SmoofNfcTools?.setColor
    ) {
      window.SmoofNfcTools.setColor(
        name === 'nfc-icon-color' ? 'icon' : 'circle',
        value,
        commit
      );
    } else if (
      (name === 'background-gradient-color-1' || name === 'background-gradient-color-2') &&
      window.SmoofBackgroundGradientTools?.setColor
    ) {
      window.SmoofBackgroundGradientTools.setColor(
        name === 'background-gradient-color-2' ? 'end' : 'start',
        value
      );
    } else if (
      name === 'background-overlay-color' &&
      window.SmoofBackgroundGradientTools?.setOverlayColor
    ) {
      window.SmoofBackgroundGradientTools.setOverlayColor(value);
    } else if (
      name === 'qr-code-color' &&
      window.SmoofQrGeometryTools?.setCodeColor
    ) {
      window.SmoofQrGeometryTools.setCodeColor(value, { commit });
    } else if (
      name === 'qr-backing-color' &&
      window.SmoofQrGeometryTools?.setBackingColor
    ) {
      window.SmoofQrGeometryTools.setBackingColor(value, { commit });
    } else if (
      name === 'payment-color' &&
      window.SmoofPaymentTools?.setColor
    ) {
      window.SmoofPaymentTools.setColor(value);
    } else if (
      name === 'social-platform-color' &&
      window.SmoofSocialPlatformTools?.setColor
    ) {
      window.SmoofSocialPlatformTools.setColor(itemId, value);
    } else if (
      name === 'logo-background-color' &&
      window.SmoofLogoBackgroundTools?.setColor
    ) {
      window.SmoofLogoBackgroundTools.setColor(itemId, value);
    } else {
      const targetSource = sourceFor(itemId);
    const selectors = {
      'text-color': `[data-smoof-text-color-input="${index}"]`,
      'arrow-color': '[data-smoof-arrow-color-input]',
      'arrow-label-color': '[data-smoof-arrow-label-color-input]',
      'number-color': '[data-smoof-number-color-input]',
      'brand-color': '[data-smoof-brand-color-input]',
      'background-color': 'input[type="color"]'
    };
      const native = targetSource?.querySelector(selectors[name]);
    if (!native) return;
    setNativeValue(native, value, commit);
    }
    const colorInput = container.querySelector(`[data-smoof-ui-color="${name}"]`);
    const colorWrap = colorInput?.closest('[data-smoof-ui-color-wrap]');
    const label = colorWrap?.querySelector('[data-smoof-ui-color-value]');
    const swatch = colorWrap?.querySelector('[data-smoof-ui-color-swatch]');
    const hexInput = container.querySelector(`[data-smoof-ui-hex-color="${name}"]`);
    if (colorInput && colorInput.value !== value) colorInput.value = value;
    if (label) label.textContent = value.toUpperCase();
    if (swatch) swatch.style.backgroundColor = value;
    if (hexInput) {
      hexInput.value = value.toUpperCase();
      hexInput.setAttribute('aria-invalid', 'false');
    }
  }

  function applyHexColor(input, commit, panel) {
    if (laserMonochromeActive()) {
      if (input) {
        input.value = '#000000';
        input.setAttribute('aria-invalid', 'false');
      }
      window.SmoofDotMePolicy?.enforceNow?.('theme-ui-hex-attempt');
      return false;
    }
    const value = normalizeHexColor(input?.value, commit);
    if (!value) {
      if (commit) input?.setAttribute('aria-invalid', 'true');
      return false;
    }
    input.setAttribute('aria-invalid', 'false');
    applyColor(input.dataset.smoofUiHexColor, value, commit, panel);
    return true;
  }

  function syncGuideSwitches() {
    if (selectedId !== 'guides' || context?.dataset.open !== 'true') return;
    const native = document.querySelector('[data-smoof-guide-visibility-button]');
    context.querySelectorAll('[data-smoof-ui-action^="guide-toggle:"]').forEach(button => {
      const axis = button.dataset.smoofUiAction.split(':')[1];
      const checked = axis === 'measurements'
        ? native?.dataset.active === 'true' || native?.getAttribute('aria-pressed') === 'true'
        : window.SmoofAlignmentGuides?.isAxisEnabled?.(axis) !== false;
      button.setAttribute('aria-checked', String(checked));
      button.disabled = axis === 'measurements' ? !native : !window.SmoofAlignmentGuides?.setAxisEnabled;
    });
  }
  window.addEventListener('smoof:snap-preferences-changed', syncGuideSwitches);

  let panelRouteStack=[];
  let routingPanel=false;
  function handleAction(action,panel){
    const drill=action.startsWith('add-open:')||action==='logo-2-open';
    const prior={id:selectedId,layers:layersOpen,page:layersPage,scroll:panel?.querySelector('[data-smoof-ui-panel-body]')?.scrollTop||0};
    routingPanel=drill;
    try{handleActionImpl(action,panel);}finally{routingPanel=false;}
    if(drill&&selectedId!==prior.id){
      panelRouteStack.push({...prior,to:selectedId});
      if(layersOpen)renderLayers();else renderContext();
      animatePanel(layersOpen?layers:context);
    }
  }
  function backPanelRoute(){
    const route=panelRouteStack.pop();if(!route)return;
    routingPanel=true;
    selectedId=route.id;layersOpen=route.layers;layersPage=route.page;
    if(layers)layers.dataset.open=String(layersOpen);
    dispatchSelection(selectedId,{openContext:true,forceContext:true});
    routingPanel=false;
    if(layersOpen)renderLayers();else renderContext();
    const panel=layersOpen?layers:context;
    const scroller=panel.querySelector('[data-smoof-ui-panel-body]');if(scroller)scroller.scrollTop=route.scroll;
    animatePanel(panel,'back');
  }

  function handleActionImpl(action, panel) {
    if (action.startsWith('guide-toggle:')) {
      const axis = action.split(':')[1];
      if (axis === 'measurements') document.querySelector('[data-smoof-guide-visibility-button]')?.click();
      else {
        const guides = window.SmoofAlignmentGuides;
        guides?.setAxisEnabled?.(axis, !guides.isAxisEnabled(axis));
      }
      syncGuideSwitches(); syncCommandbar();
      return;
    }
    if (backgroundLocked && String(action || '').startsWith('background-')) return;
    const itemId = panelItemId(panel);
    const targetSource = sourceFor(itemId);
    const map = {
      'text-minus': '[data-smoof-text-control-button="minus"]',
      'text-plus': '[data-smoof-text-control-button="plus"]',
      'text-reset': '[data-smoof-text-control-button="reset"]',
      'logo-minus': '[data-smoof-logo-control-button="control"]',
      'logo-plus': '[data-smoof-logo-control-button="plus"]',
      'logo-reset': '[data-smoof-logo-control-button="reset"]',
      'number-minus': '[data-smoof-number-control-button="minus"]',
      'number-plus': '[data-smoof-number-control-button="plus"]',
      'number-reset': '[data-smoof-number-control-button="reset"]'
    };
    if (action === 'payment-original-colours') { window.SmoofPaymentTools?.useOriginalColours?.(); renderContext(); return; }
    if (action === 'social-original-colours') { window.SmoofSocialPlatformTools?.useOriginalColours?.(selectedId); renderContext(); return; }
    if (action === 'add-open:payments') {
      if (!personalizedDesignSelected()) return;
      if (window.SmoofPaymentTools?.getState?.().visible === false) {
        window.SmoofPaymentTools.toggleVisibility();
      }
      togglePaymentsShortcut();
      return;
    }
    if (action === 'add-open:social-platforms') {
      selectedId = 'social-library';
      if (layersOpen) setLayersOpen(false);
      renderContext();
      dispatchSelection('social-library', { openContext: true });
      syncCommandbar();
      return;
    }
    if (action === 'add-open:custom-text') {
      const state = window.SmoofCustomTextTools?.add?.();
      if (!state?.id) return;
      selectedId = state.id;
      if (layersOpen) layersPage = 'detail';
      dispatchSelection(state.id, { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:custom-pictogram') {
      const state = window.SmoofCustomPictogramTools?.add?.();
      if (!state?.id) return;
      selectedId = state.id;
      if (layersOpen) layersPage = 'detail';
      dispatchSelection(state.id, { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:logo-copy') {
      const state = window.SmoofLogoCopyTools?.getState?.();
      if (!state?.enabled) window.SmoofLogoCopyTools?.toggleEnabled?.();
      selectedId = 'logo-copy';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-copy', { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:logo-2') {
      selectedId = 'logo-2';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-2', { openContext: true });
      window.SmoofLogoDuplicateTools?.openUpload?.();
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'qr-scale-minus' || action === 'qr-scale-plus') {
      const qr = window.SmoofQrGeometryTools?.getState?.();
      if (!qr) return;
      window.SmoofQrGeometryTools.setScale(
        (Number(qr.scale) || 1) + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-visibility-toggle') {
      window.SmoofQrGeometryTools?.toggleVisibility?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-backing-toggle') {
      window.SmoofQrGeometryTools?.toggleBackingVisibility?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-reset') {
      window.SmoofQrGeometryTools?.reset?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'pictogram-picker-toggle') {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      pictogramPickerOpenFor = pictogramPickerOpenFor === side ? '' : side;
      const current = window.SmoofArrowTools?.getState?.(side);
      const iconRecord = window.SmoofPictogramLibrary?.get?.(current?.symbol);
      if (iconRecord?.category) pictogramPickerCategory[side] = iconRecord.category;
      if (layersOpen) renderLayers(); else renderContext();
      if (pictogramPickerOpenFor === side) alignActivePictogramCategory(panel);
      return;
    }
    if (action.startsWith('pictogram-category:')) {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      rememberPictogramCategoryScroll(panel, side);
      pictogramPickerOpenFor = side;
      pictogramPickerCategory[side] = action.slice('pictogram-category:'.length) || 'arrows';
      if (layersOpen) renderLayers(); else renderContext();
      restorePictogramCategoryScroll(panel, side);
      return;
    }
    if (action.startsWith('pictogram-select:')) {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      const symbol = action.slice('pictogram-select:'.length);
      const applied = window.SmoofArrowTools?.setSymbol?.(side, symbol);
      if (!applied) return;
      pictogramPickerOpenFor = '';
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'pictogram-upload') {
      panel.querySelector('[data-smoof-ui-pictogram-upload]')?.click?.();
      return;
    }
    if (action === 'pictogram-color-mode') {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      const state = window.SmoofArrowTools?.getState?.(side);
      const applied = window.SmoofArrowTools?.setColorize?.(side, !state?.colorize);
      if (applied == null) return;
      selectedId = `arrow-${side}`;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-picker-toggle') {
      pictogramPickerOpenFor = pictogramPickerOpenFor === itemId ? '' : itemId;
      const current = window.SmoofCustomPictogramTools?.getState?.(itemId);
      const iconRecord = window.SmoofPictogramLibrary?.get?.(current?.symbol);
      if (iconRecord?.category) pictogramPickerCategory[itemId] = iconRecord.category;
      if (layersOpen) renderLayers(); else renderContext();
      if (pictogramPickerOpenFor === itemId) alignActivePictogramCategory(panel);
      return;
    }
    if (action.startsWith('custom-pictogram-category:')) {
      rememberPictogramCategoryScroll(panel, itemId);
      pictogramPickerOpenFor = itemId;
      pictogramPickerCategory[itemId] = action.slice('custom-pictogram-category:'.length) || 'arrows';
      if (layersOpen) renderLayers(); else renderContext();
      restorePictogramCategoryScroll(panel, itemId);
      return;
    }
    if (action.startsWith('custom-pictogram-select:')) {
      const symbol = action.slice('custom-pictogram-select:'.length);
      if (!window.SmoofCustomPictogramTools?.setSymbol?.(itemId, symbol)) return;
      pictogramPickerOpenFor = '';
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-upload') {
      panel.querySelector('[data-smoof-ui-custom-pictogram-upload]')?.click?.();
      return;
    }
    if (action === 'custom-pictogram-color-mode') {
      const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
      if (!state) return;
      window.SmoofCustomPictogramTools?.setColorize?.(itemId, !state.colorize);
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'open-design') {
      window.SmoofDesignFileTools?.open?.();
      return;
    }
    if (action === 'template-language-change' || action.startsWith('template-language:')) {
      const id = action === 'template-language-change' ? '' : action.slice('template-language:'.length);
      templateCategory = '';
      if (!window.SmoofTemplateLibrary?.selectLanguage?.(id, { silent: true })) return;
      selectedId = 'templates';
      renderContext();
      context?.querySelector(id ? '[data-smoof-ui-template-category]' : '[data-smoof-ui-language-option]')?.focus?.();
      return;
    }
    if (action.startsWith('template-category:')) {
      templateCategory = action.slice('template-category:'.length);
      selectedId = 'templates';
      renderContext();
      return;
    }
    if (action.startsWith('template-apply:')) {
      const templateId = action.slice('template-apply:'.length);
      Promise.resolve(window.SmoofTemplateLibrary?.apply?.(templateId)).then(applied => {
        if (!applied) return;
        selectedId = '';
        dispatchSelection('');
        scheduleHistoryCapture(420);
      });
      return;
    }
    if (action === 'download-design') {
      window.SmoofDesignFileTools?.save?.();
      return;
    }
    if (action === 'download-mockup') {
      const run = () => window.SmoofMockupDownload?.download?.();
      if (!run()) window.setTimeout(run, 300);
      return;
    }
    if (action === 'download-proof' || action === 'download-production') {
      const selector = action === 'download-proof'
        ? '[data-smoof-proof-test-button]'
        : '[data-smoof-production-test-button]';
      const trigger = document.querySelector(selector);
      if (trigger && !trigger.disabled) trigger.click();
      else window.setTimeout(() => document.querySelector(selector)?.click?.(), 300);
      return;
    }
    if (action === 'text-font') {
      openFontPicker(itemId);
      return;
    }
    if (action === 'letter-spacing-minus' || action === 'letter-spacing-plus') {
      const delta = action.endsWith('plus') ? 0.01 : -0.01;
      let value = 0;
      if (/^text-[0-2]$/.test(itemId)) {
        const index = Number(itemId.split('-')[1]);
        const state = window.SmoofTextTools?.getPillState?.(index);
        value = window.SmoofTextTools?.setLetterSpacing?.(
          index,
          Number(state?.letterSpacing || 0) + delta
        );
      } else if (/^custom-text-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomTextTools?.getState?.(itemId);
        value = window.SmoofCustomTextTools?.setLetterSpacing?.(
          itemId,
          Number(state?.letterSpacing || 0) + delta
        )?.letterSpacing;
      } else if (itemId === 'table-number') {
        const state = window.SmoofNumberHistory?.getState?.();
        value = window.SmoofNumberHistory?.setLetterSpacing?.(
          Number(state?.letterSpacing || 0) + delta
        );
      } else {
        return;
      }
      const output = panel.querySelector('[data-smoof-ui-letter-spacing]');
      if (output && Number.isFinite(Number(value))) {
        output.textContent = `${Math.round(Number(value) * 100)}%`;
      }
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'opacity-minus' || action === 'opacity-plus') {
      if (/^custom-pictogram-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
        if (!state) return;
        const next = Math.max(0.05, Math.min(1, Number(state.opacity || 1) + (action.endsWith('plus') ? 0.05 : -0.05)));
        window.SmoofCustomPictogramTools.setOpacity(itemId, next);
        const output = panel.querySelector('[data-smoof-ui-opacity-value]');
        if (output) output.textContent = `${Math.round(next * 100)}%`;
        return;
      }
      if (/^custom-text-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomTextTools?.getState?.(itemId);
        if (!state) return;
        const next = Math.max(0.05, Math.min(1, Number(state.opacity || 1) + (action.endsWith('plus') ? 0.05 : -0.05)));
        window.SmoofCustomTextTools.setOpacity(itemId, next);
        const output = panel.querySelector('[data-smoof-ui-opacity-value]');
        if (output) output.textContent = `${Math.round(next * 100)}%`;
        return;
      }
      const current = window.SmoofLayerOpacityTools?.get?.(itemId);
      if (!Number.isFinite(current)) return;
      const value = window.SmoofLayerOpacityTools.set(
        itemId,
        current + (action.endsWith('plus') ? 0.05 : -0.05)
      );
      const output = panel.querySelector('[data-smoof-ui-opacity-value]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'logo-colour-toggle') {
      const value = window.SmoofLogoColourTools?.get?.(itemId);
      window.SmoofLogoColourTools?.set?.(itemId, { enabled: !value?.enabled });
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
      return;
    }
    if (action === 'logo-invert' || action === 'logo-copy-invert' || action === 'logo-2-invert') {
      const logoId = action === 'logo-2-invert' ? 'logo-2' : action === 'logo-copy-invert' ? 'logo-copy' : 'logo';
      window.SmoofLogoColourTools?.set?.(logoId, { enabled: false });
      window.SmoofLogoInvertTools?.toggle?.(logoId);
      selectedId = logoId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-copy-toggle') {
      const enabled = window.SmoofLogoCopyTools?.toggleEnabled?.();
      selectedId = enabled ? 'logo-copy' : 'logo';
      if (enabled) dispatchSelection('logo-copy');
      else dispatchSelection('logo');
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'logo-copy-minus' || action === 'logo-copy-plus') {
      window.SmoofLogoCopyTools?.adjustScale?.(action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-copy-reset') {
      window.SmoofLogoCopyTools?.resetPosition?.();
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-open') {
      selectedId = 'logo-2';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-2');
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-2-minus' || action === 'logo-2-plus') {
      window.SmoofLogoDuplicateTools?.adjustScale?.(action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-reset') {
      window.SmoofLogoDuplicateTools?.resetPosition?.();
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-file') {
      const logo = window.SmoofLogoDuplicateTools?.getState?.() || {};
      if (logo.hasLogo) window.SmoofLogoDuplicateTools?.remove?.();
      else window.SmoofLogoDuplicateTools?.openUpload?.();
      selectedId = 'logo-2';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
      return;
    }
    if (action === 'logo-reset') {
      window.SmoofLogoTools?.resetPosition?.();
      selectedId = itemId;
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-crop') {
      window.SmoofLogoCropTools?.open?.();
      return;
    }
    if (action === 'logo-file') {
      const logo = window.SmoofLogoTools?.getState?.() || {};
      if (logo.hasLogo) window.SmoofLogoTools?.remove?.();
      else window.SmoofLogoTools?.openUpload?.();
      selectedId = 'logo';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
      return;
    }
    if (action === 'logo-background-toggle') {
      window.SmoofLogoBackgroundTools?.toggle?.(itemId);
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'logo-background-padding-minus' || action === 'logo-background-padding-plus') {
      const background = window.SmoofLogoBackgroundTools?.get?.(itemId);
      if (!background) return;
      const value = window.SmoofLogoBackgroundTools.setPadding(
        itemId,
        background.padding + (action.endsWith('plus') ? 0.05 : -0.05)
      );
      const output = panel.querySelector('[data-smoof-ui-logo-padding-value]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'nfc-transparency') {
      window.SmoofNfcTools?.toggleTransparency?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 60);
      return;
    }
    if (action === 'pill-toggle' || action === 'pill-fill-toggle') {
      if (itemId === 'table-number') {
        if (action === 'pill-toggle') window.SmoofNumberHistory?.togglePill?.();
        else window.SmoofNumberHistory?.togglePillFill?.();
        selectedId = itemId;
        scheduleHistoryCapture(80);
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
        return;
      }
      if (/^custom-text-[1-3]$/.test(itemId)) {
        if (action === 'pill-toggle') window.SmoofCustomTextTools?.togglePill?.(itemId);
        else window.SmoofCustomTextTools?.togglePillFill?.(itemId);
        selectedId = itemId;
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
        return;
      }
      const index = Number(itemId.split('-')[1]);
      if (action === 'pill-toggle') window.SmoofTextTools?.togglePill?.(index);
      else window.SmoofTextTools?.togglePillFill?.(index);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^pill-(stroke|padding-x|padding-y)-(minus|plus)$/.test(action)) {
      const kind = action.includes('padding-x') ? 'paddingX' : action.includes('padding-y') ? 'paddingY' : 'stroke';
      const step = kind === 'stroke' ? 0.01 : 0.05;
      if (itemId === 'table-number') {
        window.SmoofNumberHistory?.adjustPill?.(kind, action.endsWith('plus') ? step : -step);
      } else if (/^custom-text-[1-3]$/.test(itemId)) {
        window.SmoofCustomTextTools?.adjustPill?.(itemId, kind, action.endsWith('plus') ? step : -step);
      } else {
        const index = Number(itemId.split('-')[1]);
        window.SmoofTextTools?.adjustPill?.(index, kind, action.endsWith('plus') ? step : -step);
      }
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'nfc-reset') {
      window.SmoofNfcTools?.resetPosition?.();
      return;
    }
    if (action === 'payment-size-minus' || action === 'payment-size-plus') {
      const paymentState = window.SmoofPaymentTools?.getState?.();
      if (!paymentState) return;
      const value = window.SmoofPaymentTools.setScale(
        paymentState.scale + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      const output = panel.querySelector('[data-smoof-ui-payment-scale]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'payment-reset') {
      window.SmoofPaymentTools?.resetPosition?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-size-minus' || action === 'social-platform-size-plus') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(itemId);
      if (!object) return;
      window.SmoofSocialPlatformTools.setScale(itemId, object.scale + (action.endsWith('plus') ? .1 : -.1));
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-opacity-minus' || action === 'social-platform-opacity-plus') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(itemId);
      if (!object) return;
      window.SmoofSocialPlatformTools.setOpacity(itemId, object.opacity + (action.endsWith('plus') ? .05 : -.05));
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-reset') {
      window.SmoofSocialPlatformTools?.resetPosition?.(itemId);
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-delete') {
      window.SmoofSocialPlatformTools?.setEnabled?.(itemId, false);
      selectedId = 'social-library';
      dispatchSelection('social-library', { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'arrows-reset') {
      window.SmoofArrowTools?.resetPosition?.(itemId.split('-')[1]);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'rich-clear') {window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear();renderContext();if(layersOpen)renderLayers();return;}
    if (action === 'text-rotation-minus' || action === 'text-rotation-plus') {
      const delta = action.endsWith('plus') ? 15 : -15;
      if (itemId.startsWith('custom-text-')) {
        const tools = window.SmoofCustomTextTools;
        tools?.setRotation?.(itemId, Number(tools.getState(itemId)?.rotation || 0) + delta);
      } else if (itemId === 'table-number') {
        const tools = window.SmoofNumberHistory;
        tools?.setRotation?.(Number(tools.getState()?.rotation || 0) + delta);
      } else if (/^text-[0-2]$/.test(itemId)) {
        const index = Number(itemId.split('-')[1]);
        const tools = window.SmoofTextTools;
        tools?.setRotation?.(index, Number(tools.getPillState(index)?.rotation || 0) + delta);
      }
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-text-minus' || action === 'custom-text-plus') {
      window.SmoofCustomTextTools?.adjustScale?.(itemId, action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-text-reset') {
      window.SmoofCustomTextTools?.resetPosition?.(itemId);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-text-delete') {
      window.SmoofCustomTextTools?.remove?.(itemId);
      selectedId = 'add';
      dispatchSelection('add', { openContext: true });
      if (layersOpen) layersPage = 'list';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'custom-pictogram-minus' || action === 'custom-pictogram-plus') {
      window.SmoofCustomPictogramTools?.adjustScale?.(itemId, action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-pictogram-rotation-minus' || action === 'custom-pictogram-rotation-plus') {
      const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
      if (!state) return;
      window.SmoofCustomPictogramTools.setRotation(itemId, Number(state.rotation || 0) + (action.endsWith('plus') ? 15 : -15));
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-mirror') {
      window.SmoofCustomPictogramTools?.toggleMirror?.(itemId);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-reset') {
      window.SmoofCustomPictogramTools?.resetPosition?.(itemId);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-delete') {
      window.SmoofCustomPictogramTools?.remove?.(itemId);
      selectedId = 'add';
      dispatchSelection('add', { openContext: true });
      if (layersOpen) layersPage = 'list';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'arrow-scale-minus' || action === 'arrow-scale-plus') {
      const side = itemId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side);
      if (!state) return;
      window.SmoofArrowTools?.setScale?.(
        side,
        (Number(state.scale) || 1) + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = itemId;
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (/^arrow-(rotation|count)-(minus|plus)$/.test(action)) {
      const side = itemId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side);
      if (!state) return;
      if (action.startsWith('arrow-rotation')) {
        window.SmoofArrowTools.setRotation(side, state.rotation + (action.endsWith('plus') ? 15 : -15));
      } else {
        window.SmoofArrowTools.setCount(side, state.count + (action.endsWith('plus') ? 1 : -1));
      }
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'arrow-label') {
      window.SmoofArrowTools?.toggleLabel?.(itemId.split('-')[1]);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-upload') {
      if (!window.SmoofBackgroundImageBridge?.openPicker?.()) {
        window.SmoofBackgroundImageTools?.openPicker?.();
      }
      return;
    }
    if (action === 'background-gradient-toggle') {
      window.SmoofBackgroundGradientTools?.toggle?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^background-image-(?:scale|x|y)-(?:minus|plus)$/.test(action)) {
      const bridge = window.SmoofBackgroundImageBridge;
      const image = bridge?.getState?.();
      if (!image?.hasImage) return;
      const direction = action.endsWith('plus') ? 1 : -1;
      if (action.includes('-scale-')) {
        const currentScale = Math.max(0.05, Math.min(3, Number(image.scale) || 1));
        const step = currentScale < 0.1 ? 0.05 : 0.1;
        bridge.setScale?.(currentScale + direction * step);
      }
      const positionX = Number.isFinite(Number(image.positionX)) ? Number(image.positionX) : 0.5;
      const positionY = Number.isFinite(Number(image.positionY)) ? Number(image.positionY) : 0.5;
      if (action.includes('-x-')) bridge.setPosition?.(positionX + direction * 0.05, positionY);
      if (action.includes('-y-')) bridge.setPosition?.(positionX, positionY + direction * 0.05);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-image-position-reset') {
      window.SmoofBackgroundImageBridge?.resetPlacement?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-gradient-angle-minus' || action === 'background-gradient-angle-plus') {
      const gradient = window.SmoofBackgroundGradientTools?.getState?.();
      if (!gradient) return;
      window.SmoofBackgroundGradientTools.setAngle(
        gradient.angle + (action.endsWith('plus') ? 15 : -15)
      );
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-overlay-toggle') {
      window.SmoofBackgroundGradientTools?.toggleOverlay?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-overlay-opacity-minus' || action === 'background-overlay-opacity-plus') {
      const gradient = window.SmoofBackgroundGradientTools?.getState?.();
      if (!gradient) return;
      window.SmoofBackgroundGradientTools.setOverlayOpacity(
        gradient.overlayOpacity + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-remove') {
      if (window.SmoofBackgroundImageBridge?.remove) {
        window.SmoofBackgroundImageBridge.remove();
      } else {
        window.SmoofBackgroundImageTools?.remove?.();
      }
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 60);
      return;
    }
    if (action === 'item-visibility') {
      suppressSelectionRenderId = itemId;
      suppressSelectionRenderUntil = Date.now() + 500;
      toggleVisibility(itemId);
      selectedId = itemId;
      setTimeout(() => {
        const button = panel.querySelector('[data-smoof-ui-action="item-visibility"]');
        const visible = isVisible(itemId);
        if (button) {
          button.innerHTML = icon(visible ? 'eye' : 'eyeOff');
          button.setAttribute(
            'aria-label',
            visible ? t('Element ausblenden', 'Hide element') : t('Element einblenden', 'Show element')
          );
        }
      }, 60);
      return;
    } else if (map[action]) {
      suppressSelectionRenderId = itemId;
      suppressSelectionRenderUntil = Date.now() + 800;
      const native = targetSource?.querySelector(map[action]);
      if (native && !native.disabled) {
        // Legacy controls reannounce selection. This is a panel action, not a
        // new mobile canvas selection; retain its panel and current button.
        panelActionDepth++;
        try { native.click(); } finally { panelActionDepth--; }
      }
      selectedId = itemId;
      if (/^(text|logo|number)-(minus|plus|reset)$/.test(action)) {
        const update = () => syncScaleReadout(panel, itemId);
        requestAnimationFrame(() => {
          update();
          requestAnimationFrame(update);
        });
        setTimeout(update, 90);
      }
      return;
    }
    selectedId = itemId;
    dispatchSelection(itemId);
    if (action !== 'text-font') setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
  }

  function bindPanel(panel) {
    let pointerTarget = null;
    let pointerTime = 0;
    let touchPointerId = null;
    let touchTarget = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;
    let suppressTouchClickUntil = 0;
    const panelControlSelector = [
      '[data-smoof-ui-action]',
      '[data-smoof-ui-panel-close]',
      '[data-smoof-ui-panel-back]',
      '[data-smoof-ui-route-back]',
      'button[data-smoof-ui-layer-action]',
      '[data-smoof-ui-payment-option]',
      '[data-smoof-ui-layer]'
    ].join(', ');

    function finishPercentageStepper(control) {
      const button = control?.closest?.(
        'button[data-smoof-ui-action$="-minus"], button[data-smoof-ui-action$="-plus"]'
      );
      const stepper = button?.closest?.('[data-smoof-ui-stepper]');
      const input = stepper?.querySelector?.('[data-smoof-percent-input]');
      if (!input || document.activeElement !== input) return;
      input.dataset.smoofPercentStepperFinish = 'true';
      input.blur();
      setTimeout(() => {
        if (panel === layers && layersOpen) renderLayers();
        else if (panel === context) renderContext();
      }, 0);
    }

    function runPanelControl(target) {
      const paymentOption = target.closest('[data-smoof-ui-payment-option]');
      if (paymentOption) {
        const payment = paymentOption.querySelector('[data-smoof-ui-payment-provider]');
        if (!payment || payment.disabled) return false;
        payment.checked = !payment.checked;
        payment.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      if (panel === layers && layersPage === 'list') {
        const visibility = target.closest('button[data-smoof-ui-layer-action]');
        if (visibility) {
          toggleVisibility(visibility.dataset.smoofUiLayerAction);
          setTimeout(renderLayers, 70);
          return true;
        }
        const layer = target.closest('[data-smoof-ui-layer]');
        if (layer && layer.dataset.editable === 'true') {
          openLayer(layer.dataset.smoofUiLayer);
          return true;
        }
      }
      if(target.closest('[data-smoof-ui-route-back]')){backPanelRoute();return true;}
      const close = target.closest('[data-smoof-ui-panel-close]');
      if (close) {
        if (panel === layers) setLayersOpen(false); else dispatchSelection('');
        return true;
      }
      if (target.closest('[data-smoof-ui-panel-back]')) {
        layersPage = 'list';
        startLayersTransition('back');
        renderLayers();
        return true;
      }
      const action = target.closest('[data-smoof-ui-action]');
      if (action) {
        handleAction(action.dataset.smoofUiAction, panel);
        return true;
      }
      return false;
    }

    panel.addEventListener('pointerdown', event => {
      const control = event.target.closest(panelControlSelector);

      if (event.pointerType === 'touch') {
        touchPointerId = event.pointerId;
        touchTarget = control;
        touchStartX = event.clientX;
        touchStartY = event.clientY;
        touchMoved = false;
        pointerTarget = null;
        event.stopPropagation();
        return;
      }

      if (control && runPanelControl(control)) {
        pointerTarget = control;
        pointerTime = Date.now();
        event.preventDefault();
      }
      event.stopPropagation();
    });

    panel.addEventListener('pointermove', event => {
      if (event.pointerId !== touchPointerId) return;
      const distance = Math.hypot(
        event.clientX - touchStartX,
        event.clientY - touchStartY
      );
      if (distance > 8) {
        touchMoved = true;
        suppressTouchClickUntil = Date.now() + 450;
      }
      event.stopPropagation();
    });

    panel.addEventListener('pointerup', event => {
      if (event.pointerId !== touchPointerId) return;
      const releaseTarget = event.target.closest(panelControlSelector);
      const sameControl = touchTarget && (
        releaseTarget === touchTarget ||
        touchTarget.contains(releaseTarget) ||
        releaseTarget?.contains(touchTarget)
      );
      const shouldRun = !touchMoved && sameControl;
      const control = touchTarget;

      touchPointerId = null;
      touchTarget = null;
      suppressTouchClickUntil = Date.now() + 450;

      if (shouldRun && runPanelControl(control)) event.preventDefault();
      event.stopPropagation();
    });

    panel.addEventListener('pointercancel', event => {
      if (event.pointerId !== touchPointerId) return;
      touchPointerId = null;
      touchTarget = null;
      touchMoved = true;
      suppressTouchClickUntil = Date.now() + 450;
    });

    panel.addEventListener('click', event => {
      // Keyboard activation already toggles the native checkbox.
      if (event.detail === 0 && event.target.matches('[data-smoof-ui-payment-provider]')) {
        event.stopPropagation();
        return;
      }
      const control = event.target.closest(panelControlSelector);
      if (Date.now() < suppressTouchClickUntil) {
        finishPercentageStepper(control);
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (
        control &&
        control === pointerTarget &&
        Date.now() - pointerTime < 800
      ) {
        finishPercentageStepper(control);
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (control && runPanelControl(control)) {
        finishPercentageStepper(control);
        event.preventDefault();
        event.stopPropagation();
      }
    });
    panel.addEventListener('input', event => {
      const hexInput = event.target.closest('[data-smoof-ui-hex-color]');
      if (hexInput) {
        applyHexColor(hexInput, false, panel);
        return;
      }
      const input = event.target.closest('[data-smoof-ui-color]');
      if (input) applyColor(input.dataset.smoofUiColor, input.value, false, panel);
    });
    panel.addEventListener('change', event => {
      const hexInput = event.target.closest('[data-smoof-ui-hex-color]');
      if (hexInput) {
        applyHexColor(hexInput, true, panel);
        return;
      }
      const customPictogramUpload = event.target.closest('[data-smoof-ui-custom-pictogram-upload]');
      if (customPictogramUpload) {
        const file = customPictogramUpload.files?.[0];
        if (!file) return;
        const status = panel.querySelector('[data-smoof-ui-pictogram-status]');
        const itemId = customPictogramUpload.dataset.smoofUiCustomPictogramUpload;
        const isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
        const isPng = /\.png$/i.test(file.name || '') || file.type === 'image/png';
        const sizeValid = isSvg ? file.size <= 600000 : isPng ? file.size <= 500000 : false;
        if ((!isSvg && !isPng) || !sizeValid) {
          if (status) status.textContent = (!isSvg && !isPng)
            ? t('Bitte eine SVG- oder PNG-Datei auswählen.', 'Please select an SVG or PNG file.')
            : isPng
              ? t('Die PNG-Datei darf maximal 500 KB groß sein.', 'The PNG file may not exceed 500 KB.')
              : t('Die SVG-Datei darf maximal 600 KB groß sein.', 'The SVG file may not exceed 600 KB.');
          customPictogramUpload.value = '';
          return;
        }
        if (status) status.textContent = isPng ? t('PNG wird geprüft …', 'Checking PNG …') : t('SVG wird geprüft …', 'Checking SVG …');
        const readFile = isPng
          ? new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result || ''));
              reader.onerror = reject;
              reader.readAsDataURL(file);
            }).then(dataUrl => new Promise((resolve, reject) => {
              const image = new Image();
              image.onload = () => resolve({ dataUrl, width: image.naturalWidth || image.width, height: image.naturalHeight || image.height });
              image.onerror = reject;
              image.src = dataUrl;
            }))
          : file.text();
        Promise.resolve(readFile).then(fileData => {
          if (isPng && (fileData.width > 1000 || fileData.height > 1000)) {
            if (status) status.textContent = t('Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.', 'The PNG may not exceed 1,000 × 1,000 pixels.');
            return;
          }
          const fileName = file.name.replace(/\.(?:svg|png)$/i, '');
          const applied = isPng
            ? window.SmoofCustomPictogramTools?.setCustomRaster?.(itemId, fileData.dataUrl, fileName, fileData.width, fileData.height)
            : window.SmoofCustomPictogramTools?.setCustomSymbol?.(itemId, fileData, fileName);
          if (!applied) {
            if (status) status.textContent = t('Diese Datei konnte nicht als Piktogramm verwendet werden.', 'This file could not be used as a pictogram.');
            return;
          }
          pictogramPickerCategory[itemId] = 'custom';
          pictogramPickerOpenFor = '';
          selectedId = itemId;
          scheduleHistoryCapture(120);
          setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
        }).catch(() => {
          if (status) status.textContent = t('Die Datei konnte nicht gelesen werden.', 'The file could not be read.');
        }).finally(() => { customPictogramUpload.value = ''; });
        return;
      }
      const pictogramUpload = event.target.closest('[data-smoof-ui-pictogram-upload]');
      if (pictogramUpload) {
        const file = pictogramUpload.files?.[0];
        if (!file) return;
        const status = panel.querySelector('[data-smoof-ui-pictogram-status]');
        const side = pictogramUpload.dataset.smoofUiPictogramUpload === 'right' ? 'right' : 'left';
        const isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
        const isPng = /\.png$/i.test(file.name || '') || file.type === 'image/png';
        const sizeValid = isSvg ? file.size <= 600000 : isPng ? file.size <= 500000 : false;
        if ((!isSvg && !isPng) || !sizeValid) {
          if (status) status.textContent = (!isSvg && !isPng)
            ? t('Bitte eine SVG- oder PNG-Datei auswählen.', 'Please select an SVG or PNG file.')
            : isPng
              ? t('Die PNG-Datei darf maximal 500 KB groß sein.', 'The PNG file may not exceed 500 KB.')
              : t('Die SVG-Datei darf maximal 600 KB groß sein.', 'The SVG file may not exceed 600 KB.');
          pictogramUpload.value = '';
          return;
        }
        if (status) status.textContent = isPng
          ? t('PNG wird geprüft …', 'Checking PNG …')
          : t('SVG wird geprüft …', 'Checking SVG …');
        const readFile = isPng
          ? new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result || ''));
              reader.onerror = reject;
              reader.readAsDataURL(file);
            }).then(dataUrl => new Promise((resolve, reject) => {
              const image = new Image();
              image.onload = () => resolve({
                dataUrl,
                width: image.naturalWidth || image.width,
                height: image.naturalHeight || image.height
              });
              image.onerror = reject;
              image.src = dataUrl;
            }))
          : (typeof file.text === 'function'
              ? file.text()
              : new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(String(reader.result || ''));
                  reader.onerror = reject;
                  reader.readAsText(file);
                }));
        Promise.resolve(readFile).then(fileData => {
          if (isPng && (fileData.width > 1000 || fileData.height > 1000)) {
            if (status) status.textContent = t(
              'Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.',
              'The PNG may not exceed 1,000 × 1,000 pixels.'
            );
            return;
          }
          const fileName = file.name.replace(/\.(?:svg|png)$/i, '');
          const applied = isPng
            ? window.SmoofArrowTools?.setCustomRaster?.(
                side,
                fileData.dataUrl,
                fileName,
                fileData.width,
                fileData.height
              )
            : window.SmoofArrowTools?.setCustomSymbol?.(side, fileData, fileName);
          if (!applied) {
            if (status) status.textContent = t(
              'Diese Datei konnte nicht als Piktogramm verwendet werden.',
              'This file could not be used as a pictogram.'
            );
            return;
          }
          pictogramPickerCategory[side] = 'custom';
          pictogramPickerOpenFor = '';
          selectedId = `arrow-${side}`;
          scheduleHistoryCapture(120);
          setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
        }).catch(() => {
          if (status) status.textContent = t('Die Datei konnte nicht gelesen werden.', 'The file could not be read.');
        }).finally(() => { pictogramUpload.value = ''; });
        return;
      }
      const payment = event.target.closest('[data-smoof-ui-payment-provider]');
      if (payment) {
        window.SmoofPaymentTools?.setProvider?.(
          payment.dataset.smoofUiPaymentProvider,
          payment.checked
        );
        selectedId = 'payments';
        scheduleHistoryCapture(80);
      }
      const socialPlatform = event.target.closest('[data-smoof-ui-social-platform]');
      if (socialPlatform) {
        const id = socialPlatform.dataset.smoofUiSocialPlatform;
        window.SmoofSocialPlatformTools?.setEnabled?.(id, socialPlatform.checked);
        selectedId = 'social-library';
        scheduleHistoryCapture(80);
        dispatchSelection('social-library', { openContext: true });
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      }
      const select = event.target.closest('[data-smoof-ui-select]');
      if (select) applySelect(select.dataset.smoofUiSelect, select.value, panel);
      const input = event.target.closest('[data-smoof-ui-color]');
      if (input) applyColor(input.dataset.smoofUiColor, input.value, true, panel);
    });
  }

  function setLayersOpen(open) {
    layersOpen = Boolean(open);
    if (layersOpen) {
      closeLegacyHelp();
      closeLegacyReset();
      layersPage = 'list';
      delete layers.dataset.smoofUiTransition;
      context.dataset.open = 'false';
      layers.dataset.open = 'true';
      renderLayers();
    } else {
      layers.dataset.open = 'false';
      layersPage = 'list';
    }
    syncCommandbar();
  }

  function togglePaymentsShortcut() {
    if (!personalizedDesignSelected() || !window.SmoofPaymentTools) return;
    const shouldOpen = !(selectedId === 'payments' && context?.dataset.open === 'true');

    if (layersOpen) setLayersOpen(false);
    closeLegacyHelp();
    closeLegacyReset();

    if (!shouldOpen) {
      selectedId = '';
      source = null;
      if (context) context.dataset.open = 'false';
      dispatchSelection('');
      syncCommandbar();
      return;
    }

    selectedId = 'payments';
    source = sourceFor('payments');
    renderContext();
    dispatchSelection('payments', { openContext: true });
    syncCommandbar();

    requestAnimationFrame(() => {
      if (selectedId !== 'payments' || layersOpen) return;
      source = sourceFor('payments');
      renderContext();
      syncCommandbar();
    });
  }

  function toggleAddShortcut() {
    if (!personalizedDesignSelected()) return;
    const shouldOpen = !(selectedId === 'add' && context?.dataset.open === 'true');

    if (layersOpen) setLayersOpen(false);
    closeLegacyHelp();
    closeLegacyReset();

    if (!shouldOpen) {
      selectedId = '';
      source = null;
      if (context) context.dataset.open = 'false';
      dispatchSelection('');
      syncCommandbar();
      return;
    }

    dispatchSelection('');
    selectedId = 'add';
    source = commandbar;
    renderContext();
    syncCommandbar();
  }

  function openLayer(id) {
    panelRouteStack=[];
    if (id === 'table-number' && !visibleItemFor(id)) {
      const toggle = document.querySelector('[data-smoof-number-toggle]');
      if (toggle && !toggle.hidden) toggle.click();
    }
    layersPage = 'detail';
    selectedId = id;
    suppressSelectionRenderId = id;
    suppressSelectionRenderUntil = Date.now() + 500;
    startLayersTransition('forward');
    renderLayers();
    dispatchSelection(id);
  }

  function startLayersTransition(direction) {
    if (!layers) return;
    clearTimeout(layersTransitionTimer);
    layers.dataset.smoofUiTransition = direction;
    layersTransitionTimer = setTimeout(() => {
      if (layers) delete layers.dataset.smoofUiTransition;
    }, mobile.matches ? 570 : 480);
  }

  function templateCoachmarkWasSeen() {
    if (templateCoachmarkAcknowledged) return true;
    try {
      return window.localStorage.getItem(TEMPLATE_COACHMARK_KEY) === 'seen';
    } catch (_error) {
      return false;
    }
  }

  function rememberTemplateCoachmark() {
    templateCoachmarkAcknowledged = true;
    try {
      window.localStorage.setItem(TEMPLATE_COACHMARK_KEY, 'seen');
    } catch (_error) {
      // The current page still stays dismissed when storage is unavailable.
    }
  }

  function positionTemplateCoachmark() {
    if (!templateCoachmark || templateCoachmark.hidden || !commandbar) return;
    const button = commandbar.querySelector('[data-smoof-ui-command-action="templates"]');
    if (!button) return;
    const anchor = button.getBoundingClientRect();
    const panel = templateCoachmark.getBoundingClientRect();
    const edge = 12;
    const gap = 13;
    const width = panel.width || 292;
    const height = panel.height || 230;
    const idealLeft = anchor.left + (anchor.width / 2) - (width / 2);
    const left = Math.max(edge, Math.min(idealLeft, window.innerWidth - width - edge));
    const fitsBelow = anchor.bottom + gap + height <= window.innerHeight - edge;
    const top = fitsBelow
      ? anchor.bottom + gap
      : Math.max(edge, anchor.top - height - gap);
    templateCoachmark.style.left = `${Math.round(left)}px`;
    templateCoachmark.style.top = `${Math.round(top)}px`;
    templateCoachmark.style.setProperty('--smoof-template-coachmark-arrow-x', `${Math.round(anchor.left + (anchor.width / 2) - left)}px`);
    templateCoachmark.dataset.placement = fitsBelow ? 'below' : 'above';
  }

  function dismissTemplateCoachmark(markSeen = true) {
    clearTimeout(templateCoachmarkTimer);
    templateCoachmarkTimer = 0;
    if (markSeen) rememberTemplateCoachmark();
    if (!templateCoachmark) return;
    templateCoachmark.dataset.open = 'false';
    templateCoachmark.hidden = true;
  }

  function ensureTemplateCoachmark() {
    if (templateCoachmark?.isConnected) return templateCoachmark;
    templateCoachmark = document.createElement('aside');
    templateCoachmark.dataset.smoofUiTemplateCoachmark = 'true';
    templateCoachmark.dataset.smoofEditorItem = 'modern-ui-control';
    templateCoachmark.dataset.open = 'false';
    templateCoachmark.hidden = true;
    templateCoachmark.setAttribute('role', 'dialog');
    templateCoachmark.setAttribute('aria-modal', 'false');
    templateCoachmark.setAttribute('aria-labelledby', 'smoof-template-coachmark-title');
    templateCoachmark.innerHTML = `<button type="button" data-smoof-ui-template-coachmark-close aria-label="${t('Hinweis schließen', 'Close hint')}">${icon('close')}</button><div data-smoof-ui-template-coachmark-preview aria-hidden="true"><span>${t('Order & Pay', 'Order & Pay')}</span><span>${t('Speisekarte', 'Menu')}</span><span>${t('Gästemappe', 'Guest directory')}</span></div><div data-smoof-ui-template-coachmark-body><span data-smoof-ui-template-coachmark-symbol>${icon('templates')}</span><div><strong id="smoof-template-coachmark-title">${t('Mit Vorlagen schneller starten', 'Start faster with templates')}</strong><p>${t('Wählen Sie ein vorbereitetes Design und passen Sie es direkt an Ihr Branding an.', 'Choose a prepared design and adapt it directly to your branding.')}</p></div><button type="button" data-smoof-ui-template-coachmark-open>${t('Vorlagen entdecken', 'Explore templates')}<span aria-hidden="true">→</span></button></div>`;
    templateCoachmark.addEventListener('pointerdown', event => event.stopPropagation());
    templateCoachmark.addEventListener('click', event => {
      if (event.target.closest('[data-smoof-ui-template-coachmark-close]')) {
        dismissTemplateCoachmark(true);
        return;
      }
      if (!event.target.closest('[data-smoof-ui-template-coachmark-open]')) return;
      dismissTemplateCoachmark(true);
      commandbar?.querySelector('[data-smoof-ui-command-action="templates"]')?.click();
    });
    document.body.append(templateCoachmark);
    return templateCoachmark;
  }

  function scheduleTemplateCoachmark() {
    if (
      templateCoachmarkTimer ||
      templateCoachmark?.dataset.open === 'true' ||
      templateCoachmarkWasSeen() ||
      !personalizedDesignSelected()
    ) return;
    templateCoachmarkTimer = window.setTimeout(() => {
      templateCoachmarkTimer = 0;
      if (templateCoachmarkWasSeen() || !personalizedDesignSelected()) return;
      const panel = ensureTemplateCoachmark();
      panel.hidden = false;
      panel.dataset.open = 'true';
      requestAnimationFrame(positionTemplateCoachmark);
    }, 900);
  }

  function ensureShell() {
    if (commandbar && commandbar.isConnected) return;
    commandbar = document.createElement('nav');
    commandbar.dataset.smoofUiCommandbar = 'true';
    commandbar.dataset.smoofEditorItem = 'modern-ui-control';
    commandbar.innerHTML = `<button type="button" data-smoof-ui-command-action="templates" aria-label="${t('Vorlagen', 'Templates')}" title="${t('Vorlagen', 'Templates')}" aria-expanded="false">${icon('templates')}</button><button type="button" data-smoof-ui-command-action="layers" aria-label="${t('Ebenen', 'Layers')}" title="${t('Ebenen', 'Layers')}" aria-expanded="false">${icon('layers')}</button><button type="button" data-smoof-ui-command-action="add" aria-label="${t('Hinzufügen', 'Add')}" title="${t('Hinzufügen', 'Add')}" aria-expanded="false">${icon('add')}</button><button type="button" data-smoof-ui-command-action="save-design" aria-label="${t('Uploads & Downloads', 'Uploads & Downloads')}" title="${t('Uploads & Downloads', 'Uploads & Downloads')}" aria-expanded="false">${icon('save')}</button><button type="button" data-smoof-ui-command-action="undo" aria-label="${t('Rückgängig', 'Undo')}" title="${t('Rückgängig', 'Undo')}">${icon('undo')}</button><button type="button" data-smoof-ui-command-action="redo" aria-label="${t('Wiederholen', 'Redo')}" title="${t('Wiederholen', 'Redo')}">${icon('redo')}</button><button type="button" data-smoof-ui-command-action="guides" aria-label="${t('Bemaßung & Ausrichtung', 'Measurements & alignment')}" title="${t('Bemaßung & Ausrichtung', 'Measurements & alignment')}">${icon('ruler')}</button><button type="button" data-smoof-ui-command-action="reset" aria-label="${t('Design zurücksetzen', 'Reset design')}" title="${t('Design zurücksetzen', 'Reset design')}">${icon('reset')}</button><button type="button" data-smoof-ui-command-action="help" aria-label="${t('Hilfe', 'Help')}" title="${t('Hilfe', 'Help')}">${icon('help')}</button>`;
    context = document.createElement('section');
    context.dataset.smoofUiContext = 'true';
    context.dataset.smoofEditorItem = 'modern-ui-control';
    context.dataset.open = 'false';
    layers = document.createElement('aside');
    layers.dataset.smoofUiLayers = 'true';
    layers.dataset.smoofEditorItem = 'modern-ui-control';
    layers.dataset.open = 'false';
    document.body.append(commandbar, context, layers);
    root.dataset.smoofUiShellReady = 'true';
    bindPanel(context);
    bindPanel(layers);

    commandbar.addEventListener('pointerdown', event => {
      event.stopPropagation();
    });
    commandbar.addEventListener('pointerup', event => {
      const addButton = event.target.closest('[data-smoof-ui-command-action="add"]');
      if (!addButton || (event.button !== undefined && event.button !== 0)) return;
      addShortcutPointerHandledUntil = Date.now() + 700;
      event.preventDefault();
      event.stopPropagation();
      toggleAddShortcut();
    });
    commandbar.addEventListener('click', event => {
      const button = event.target.closest('[data-smoof-ui-command-action]');
      if (!button) return;
      const action = button.dataset.smoofUiCommandAction;
      if (action === 'guides') {
        const shouldOpen = selectedId !== 'guides' || context?.dataset.open !== 'true';
        closeLegacyHelp(); closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        dispatchSelection(shouldOpen ? 'guides' : '', { openContext: shouldOpen });
        if (shouldOpen) {
          renderContext();
          context.querySelector('[role="switch"]')?.focus({ preventScroll: true });
        }
        syncCommandbar();
        return;
      }
      if (action === 'layers') { setLayersOpen(!layersOpen); return; }
      if (action === 'templates') {
        dismissTemplateCoachmark(true);
        const shouldOpen = selectedId !== 'templates' || context?.dataset.open !== 'true';
        closeLegacyHelp();
        closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        if (shouldOpen) {
          selectedId = 'templates';
          source = commandbar;
          renderContext();
        } else {
          dispatchSelection('');
        }
        syncCommandbar();
        return;
      }
      if (action === 'save-design') {
        const shouldOpen = selectedId !== 'downloads' || context?.dataset.open !== 'true';
        closeLegacyHelp();
        closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        if (shouldOpen) {
          selectedId = 'downloads';
          source = commandbar;
          renderContext();
        } else {
          dispatchSelection('');
        }
        syncCommandbar();
        return;
      }
      if (action === 'add') {
        if (Date.now() < addShortcutPointerHandledUntil) return;
        toggleAddShortcut();
        return;
      }
      if (action === 'undo') { undoHistory(); return; }
      if (action === 'redo') { redoHistory(); return; }
      if (action === 'help') {
        const shouldOpen = !helpWasOpenOnPointerDown;
        helpWasOpenOnPointerDown = false;
        if (shouldOpen) openLegacyHelp();
        else closeLegacyHelp();
        syncCommandbar();
        return;
      }
      if (action === 'reset') {
        const shouldOpen = !resetWasOpenOnPointerDown;
        resetWasOpenOnPointerDown = false;
        if (shouldOpen) openLegacyReset();
        else closeLegacyReset();
        syncCommandbar();
        return;
      }
      const selectors = { guides: '[data-smoof-guide-visibility-button]' };
      const native = document.querySelector(selectors[action]);
      if (native) native.click();
      setTimeout(() => {
        syncCommandbar();
        if (action === 'help') positionLegacyPopover(action);
      }, 80);
      helpWasOpenOnPointerDown = false;
      resetWasOpenOnPointerDown = false;
    });

    syncCommandbar();
  }

  window.addEventListener(SELECT_EVENT, event => {
    const nextId=String(event.detail && event.detail.id ? event.detail.id : '');
    if (panelActionDepth && nextId === selectedId && context?.dataset.open === 'true' && !layersOpen) return;
    if(!routingPanel&&nextId!==selectedId&&nextId!==panelRouteStack.at(-1)?.to)panelRouteStack=[];
    selectedId = nextId;
    if (
      mobile.matches &&
      !layersOpen &&
      event.detail?.openContext !== true
    ) {
      source = selectedId ? sourceFor(selectedId) : null;
      if (context) context.dataset.open = 'false';
      syncCommandbar();
      return;
    }
    if (
      selectedId === suppressSelectionRenderId &&
      Date.now() < suppressSelectionRenderUntil
    ) {
      return;
    }
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
      syncCommandbar();
    }, 0);
  });

  window.addEventListener('smoof:font-styles-ready', () => {
    setTimeout(() => { if (layersOpen && layersPage === 'detail') renderLayers(); else renderContext(); }, 0);
  });

  window.addEventListener('smoof:background-image-changed', () => {
    if (selectedId !== 'background') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:qr-geometry-change', () => {
    if (selectedId !== 'qr') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:custom-pictogram-change', () => {
    if (!/^custom-pictogram-[1-3]$/.test(selectedId) && !layersOpen && selectedId !== 'add') return;
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:template-library-changed', () => {
    if (selectedId !== 'templates' || context?.dataset.open !== 'true') return;
    setTimeout(() => {
      renderContext();
      syncCommandbar();
    }, 0);
  });

  window.addEventListener('smoof:logo-crop-applied', () => scheduleHistoryCapture(350));
  window.addEventListener('smoof:logo-crop-ready', () => { if (selectedId === 'logo') renderContext(); });
  window.addEventListener('smoof:logo-file-changed', () => {
    if (selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-copy-ready', () => {
    if (selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-2-file-changed', () => {
    if (selectedId !== 'logo-2' && selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-colour-changed', event => {
    if (event.detail?.commit !== false) scheduleHistoryCapture(180);
  });

  ['smoof:logo-copy-changed', 'smoof:logo-background-changed', 'smoof:logo-colour-ready'].forEach(eventName => {
    window.addEventListener(eventName, () => {
      if (!['logo', 'logo-copy', 'logo-2'].includes(selectedId)) return;
      setTimeout(() => {
        if (layersOpen && layersPage === 'detail') renderLayers();
        else renderContext();
      }, 0);
    });
  });

  window.addEventListener('smoof:editor-reset-content', () => {
    ['left', 'right'].forEach(side => {
      if (window.SmoofArrowTools?.isVisible?.(side) === false) {
        window.SmoofArrowTools?.toggleVisibility?.(side);
      }
    });
  });

  window.addEventListener('pointerdown', event => {
    const target = event.target instanceof Element ? event.target : null;
    const layersToggle = target?.closest('[data-smoof-ui-command-action="layers"]');
    const insideLayers = target?.closest('[data-smoof-ui-layers]');
    const canvasItem = target?.closest('[data-smoof-editor-item]');
    if (layersOpen && !layersToggle && !insideLayers && !canvasItem) setLayersOpen(false);

    const resetToggle = target?.closest('[data-smoof-ui-command-action="reset"], [data-smoof-reset-button]');
    const insideReset = target?.closest('[data-smoof-reset-menu]');
    if (legacyPanelOpen('reset') && !resetToggle && !insideReset) closeLegacyReset();

    if (target?.closest('[data-smoof-ui-command-action="help"]')) {
      helpWasOpenOnPointerDown = legacyPanelOpen('help');
    } else if (target?.closest('[data-smoof-ui-command-action="reset"]')) {
      resetWasOpenOnPointerDown = legacyPanelOpen('reset');
    } else if (legacyPanelOpen('help')) {
      setTimeout(syncCommandbar, 0);
    } else if (legacyPanelOpen('reset')) {
      setTimeout(syncCommandbar, 0);
    }
  }, true);

  document.addEventListener('pointerdown', event => {
    const target = event.target instanceof Element ? event.target : null;
    const editorItem = target?.closest('[data-smoof-editor-item]');
    const itemId = editorItem?.dataset.smoofEditorItem || '';
    const closestButton = target?.closest('button');
    const directControl = target?.closest('input, select, textarea, [data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-commandbar]') ||
      (closestButton && closestButton !== editorItem);
    if (
      mobile.matches &&
      itemId &&
      descriptors()[itemId] &&
      !directControl
    ) {
      mobileCanvasPointer = {
        pointerId: event.pointerId,
        itemId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false,
        wasSelected: selectedId === itemId,
        contextWasOpen: context?.dataset.open === 'true'
      };
      if (context) context.dataset.open = 'false';
    }
    const descriptor = itemId ? descriptors()[itemId] : null;
    const nestedControl = target?.closest([
      'input',
      'select',
      'textarea',
      '[data-smoof-text-controls]',
      '[data-smoof-logo-controls]',
      '[data-smoof-logo-copy-controls]',
      '[data-smoof-logo-duplicate-controls]',
      '[data-smoof-arrow-controls]',
      '[data-smoof-number-controls]',
      '[data-smoof-brand-controls]',
      '[data-smoof-ui-context]',
      '[data-smoof-ui-layers]',
      '[data-smoof-ui-commandbar]'
    ].join(','));
    const button = target?.closest('button');
    const canvasButton = button && button === editorItem;
    if (editorItem && descriptor && !descriptor.locked && !nestedControl && (!button || canvasButton)) {
      root.dataset.smoofUiDragging = 'true';
    }
  }, true);

  window.addEventListener('pointermove', event => {
    if (!mobileCanvasPointer || mobileCanvasPointer.pointerId !== event.pointerId) return;
    if (Math.hypot(
      event.clientX - mobileCanvasPointer.startX,
      event.clientY - mobileCanvasPointer.startY
    ) > 7) {
      mobileCanvasPointer.moved = true;
    }
  }, true);

  function finishMobileCanvasPointer(event, cancelled = false) {
    if (!mobileCanvasPointer || mobileCanvasPointer.pointerId !== event.pointerId) return;
    const interaction = mobileCanvasPointer;
    mobileCanvasPointer = null;
    if (cancelled || !interaction.wasSelected) return;
    setTimeout(() => {
      if (
        mobile.matches &&
        !layersOpen &&
        selectedId === interaction.itemId &&
        (!interaction.moved || interaction.contextWasOpen)
      ) {
        renderContext();
        syncCommandbar();
      }
    }, 0);
  }

  window.addEventListener('pointerup', event => finishMobileCanvasPointer(event), true);
  window.addEventListener('pointercancel', event => finishMobileCanvasPointer(event, true), true);

  const finishUiDrag = () => {
    root.removeAttribute('data-smoof-ui-dragging');
    scheduleHistoryCapture(180);
  };
  window.addEventListener('pointerup', finishUiDrag, true);
  window.addEventListener('pointercancel', finishUiDrag, true);
  window.addEventListener('blur', () => {
    mobileCanvasPointer = null;
    finishUiDrag();
  });

  window.addEventListener('resize', () => { positionCommandbar(); positionContext(); positionLayers(); positionLegacyPopover('help'); positionLegacyPopover('reset'); positionTemplateCoachmark(); });
  window.addEventListener('scroll', () => { positionCommandbar(); positionContext(); positionLayers(); positionLegacyPopover('help'); positionLegacyPopover('reset'); positionTemplateCoachmark(); }, true);
  window.addEventListener('smoof:product-variant-change', () => {
    if (layersOpen) renderLayers();
    else if (selectedId) renderContext();
    syncCommandbar();
  });

  let frame = 0;
  function reconcile() {
    frame = 0;
    ensureShell();
    syncPersonalizationGate();
    syncCommandbar();
    positionContext();positionLayers();
    if (selectedId && source && !source.isConnected) {
      source = sourceFor(selectedId);
      const visibilityTransition =
        selectedId === suppressSelectionRenderId &&
        Date.now() < suppressSelectionRenderUntil;
      if (!visibilityTransition) {
        if (layersOpen && layersPage === 'detail') renderLayers(); else renderContext();
      }
    }
  }
  const observer = new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(reconcile);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const fontPickerCloseObserver = new MutationObserver(records => {
    // Closed panels must never leave a detached decorative anchor behind.
    for (const record of records) {
      if ((record.target === context || record.target === layers) && record.target.dataset.open !== 'true') {
        const tip = panelAnchors.get(record.target);
        if (tip) tip.hidden = true;
        delete record.target.dataset.smoofUnifiedSkin;
      }
    }
    if(panelSubview?.kind==='font'&&!document.querySelector('.smoof-font-backdrop[data-open="true"]'))leavePanelSubview(false);
    if (!fontPickerTarget) return;
    const pickerClosed = records.some(record =>
      record.target instanceof Element &&
      record.target.matches('.smoof-font-backdrop') &&
      record.target.dataset.open === 'false'
    );
    if (!pickerClosed) return;
    setTimeout(() => {
      if (!fontPickerTarget) return;
      if (document.querySelector('.smoof-font-backdrop[data-open="true"]')) return;
      resetFontPickerState();
    }, 0);
  });
  fontPickerCloseObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-open'],
    subtree: true
  });
  function detectFontSelection(event) {
    if (!fontPickerTarget) return;
    const changed = event?.target instanceof Element ? event.target : null;
    const fontOption = optionRoot(FONT_OPTION_ID);
    if (changed && fontOption && !fontOption.contains(changed)) return;
    const family = selectedGoogleFont();
    if (!family) return;
    const explicitSelection = Boolean(changed?.matches?.('select, input[type="hidden"]'));
    if (family !== fontPickerInitialFamily || explicitSelection) finishFontSelection(family);
  }

  let richSelectionTimer=0;
  window.addEventListener('smoof:rich-selection',()=>{
    clearTimeout(richSelectionTimer);
    richSelectionTimer=setTimeout(()=>{if(!panelSubview){if(layersOpen)renderLayers();else renderContext();}scheduleHistoryCapture(80);},120);
  });
  window.addEventListener('smoof:font-selected', event => {
    if (!fontPickerTarget) return;
    const family = cleanFontFamily(event.detail?.font);
    if (family) finishFontSelection(family);
  });

  window.setInterval(() => {
    if (!fontPickerTarget) return;
    const family = selectedGoogleFont();
    if (family && family !== fontPickerInitialFamily) finishFontSelection(family);
  }, 180);

  // Movement is dispatched to the owning component, never to CSS or history restore.
  function movementFor(id) {
    if (/^text-[0-2]$/.test(id)) return [window.SmoofTextTools, Number(id.split('-')[1])];
    if (/^arrow-(left|right)$/.test(id)) return [window.SmoofArrowTools, id.split('-')[1]];
    if (/^custom-text-[1-3]$/.test(id)) return [window.SmoofCustomTextTools, id];
    if (/^custom-pictogram-[1-3]$/.test(id)) return [window.SmoofCustomPictogramTools, id];
    if (/^social-platform-/.test(id)) return [window.SmoofSocialPlatformTools, id];
    return [{
      logo: window.SmoofLogoHistory, 'logo-copy': window.SmoofLogoCopyTools,
      'logo-2': window.SmoofLogoDuplicateTools, 'table-number': window.SmoofNumberHistory,
      'branding-dot': window.SmoofBrandTools, qr: window.SmoofQrGeometryTools,
      nfc: window.SmoofNfcTools, payments: window.SmoofPaymentTools
    }[id]];
  }
  function finishKeyboardMove() {
    heldArrows.clear();
    if (!keyboardMove) return;
    keyboardMove = false;
    // Include dependent constraint/render updates in the same Undo entry.
    scheduleHistoryCapture(320);
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && selectedId === 'guides') {
      event.preventDefault();
      dispatchSelection('');
      context.dataset.open = 'false'; syncCommandbar();
      commandbar?.querySelector('[data-smoof-ui-command-action="guides"]')?.focus();
      return;
    }
    const directions = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
    const direction = directions[event.key];
    if (!direction) return;
    const target = event.target instanceof Element ? event.target : null;
    const blocked = event.defaultPrevented || event.isComposing || event.altKey || event.ctrlKey || event.metaKey ||
      heldPointers.size > 0 || historyRestoring || !personalizedDesignSelected() || fontPickerTarget ||
      root.hasAttribute('data-smoof-font-picker-active') || root.dataset.smoofEditorTourOpen === 'true' ||
      root.hasAttribute('data-smoof-surface-session') || root.hasAttribute('data-smoof-surface-external-apply') ||
      root.dataset.smoofUiDragging === 'true' || root.dataset.smoofQhsMode === 'three-quarter' ||
      target?.isContentEditable || target?.closest('input, textarea, select, button, [contenteditable="true"], [role="textbox"], [role="slider"], [role="spinbutton"], [role="combobox"]') ||
      [...document.querySelectorAll('dialog[open], [role="dialog"][open], [aria-modal="true"]')].some(el => {
        if (!el.getClientRects().length) return false;
        for (let node = el; node instanceof Element; node = node.parentElement) {
          const css = getComputedStyle(node);
          if (node.hidden || node.getAttribute('aria-hidden') === 'true' || css.display === 'none' || css.visibility === 'hidden' || css.opacity === '0') return false;
        }
        return true;
      });
    const [owner, argument] = movementFor(selectedId);
    if (blocked || !owner?.nudge || !isVisible(selectedId) || !visibleItemFor(selectedId)) {
      finishKeyboardMove(); return;
    }
    if (!keyboardMove) {
      clearTimeout(historyTimer); clearTimeout(historyBaselineTimer);
      commitHistorySnapshot(); keyboardMove = true;
    }
    const step = event.shiftKey ? 0.01 : 0.001;
    const args = [direction[0] * step, direction[1] * step];
    if (argument !== undefined) args.unshift(argument);
    if (owner.nudge(...args) === false) { finishKeyboardMove(); return; }
    heldArrows.add(event.key);
    window.SmoofAlignmentGuides?.hideAll?.();
    event.preventDefault(); event.stopPropagation();
  });
  document.addEventListener('keyup', event => {
    heldArrows.delete(event.key);
    if (!heldArrows.size) finishKeyboardMove();
  });
  window.addEventListener('blur', () => { heldPointers.clear(); finishKeyboardMove(); });
  document.addEventListener('pointerdown', event => { heldPointers.add(event.pointerId); finishKeyboardMove(); }, true);
  window.addEventListener('pointerup', event => heldPointers.delete(event.pointerId), true);
  window.addEventListener('pointercancel', event => heldPointers.delete(event.pointerId), true);
  document.addEventListener('focusin', finishKeyboardMove);
  window.addEventListener(SELECT_EVENT, finishKeyboardMove);
  window.addEventListener('smoof:surface-change', () => {
    // SurfaceController already captured the old side and reset the history.
    keyboardMove = false; heldArrows.clear();
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !fontPickerTarget) return;
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    setTimeout(() => layersOpen ? renderLayers() : renderContext(), 0);
  }, true);

  document.addEventListener('input', event => {
    detectFontSelection(event);
    scheduleHistoryCapture(380);
  }, true);
  document.addEventListener('change', event => {
    const changed = event.target instanceof Element ? event.target : null;
    detectFontSelection(event);
    scheduleHistoryCapture(320);
    if (changed?.matches('input[type="file"]')) scheduleHistoryCapture(1400);
    setTimeout(() => {
      syncPersonalizationGate();
      syncCommandbar();
    }, 40);
  }, true);
  document.addEventListener('click', () => scheduleHistoryCapture(260), true);

  function tourAnchor(name) {
    const command = action => commandbar?.querySelector(`[data-smoof-ui-command-action="${action}"]`) || null;
    const anchors = {
      workspace: () => commandbarAnchor(),
      text: () => context?.dataset.open === 'true' ? context : null,
      fonts: () => context?.dataset.open === 'true' ? context.querySelector('[data-smoof-ui-font-button]') : null,
      logos: () => context?.dataset.open === 'true' ? context : null,
      alignment: () => command('guides'),
      templates: () => context?.dataset.open === 'true' && selectedId === 'templates' ? context : command('templates'),
      layers: () => layers?.dataset.open === 'true' ? layers : command('layers'),
      add: () => context?.dataset.open === 'true' && selectedId === 'add' ? context : command('add'),
      downloads: () => context?.dataset.open === 'true' && selectedId === 'downloads' ? context : command('save-design'),
      safety: () => commandbar,
      surfaces: () => document.querySelector('[data-smoof-surface-switcher]:not([data-smoof-single-surface-presentation])'),
      views: () => document.querySelector('[data-smoof-qhs-3d-toggle]'),
      help: () => command('help')
    };
    return anchors[name]?.() || null;
  }

  function captureTourUi() {
    return {
      selectedId,
      layersOpen,
      layersPage,
      contextOpen: context?.dataset.open === 'true',
      helpOpen: legacyPanelOpen('help'),
      resetOpen: legacyPanelOpen('reset'),
      focus: document.activeElement instanceof HTMLElement ? document.activeElement : null
    };
  }

  function closeTourPanels() {
    closeLegacyHelp();
    closeLegacyReset();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';
  }

  function prepareTourStep(name) {
    if (!personalizedDesignSelected()) return false;
    dismissTemplateCoachmark(true);
    closeTourPanels();

    if (name === 'text' || name === 'fonts' || name === 'logos') {
      // Open real settings without input/change events, font freezing or uploads.
      const map = descriptors();
      const textId = Object.keys(map).find(id =>
        (map[id].kind === 'text' || map[id].kind === 'custom-text') && visibleItemFor(id)
      ) || 'text-0';
      selectedId = name === 'logos' ? 'logo' : textId;
      source = sourceFor(selectedId);
      renderContext();
      positionContext();
    } else if (name === 'templates' || name === 'add' || name === 'downloads') {
      selectedId = name;
      source = commandbar;
      renderContext();
    } else if (name === 'layers') {
      setLayersOpen(true);
    }

    syncCommandbar();
    return true;
  }

  function restoreTourUi(snapshot) {
    closeTourPanels();
    if (!snapshot || !personalizedDesignSelected()) {
      syncCommandbar();
      return;
    }

    selectedId = String(snapshot.selectedId || '');
    layersPage = snapshot.layersPage === 'detail' ? 'detail' : 'list';
    source = selectedId ? sourceFor(selectedId) : null;

    if (snapshot.layersOpen) {
      layersOpen = true;
      layers.dataset.open = 'true';
      renderLayers();
    } else if (snapshot.contextOpen && selectedId) {
      renderContext();
    }

    if (snapshot.helpOpen) openLegacyHelp();
    else if (snapshot.resetOpen) openLegacyReset();
    syncCommandbar();
  }

  window.SmoofEditorTourBridge = Object.freeze({
    version: '1.0.0',
    enabled: personalizedDesignSelected,
    captureUi: captureTourUi,
    restoreUi: restoreTourUi,
    prepareStep: prepareTourStep,
    resolveAnchor: tourAnchor,
    closePanels: closeTourPanels,
    surfaceCount: () => Number(profile?.surfaceCount || root.dataset.smoofSurfaceCount || 1),
    hasThreeQuarter: () => Boolean(profile?.scene?.presentation?.views?.includes?.('threeQuarter') || tourAnchor('views'))
  });
  window.dispatchEvent(new CustomEvent('smoof:editor-tour-bridge-ready'));

  /*
   * Versionierte Zustandsgrenze fuer Produkte mit mehreren Druckflaechen.
   * Die einzelnen Editormodule bleiben Singletons; ein Surface-Controller
   * speichert und aktiviert genau einen vollstaendigen Snapshot zur Zeit.
   */
  window.SmoofEditorState = Object.freeze({
    version: '1.0.0',
    capture: captureHistorySnapshot,
    apply: applyHistorySnapshot,
    resetHistory() {
      clearHistory();
      historyBaselineTimer = setTimeout(() => {
        historyBaselineTimer = 0;
        commitHistorySnapshot();
      }, 320);
    },
    deselect() {
      window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: '' } }));
    }
  });

  ensureShell();
  syncPersonalizationGate();
  if (personalizedDesignSelected() && !historyCurrent) {
    historyBaselineTimer = setTimeout(() => {
      historyBaselineTimer = 0;
      commitHistorySnapshot();
    }, 420);
  }
  window.addEventListener('smoof:brand-policy-change', () => { if (selectedId) renderContext(); });
})();
